window.product
let visual, prodTemplate, namespace = 'tombalding-assets', name = '3-in-1', isProductLoading = true, LoadProduct, LoadProductsplit;
let modalElement = document.getElementById('dopple-canvas-wrapper');
let LoadCIProduct = "",LoadChainpiece = "",LoadMouthpiece = "",LoadFancyshank = "",LoadPlainshank = "",LoadColorshank = "",LoadOvarlayshank = "",DataPropertyUrl="",LoadCustInscription="",LoadCustMouthwidth="",LoadSilverLetter="";

const selectmouthpieces = [
    {
      name: 'balanced-snaffle',
      value: 'balancedSnaffle',
      baseval: 'baseline_BalancedSnaffle'
    },
    {
      name: 'billy-allen',
      value: 'billyAllen',
      baseval: 'baseline_BillyAllen'
    },
    {
      name: 'clearwater',
      value: 'clearwater_NoRoller',
      baseval: 'baseline_Clearwater_NoRoller'
    },
    {
      name: 'correction',
      value: 'correction',
      baseval: 'baseline_Correction'
    },
    {
      name: 'dr-tom',
      value: 'drTom',
      baseval: 'baseline_DrTom'
    },
    {
      name: 'high-port',
      value: 'highPort_NoRoller',
      baseval: 'baseline_HighPort_NoRoller'
    },
    {
      name: 'hinge-port',
      value: 'hingePort_Roller',
      baseval: 'baseline_HingePort_Roller'
    },
    {
      name: 'house-snaffle',
      value: 'houseSnaffle',
      baseval: 'baseline_HouseSnaffle'
    },
    {
      name: 'iron-worker',
      value: 'ironWorkerSmall',
      baseval: 'ironWorkerMedium'
    },
    {
      name: 'low-hinge-port',
      value: 'lowHingePort_Roller',
      baseval: 'baseline_LowHingePort_Roller'
    },
    {
      name: 'low-port',
      value: 'lowPort',
      baseval: 'baseline_LowPort'
    },
    {
      name: 'low-rider',
      value: 'lowRider',
      baseval: 'baseline_LowRider'
    },
    {
      name: 'malibu',
      value: 'malibu_NoRoller',
      baseval: 'baseline_Malibu_NoRoller'
    },
    {
      name: 'med-low-port',
      value: 'mediumLowPort_NoRoller',
      baseval: 'baseline_MediumLowPort_NoRoller'
    },
    {
      name: 'med-port',
      value: 'mediumPort_NoRoller',
      baseval: 'baseline_MediumPort_NoRoller'
    },
    {
      name: 'mullened-correction',
      value: 'mullenedCorrection',
      baseval: 'baseline_MullenedCorrection'
    },
    {
      name: 'silverado',
      value: 'silverado_NoRoller',
      baseval: 'baseline_Silverado_NoRoller'
    },
    {
      name: 'slick-50',
      value: 'slick50',
      baseval: 'baseline_Slick50'
    },
    {
      name: 'snaffle',
      value: 'snaffle',
      baseval: 'baseline_Snaffle'
    },
    {
      name: 'square-port',
      value: 'squarePort_NoRoller',
      baseval: 'baseline_SquarePort_NoRoller'
    },
    {
      name: 'sweet-water',
      value: 'sweetWater',
      baseval: 'baseline_SweetWater'
    },
    {
      name: 'twisted',
      value: 'twistedSquare',
      baseval: 'twistedWireMedium'
    },
    {
      name: 'verona',
      value: 'verona_Roller',
      baseval: 'baseline_Verona_Roller'
    }
];
const selectshanks = [
    {
      name: 'Baseline Advantage Long',
      handle: 'baselineAdvantageLong',
      left: 'baseAdvLongLeftKey',
      right: 'baseAdvLongRightKey',
      shank: false,
      shankfinish: false,
      shankoverlay: false
    },
    {
      name: 'Advantage Long',
      handle: 'advantageLong',
      left: 'advLongLeftKey',
      right: 'advLongRightKey',
      shank: true,
      shankfinish: true,
      shankoverlay: true
    },
    {
      name: 'Baseline Long',
      handle: 'baselineLong',
      left: 'baseLongLeftKey',
      right: 'baseLongRightKey',
      shank: true,
      shankfinish: false,
      shankoverlay: false
    },
    {
      name: 'Long',
      handle: 'long',
      left: 'longLeftKey',
      right: 'longRightKey',
      shank: true,
      shankfinish: true,
      shankoverlay: true
    },
    {
      name: 'Baseline Advantage Short',
      handle: 'baselineAdvantageShort',
      left: 'baseAdvShortLeftKey',
      right: 'baseAdvShortRightKey',
      shank: true,
      shankfinish: false,
      shankoverlay: false
    },
    {
      name: 'Advantage Short',
      handle: 'advantageShort',
      left: 'advShortLeftKey',
      right: 'advShortRightKey',
      shank: true,
      shankfinish: true,
      shankoverlay: true
    },
    {
      name: 'Baseline Short',
      handle: 'baselineShort',
      left: 'baseShortLeftKey',
      right: 'baseShortRightKey',
      shank: true,
      shankfinish: false,
      shankoverlay: false
    },
    {
      name: 'Short',
      handle: 'short',
      left: 'shortLeftKey',
      right: 'shortRightKey',
      shank: true,
      shankfinish: true,
      shankoverlay: true
    },
    {
      name: 'Baseline Medium S',
      handle: 'baselineMedS',
      left: 'baseMedLeftKey',
      right: 'baseMedRightKey',
      shank: true,
      shankfinish: false,
      shankoverlay: false
    },
    {
      name: 'Medium S',
      handle: 'medS',
      left: 'medLeftKey',
      right: 'medRightKey',
      shank: true,
      shankfinish: true,
      shankoverlay: true
    },
    {
      name: 'Long S',
      handle: 'longS', 
      left: 'longSLeftKey',
      right: 'longSRightKey',
      shankfinish: true,
      shankoverlay: true
    },
    {
      name: 'Long Ballhinge',
      handle: 'longBallhinge',
      left: 'longBallhingeLeftKey',
      right: 'longBallhingeRightKey',
      shankfinish: true,
      shankoverlay: true
    },
    {
      name: 'Long S Ballhinge',
      handle: 'longSBallhinge',
      left: 'longSBallhingeLeftKey',
      right: 'longSBallhingeRightKey',
      shankfinish: true,
      shankoverlay: true
    },
    {
      name: 'Long Horn',
      handle: 'longHorn',
      left: 'longHornLeftKey',
      right: 'longHornRightKey',
      shankfinish: true,
      shankoverlay: true
    },
    {
      name: 'Maverick',
      handle: 'maverick',
      left: 'maverickLeftKey',
      right: 'maverickRightKey',
      shankfinish: true,
      shankoverlay: true
    },
    {
      name: 'Medium S Ballhinge',
      handle: 'mediumSBallhinge',
      left: 'mediumSBallhingeLeftKey',
      right: 'mediumSBallhingeRightKey',
      shankfinish: true,
      shankoverlay: true
    },
    {
      name: 'Mustang',
      handle: 'mustang',
      left: 'mustangLeftKey',
      right: 'mustangRightKey',
      shankfinish: true,
      shankoverlay: true
    },
    {
      name: 'Predator',
      handle: 'predator',
      left: 'predatorLeftKey',
      right: 'predatorRightKey',
      shankfinish: true,
      shankoverlay: true
    },
    {
      name: 'Raptor',
      handle: 'raptor',
      left: 'raptorLeftKey',
      right: 'raptorRightKey',
      shankfinish: true,
      shankoverlay: true
    },
    {
      name: 'Short Ballhinge',
      handle: 'shortBallhinge',
      left: 'shortBallhingeLeftKey',
      right: 'shortBallhingeRightKey',
      shankfinish: true,
      shankoverlay: true
    },
    {
      name: 'Short S',
      handle: 'shortS',
      left: 'shortSLeftKey',
      right: 'shortSRightKey',
      shankfinish: true,
      shankoverlay: true
    },
    {
      name: 'Shorty',
      handle: 'shorty',
      left: 'shortyLeftKey',
      right: 'shortyRightKey',
      shankfinish: true,
      shankoverlay: true
    },
    {
      name: 'Shorty Ballhinge',
      handle: 'shortyBallhinge',
      left: 'shortyBallhingeLeftKey',
      right: 'shortyBallhingeRightKey',
      shankfinish: true,
      shankoverlay: true
    },
    {
      name: 'Short Horn',
      handle: 'shortHorn',
      left: 'shortHornLeftKey',
      right: 'shortHornRightKey',
      shankfinish: true,
      shankoverlay: true
    },
    {
      name: 'Sierra Ballhinge',
      handle: 'sierraBallhinge',
      left: 'sierraBallhingeLeftKey',
      right: 'sierraBallhingeRightKey',
      shankfinish: true,
      shankoverlay: true
    },
    {
      name: 'Avila',
      handle: 'avila',
      left: 'avilaLeftKey',
      right: 'avilaRightKey',
      shankfinish: true,
      shankoverlay: true
    },
    {
      name: 'Bighorn',
      handle: 'bigHorn',
      left: 'bigHornLeftKey',
      right: 'bigHornRightKey',
      shankfinish: true,
      shankoverlay: true
    },
    {
      name: 'Cody',
      handle: 'cody',
      left: 'codyLeftKey',
      right: 'codyRightKey',
      shankfinish: true,
      shankoverlay: true
    },
    {
      name: 'Eva Marie',
      handle: 'evaMarie',
      left: 'evaMarieLeftKey',
      right: 'evaMarieRightKey',
      shankfinish: true,
      shankoverlay: true
    },
    {
      name: 'K2',
      handle: 'k2',
      left: 'k2LeftKey',
      right: 'k2RightKey',
      shankfinish: true,
      shankoverlay: true
    },
    {
      name: 'Powder River',
      handle: 'powderRiver',
      left: 'powderRiverLeftKey',
      right: 'powderRiverRightKey',
      shankfinish: true,
      shankoverlay: true
    },
    {
      name: 'Riviera',
      handle: 'riviera',
      left: 'rivieraLeftKey',
      right: 'rivieraRightKey',
      shankfinish: true,
      shankoverlay: true
    },
    {
      name: 'Santa Barbara',
      handle: 'santaBarbara',
      left: 'santaBarbaraLeftKey',
      right: 'santaBarbaraRightKey',
      shankfinish: true,
      shankoverlay: true
    },
    {
      name: 'Santa Barbara Short',
      handle: 'santaBarbaraShort',
      left: 'santaBarbaraShortLeftKey',
      right: 'santaBarbaraShortRightKey',
      shankfinish: true,
      shankoverlay: true
    },
    {
      name: 'Santa Maria',
      handle: 'santaMaria',
      left: 'santaMariaLeftKey',
      right: 'santaMariaRightKey',
      shankfinish: true,
      shankoverlay: true
    },
    {
      name: 'Sheridan',
      handle: 'sheridan',
      left: 'sheridanLeftKey',
      right: 'sheridanRightKey',
      shankfinish: true,
      shankoverlay: true
    },
    {
      name: 'Sheridan 7',
      handle: 'sheridan7',
      left: 'sheridan7LeftKey',
      right: 'sheridan7RightKey',
      shankfinish: true,
      shankoverlay: true
    },
    {
      name: 'Switchback',
      handle: 'switchback',
      left: 'switchbackLeftKey',
      right: 'switchbackRightKey',
      shankfinish: true,
      shankoverlay: true
    },
    {
      name: 'Tahoe',
      handle: 'tahoe',
      left: 'tahoeLeftKey',
      right: 'tahoeRightKey',
      shankfinish: true,
      shankoverlay: true
    },
    {
      name: 'Teton',
      handle: 'teton',
      left: 'tetonLeftKey',
      right: 'tetonRightKey',
      shankfinish: true,
      shankoverlay: true
    },
    {
      name: 'Baseline D-Ring Snaffle',
      handle: 'baseline-dring',
      left: 'baseDRingLeftKey',
      right: 'baseDRingRightKey',
      shankfinish: true,
      shankoverlay: true
    },
    {
      name: 'D-Ring',
      handle: 'dRing',
      left: 'dRingLeftKey',
      right: 'dRingRightKey',
      shankfinish: true,
      shankoverlay: true
    },
    {
      name: 'Loose Ring',
      handle: 'looseRing',
      left: 'looseRingLeftKey',
      right: 'looseRingRightKey',
      shankfinish: true,
      shankoverlay: true
    },
    {
      name: 'West Coast',
      handle: 'westCoast',
      left: 'westCoastLeftKey',
      right: 'westCoastRightKey',
      shankfinish: true,
      shankoverlay: true
    },
    {
      name: 'Ballhinge Ring',
      handle: 'ballhingeRing',
      left: 'ballhingeRingLeftKey',
      right: 'ballhingeRingRightKey',
      shankfinish: true,
      shankoverlay: true
    },
    {
      name: 'Ballhinge D-Ring',
      handle: 'ballhingeDRing',
      left: 'ballhingeDRingLeftKey',
      right: 'ballhingeDRingRightKey',
      shankfinish: true,
      shankoverlay: true
    },
    {
      name: 'West Coast Divots & Dots',
      handle: 'westCoastDotsandDivots',
      left: 'westCoastDandDLeftKey',
      right: 'westCoastDandDRightKey',
      shankfinish: true,
      shankoverlay: true
    }
];
const selectshanksSR = [
    {
      name: 'Advantage Short',
      handle: 'advantageShort',
      left: 'srAdvShortLeftKey',
      right: 'srAdvShortRightKey',
      shank: true,
      shankfinish: true,
      shankoverlay: true
    },
    {
      name: 'Baseline Short',
      handle: 'baselineShort',
      left: 'srBaseShortLeftKey',
      right: 'srBaseShortRightKey',
      shank: true,
      shankfinish: false,
      shankoverlay: false
    },
    {
      name: 'Short',
      handle: 'short',
      left: 'srShortLeftKey',
      right: 'srShortRightKey',
      shank: true,
      shankfinish: true,
      shankoverlay: true
    },
    {
      name: 'Baseline Medium S',
      handle: 'baselineMedS',
      left: 'srBaseMedLeftKey',
      right: 'srBaseMedRightKey',
      shank: true,
      shankfinish: false,
      shankoverlay: false
    },
    {
      name: 'Medium S',
      handle: 'medS',
      left: 'srMedLeftKey',
      right: 'srMedRightKey',
      shank: true,
      shankfinish: true,
      shankoverlay: true
    },
    {
      name: 'Long S',
      handle: 'longS',
      left: 'srLongSLeftKey',
      right: 'srLongSRightKey',
      shankfinish: true,
      shankoverlay: true
    },
    {
      name: 'Long Ballhinge',
      handle: 'longBallhinge',
      left: 'srLongBallhingeLeftKey',
      right: 'srLongBallhingeRightKey',
      shankfinish: true,
      shankoverlay: true
    },
    {
      name: 'Long S Ballhinge',
      handle: 'longSBallhinge',
      left: 'srLongSBallhingeLeftKey',
      right: 'srLongSBallhingeRightKey',
      shankfinish: true,
      shankoverlay: true
    },
    {
      name: 'Long Horn',
      handle: 'longHorn',
      left: 'srLongHornLeftKey',
      right: 'srLongHornRightKey',
      shankfinish: true,
      shankoverlay: true
    },
    {
      name: 'Maverick',
      handle: 'maverick',
      left: 'srMaverickLeftKey',
      right: 'srMaverickRightKey',
      shankfinish: true,
      shankoverlay: true
    },
    {
      name: 'Medium S Ballhinge',
      handle: 'mediumSBallhinge',
      left: 'srMediumSBallhingeLeftKey',
      right: 'srMediumSBallhingeRightKey',
      shankfinish: true,
      shankoverlay: true
    },
    {
      name: 'Mustang',
      handle: 'mustang',
      left: 'srMustangLeftKey',
      right: 'srMustangRightKey',
      shankfinish: true,
      shankoverlay: true
    },
    {
      name: 'Predator',
      handle: 'predator',
      left: 'srPredatorLeftKey',
      right: 'srPredatorRightKey',
      shankfinish: true,
      shankoverlay: true
    },
    {
      name: 'Raptor',
      handle: 'raptor',
      left: 'srRaptorLeftKey',
      right: 'srRaptorRightKey',
      shankfinish: true,
      shankoverlay: true
    },
    {
      name: 'Short Ballhinge',
      handle: 'shortBallhinge',
      left: 'srShortBallhingeLeftKey',
      right: 'srShortBallhingeRightKey',
      shankfinish: true,
      shankoverlay: true
    },
    {
      name: 'Short S',
      handle: 'shortS',
      left: 'srShortSLeftKey',
      right: 'srShortSRightKey',
      shankfinish: true,
      shankoverlay: true
    },
    {
      name: 'Shorty',
      handle: 'shorty',
      left: 'srShortyLeftKey',
      right: 'srShortyRightKey',
      shankfinish: true,
      shankoverlay: true
    },
    {
      name: 'Shorty Ballhinge',
      handle: 'shortyBallhinge',
      left: 'srShortyBallhingeLeftKey',
      right: 'srShortyBallhingeRightKey',
      shankfinish: true,
      shankoverlay: true
    },
    {
      name: 'Short Horn',
      handle: 'shortHorn',
      left: 'srShortHornLeftKey',
      right: 'srShortHornRightKey',
      shankfinish: true,
      shankoverlay: true
    },
    {
      name: 'Sierra Ballhinge',
      handle: 'sierraBallhinge',
      left: 'srSierraBallhingeLeftKey',
      right: 'srSierraBallhingeRightKey',
      shankfinish: true,
      shankoverlay: true
    },
    {
      name: 'Avila',
      handle: 'avila',
      left: 'srAvilaLeftKey',
      right: 'srAvilaRightKey',
      shankfinish: true,
      shankoverlay: true
    },
    {
      name: 'Bighorn',
      handle: 'bigHorn',
      left: 'srBigHornLeftKey',
      right: 'srBigHornRightKey',
      shankfinish: true,
      shankoverlay: true
    },
    {
      name: 'Cody',
      handle: 'cody',
      left: 'srCodyLeftKey',
      right: 'srCodyRightKey',
      shankfinish: true,
      shankoverlay: true
    },
    {
      name: 'Eva Marie',
      handle: 'evaMarie',
      left: 'srEvaMarieLeftKey',
      right: 'srEvaMarieRightKey',
      shankfinish: true,
      shankoverlay: true
    },
    {
      name: 'K2',
      handle: 'k2',
      left: 'srK2LeftKey',
      right: 'srK2RightKey',
      shankfinish: true,
      shankoverlay: true
    },
    {
      name: 'Powder River',
      handle: 'powderRiver',
      left: 'srPowderRiverLeftKey',
      right: 'srPowderRiverRightKey',
      shankfinish: true,
      shankoverlay: true
    },
    {
      name: 'Riviera',
      handle: 'riviera',
      left: 'srRivieraLeftKey',
      right: 'srRivieraRightKey',
      shankfinish: true,
      shankoverlay: true
    },
    {
      name: 'Santa Barbara',
      handle: 'santaBarbara',
      left: 'srSantaBarbaraLeftKey',
      right: 'srSantaBarbaraRightKey',
      shankfinish: true,
      shankoverlay: true
    },
    {
      name: 'Santa Barbara Short',
      handle: 'santaBarbaraShort',
      left: 'srSantaBarbaraShortLeftKey',
      right: 'srSantaBarbaraShortRightKey',
      shankfinish: true,
      shankoverlay: true
    },
    {
      name: 'Santa Maria',
      handle: 'santaMaria',
      left: 'srSantaMariaLeftKey',
      right: 'srSantaMariaRightKey',
      shankfinish: true,
      shankoverlay: true
    },
    {
      name: 'Sheridan',
      handle: 'sheridan',
      left: 'srSheridanLeftKey',
      right: 'srSheridanRightKey',
      shankfinish: true,
      shankoverlay: true
    },
    {
      name: 'Sheridan 7',
      handle: 'sheridan7',
      left: 'srSheridan7LeftKey',
      right: 'srSheridan7RightKey',
      shankfinish: true,
      shankoverlay: true
    },
    {
      name: 'Switchback',
      handle: 'switchback',
      left: 'srSwitchbackLeftKey',
      right: 'srSwitchbackRightKey',
      shankfinish: true,
      shankoverlay: true
    },
    {
      name: 'Tahoe',
      handle: 'tahoe',
      left: 'srTahoeLeftKey',
      right: 'srTahoeRightKey',
      shankfinish: true,
      shankoverlay: true
    },
    {
      name: 'Teton',
      handle: 'teton',
      left: 'srTetonLeftKey',
      right: 'srTetonRightKey',
      shankfinish: true,
      shankoverlay: true
    }
];
const selectshanksSR2 = [
    {
      name: 'Advantage Short',
      handle: 'advantageShort',
      left: 'sr2AdvShortLeftKey',
      right: 'sr2AdvShortRightKey',
      shank: true,
      shankfinish: true,
      shankoverlay: true
    },
    {
      name: 'Baseline Short',
      handle: 'baselineShort',
      left: 'sr2BaseShortLeftKey',
      right: 'sr2BaseShortRightKey',
      shank: true,
      shankfinish: false,
      shankoverlay: false
    },
    {
      name: 'Short',
      handle: 'short',
      left: 'sr2ShortLeftKey',
      right: 'sr2ShortRightKey',
      shank: true,
      shankfinish: true,
      shankoverlay: true
    },
    {
      name: 'Baseline Medium S',
      handle: 'baselineMedS',
      left: 'sr2BaseMedLeftKey',
      right: 'sr2BaseMedRightKey',
      shank: true,
      shankfinish: false,
      shankoverlay: false
    },
    {
      name: 'Medium S',
      handle: 'medS',
      left: 'sr2MedLeftKey',
      right: 'sr2MedRightKey',
      shank: true,
      shankfinish: true,
      shankoverlay: true
    },
    {
      name: 'Long S',
      handle: 'longS',
      left: 'sr2LongSLeftKey',
      right: 'sr2LongSRightKey',
      shankfinish: true,
      shankoverlay: true
    },
    {
      name: 'Long Ballhinge',
      handle: 'longBallhinge',
      left: 'sr2LongBallhingeLeftKey',
      right: 'sr2LongBallhingeRightKey',
      shankfinish: true,
      shankoverlay: true
    },
    {
      name: 'Long S Ballhinge',
      handle: 'longSBallhinge',
      left: 'sr2LongSBallhingeLeftKey',
      right: 'sr2LongSBallhingeRightKey',
      shankfinish: true,
      shankoverlay: true
    },
    {
      name: 'Long Horn',
      handle: 'longHorn',
      left: 'sr2LongHornLeftKey',
      right: 'sr2LongHornRightKey',
      shankfinish: true,
      shankoverlay: true
    },
    {
      name: 'Maverick',
      handle: 'maverick',
      left: 'sr2MaverickLeftKey',
      right: 'sr2MaverickRightKey',
      shankfinish: true,
      shankoverlay: true
    },
    {
      name: 'Medium S Ballhinge',
      handle: 'mediumSBallhinge',
      left: 'sr2MediumSBallhingeLeftKey',
      right: 'sr2MediumSBallhingeRightKey',
      shankfinish: true,
      shankoverlay: true
    },
    {
      name: 'Mustang',
      handle: 'mustang',
      left: 'sr2MustangLeftKey',
      right: 'sr2MustangRightKey',
      shankfinish: true,
      shankoverlay: true
    },
    {
      name: 'Predator',
      handle: 'predator',
      left: 'sr2PredatorLeftKey',
      right: 'sr2PredatorRightKey',
      shankfinish: true,
      shankoverlay: true
    },
    {
      name: 'Raptor',
      handle: 'raptor',
      left: 'sr2RaptorLeftKey',
      right: 'sr2RaptorRightKey',
      shankfinish: true,
      shankoverlay: true
    },
    {
      name: 'Short Ballhinge',
      handle: 'shortBallhinge',
      left: 'sr2ShortBallhingeLeftKey',
      right: 'sr2ShortBallhingeRightKey',
      shankfinish: true,
      shankoverlay: true
    },
    {
      name: 'Short S',
      handle: 'shortS',
      left: 'sr2ShortSLeftKey',
      right: 'sr2ShortSRightKey',
      shankfinish: true,
      shankoverlay: true
    },
    {
      name: 'Shorty',
      handle: 'shorty',
      left: 'sr2ShortyLeftKey',
      right: 'sr2ShortyRightKey',
      shankfinish: true,
      shankoverlay: true
    },
    {
      name: 'Shorty Ballhinge',
      handle: 'shortyBallhinge',
      left: 'sr2ShortyBallhingeLeftKey',
      right: 'sr2ShortyBallhingeRightKey',
      shankfinish: true,
      shankoverlay: true
    },
    {
      name: 'Short Horn',
      handle: 'shortHorn',
      left: 'sr2ShortHornLeftKey',
      right: 'sr2ShortHornRightKey',
      shankfinish: true,
      shankoverlay: true
    },
    {
      name: 'Sierra Ballhinge',
      handle: 'sierraBallhinge',
      left: 'sr2SierraBallhingeLeftKey',
      right: 'sr2SierraBallhingeRightKey',
      shankfinish: true,
      shankoverlay: true
    },
    {
      name: 'Avila',
      handle: 'avila',
      left: 'sr2AvilaLeftKey',
      right: 'sr2AvilaRightKey',
      shankfinish: true,
      shankoverlay: true
    },
    {
      name: 'Bighorn',
      handle: 'bigHorn',
      left: 'sr2BigHornLeftKey',
      right: 'sr2BigHornRightKey',
      shankfinish: true,
      shankoverlay: true
    },
    {
      name: 'Cody',
      handle: 'cody',
      left: 'sr2CodyLeftKey',
      right: 'sr2CodyRightKey',
      shankfinish: true,
      shankoverlay: true
    },
    {
      name: 'Eva Marie',
      handle: 'evaMarie',
      left: 'sr2EvaMarieLeftKey',
      right: 'sr2EvaMarieRightKey',
      shankfinish: true,
      shankoverlay: true
    },
    {
      name: 'K2',
      handle: 'k2',
      left: 'sr2K2LeftKey',
      right: 'sr2K2RightKey',
      shankfinish: true,
      shankoverlay: true
    },
    {
      name: 'Powder River',
      handle: 'powderRiver',
      left: 'sr2PowderRiverLeftKey',
      right: 'sr2PowderRiverRightKey',
      shankfinish: true,
      shankoverlay: true
    },
    {
      name: 'Riviera',
      handle: 'riviera',
      left: 'sr2RivieraLeftKey',
      right: 'sr2RivieraRightKey',
      shankfinish: true,
      shankoverlay: true
    },
    {
      name: 'Santa Barbara',
      handle: 'santaBarbara',
      left: 'sr2SantaBarbaraLeftKey',
      right: 'sr2SantaBarbaraRightKey',
      shankfinish: true,
      shankoverlay: true
    },
    {
      name: 'Santa Barbara Short',
      handle: 'santaBarbaraShort',
      left: 'sr2SantaBarbaraShortLeftKey',
      right: 'sr2SantaBarbaraShortRightKey',
      shankfinish: true,
      shankoverlay: true
    },
    {
      name: 'Santa Maria',
      handle: 'santaMaria',
      left: 'sr2SantaMariaLeftKey',
      right: 'sr2SantaMariaRightKey',
      shankfinish: true,
      shankoverlay: true
    },
    {
      name: 'Sheridan',
      handle: 'sheridan',
      left: 'sr2SheridanLeftKey',
      right: 'sr2SheridanRightKey',
      shankfinish: true,
      shankoverlay: true
    },
    {
      name: 'Sheridan 7',
      handle: 'sheridan7',
      left: 'sr2Sheridan7LeftKey',
      right: 'sr2Sheridan7RightKey',
      shankfinish: true,
      shankoverlay: true
    },
    {
      name: 'Switchback',
      handle: 'switchback',
      left: 'sr2SwitchbackLeftKey',
      right: 'sr2SwitchbackRightKey',
      shankfinish: true,
      shankoverlay: true
    },
    {
      name: 'Tahoe',
      handle: 'tahoe',
      left: 'sr2TahoeLeftKey',
      right: 'sr2TahoeRightKey',
      shankfinish: true,
      shankoverlay: true
    },
    {
      name: 'Teton',
      handle: 'teton',
      left: 'sr2TetonLeftKey',
      right: 'sr2TetonRightKey',
      shankfinish: true,
      shankoverlay: true
    }
];
const selectshanksMedPortnoRoll = [
    {
      name: 'Baseline Advantage Long',
      handle: 'baselineAdvantageLong',
      left: 'mediumPortBaseAdvLongLeftKey',
      right: 'mediumPortBaseAdvLongRightKey',
      shank: false,
      shankfinish: false,
      shankoverlay: false
    },
    {
      name: 'Advantage Long',
      handle: 'advantageLong',
      left: 'mediumPortAdvLongLeftKey',
      right: 'mediumPortAdvLongRightKey',
      shank: true,
      shankfinish: true,
      shankoverlay: true
    },
    {
      name: 'Baseline Long',
      handle: 'baselineLong',
      left: 'mediumPortBaseLongLeftKey',
      right: 'mediumPortBaseLongRightKey',
      shank: true,
      shankfinish: false,
      shankoverlay: false
    },
    {
      name: 'Long',
      handle: 'long',
      left: 'mediumPortLongLeftKey',
      right: 'mediumPortLongRightKey',
      shank: true,
      shankfinish: true,
      shankoverlay: true
    },
    {
      name: 'Baseline Advantage Short',
      handle: 'baselineAdvantageShort',
      left: 'mediumPortBaseAdvShortLeftKey',
      right: 'mediumPortBaseAdvShortRightKey',
      shank: true,
      shankfinish: false,
      shankoverlay: false
    },
    {
      name: 'Advantage Short',
      handle: 'advantageShort',
      left: 'mediumPortAdvShortLeftKey',
      right: 'mediumPortAdvShortRightKey',
      shank: true,
      shankfinish: true,
      shankoverlay: true
    },
    {
      name: 'Baseline Short',
      handle: 'baselineShort',
      left: 'mediumPortBaseShortLeftKey',
      right: 'mediumPortBaseShortRightKey',
      shank: true,
      shankfinish: false,
      shankoverlay: false
    },
    {
      name: 'Short',
      handle: 'short',
      left: 'mediumPortShortLeftKey',
      right: 'mediumPortShortRightKey',
      shank: true,
      shankfinish: true,
      shankoverlay: true
    },
    {
      name: 'Baseline Medium S',
      handle: 'baselineMedS',
      left: 'mediumPortBaseMedLeftKey',
      right: 'mediumPortBaseMedRightKey',
      shank: true,
      shankfinish: false,
      shankoverlay: false
    },
    {
      name: 'Medium S',
      handle: 'medS',
      left: 'mediumPortMedLeftKey',
      right: 'mediumPortMedRightKey',
      shank: true,
      shankfinish: true,
      shankoverlay: true
    },
    {
      name: 'Long S',
      handle: 'longS',
      left: 'mediumPortLongSLeftKey',
      right: 'mediumPortLongSRightKey',
      shankfinish: true,
      shankoverlay: true
    },
    {
      name: 'Long Ballhinge',
      handle: 'longBallhinge',
      left: 'mediumPortLongBallhingeLeftKey',
      right: 'mediumPortLongBallhingeRightKey',
      shankfinish: true,
      shankoverlay: true
    },
    {
      name: 'Long S Ballhinge',
      handle: 'longSBallhinge',
      left: 'mediumPortLongSBallhingeLeftKey',
      right: 'mediumPortLongSBallhingeRightKey',
      shankfinish: true,
      shankoverlay: true
    },
    {
      name: 'Long Horn',
      handle: 'longHorn',
      left: 'mediumPortLongHornLeftKey',
      right: 'mediumPortLongHornRightKey',
      shankfinish: true,
      shankoverlay: true
    },
    {
      name: 'Maverick',
      handle: 'maverick',
      left: 'mediumPortMaverickLeftKey',
      right: 'mediumPortMaverickRightKey',
      shankfinish: true,
      shankoverlay: true
    },
    {
      name: 'Medium S Ballhinge',
      handle: 'mediumSBallhinge',
      left: 'mediumPortMediumSBallhingeLeftKey',
      right: 'mediumPortMediumSBallhingeRightKey',
      shankfinish: true,
      shankoverlay: true
    },
    {
      name: 'Mustang',
      handle: 'mustang',
      left: 'mediumPortMustangLeftKey',
      right: 'mediumPortMustangRightKey',
      shankfinish: true,
      shankoverlay: true
    },
    {
      name: 'Predator',
      handle: 'predator',
      left: 'mediumPortPredatorLeftKey',
      right: 'mediumPortPredatorRightKey',
      shankfinish: true,
      shankoverlay: true
    },
    {
      name: 'Raptor',
      handle: 'raptor',
      left: 'mediumPortRaptorLeftKey',
      right: 'mediumPortRaptorRightKey',
      shankfinish: true,
      shankoverlay: true
    },
    {
      name: 'Short Ballhinge',
      handle: 'shortBallhinge',
      left: 'mediumPortShortBallhingeLeftKey',
      right: 'mediumPortShortBallhingeRightKey',
      shankfinish: true,
      shankoverlay: true
    },
    {
      name: 'Short S',
      handle: 'shortS',
      left: 'mediumPortShortSLeftKey',
      right: 'mediumPortShortSRightKey',
      shankfinish: true,
      shankoverlay: true
    },
    {
      name: 'Shorty',
      handle: 'shorty',
      left: 'mediumPortShortyLeftKey',
      right: 'mediumPortShortyRightKey',
      shankfinish: true,
      shankoverlay: true
    },
    {
      name: 'Shorty Ballhinge',
      handle: 'shortyBallhinge',
      left: 'mediumPortShortyBallhingeLeftKey',
      right: 'mediumPortShortyBallhingeRightKey',
      shankfinish: true,
      shankoverlay: true
    },
    {
      name: 'Short Horn',
      handle: 'shortHorn',
      left: 'mediumPortShortHornLeftKey',
      right: 'mediumPortShortHornRightKey',
      shankfinish: true,
      shankoverlay: true
    },
    {
      name: 'Sierra Ballhinge',
      handle: 'sierraBallhinge',
      left: 'mediumPortSierraBallhingeLeftKey',
      right: 'mediumPortSierraBallhingeRightKey',
      shankfinish: true,
      shankoverlay: true
    },
    {
      name: 'Avila',
      handle: 'avila',
      left: 'mediumPortAvilaLeftKey',
      right: 'mediumPortAvilaRightKey',
      shankfinish: true,
      shankoverlay: true
    },
    {
      name: 'Bighorn',
      handle: 'bigHorn',
      left: 'mediumPortBigHornLeftKey',
      right: 'mediumPortBigHornRightKey',
      shankfinish: true,
      shankoverlay: true
    },
    {
      name: 'Cody',
      handle: 'cody',
      left: 'mediumPortCodyLeftKey',
      right: 'mediumPortCodyRightKey',
      shankfinish: true,
      shankoverlay: true
    },
    {
      name: 'Eva Marie',
      handle: 'evaMarie',
      left: 'mediumPortEvaMarieLeftKey',
      right: 'mediumPortEvaMarieRightKey',
      shankfinish: true,
      shankoverlay: true
    },
    {
      name: 'K2',
      handle: 'k2',
      left: 'mediumPortK2LeftKey',
      right: 'mediumPortK2RightKey',
      shankfinish: true,
      shankoverlay: true
    },
    {
      name: 'Powder River',
      handle: 'powderRiver',
      left: 'mediumPortPowderRiverLeftKey',
      right: 'mediumPortPowderRiverRightKey',
      shankfinish: true,
      shankoverlay: true
    },
    {
      name: 'Riviera',
      handle: 'riviera',
      left: 'mediumPortRivieraLeftKey',
      right: 'mediumPortRivieraRightKey',
      shankfinish: true,
      shankoverlay: true
    },
    {
      name: 'Santa Barbara',
      handle: 'santaBarbara',
      left: 'mediumPortSantaBarbaraLeftKey',
      right: 'mediumPortSantaBarbaraRightKey',
      shankfinish: true,
      shankoverlay: true
    },
    {
      name: 'Santa Barbara Short',
      handle: 'santaBarbaraShort',
      left: 'mediumPortSantaBarbaraShortLeftKey',
      right: 'mediumPortSantaBarbaraShortRightKey',
      shankfinish: true,
      shankoverlay: true
    },
    {
      name: 'Santa Maria',
      handle: 'santaMaria',
      left: 'mediumPortSantaMariaLeftKey',
      right: 'mediumPortSantaMariaRightKey',
      shankfinish: true,
      shankoverlay: true
    },
    {
      name: 'Sheridan',
      handle: 'sheridan',
      left: 'mediumPortSheridanLeftKey',
      right: 'mediumPortSheridanRightKey',
      shankfinish: true,
      shankoverlay: true
    },
    {
      name: 'Sheridan 7',
      handle: 'sheridan7',
      left: 'mediumPortSheridan7LeftKey',
      right: 'mediumPortSheridan7RightKey',
      shankfinish: true,
      shankoverlay: true
    },
    {
      name: 'Switchback',
      handle: 'switchback',
      left: 'mediumPortSwitchbackLeftKey',
      right: 'mediumPortSwitchbackRightKey',
      shankfinish: true,
      shankoverlay: true
    },
    {
      name: 'Tahoe',
      handle: 'tahoe',
      left: 'mediumPortTahoeLeftKey',
      right: 'mediumPortTahoeRightKey',
      shankfinish: true,
      shankoverlay: true
    },
    {
      name: 'Teton',
      handle: 'teton',
      left: 'mediumPortTetonLeftKey',
      right: 'mediumPortTetonRightKey',
      shankfinish: true,
      shankoverlay: true
    }
];
const selectshanksMedPort = [
    {
      name: 'Baseline Advantage Long',
      handle: 'baselineAdvantageLong',
      left: 'mediumPortRollerBaseAdvLongLeftKey',
      right: 'mediumPortRollerBaseAdvLongRightKey',
      shank: false,
      shankfinish: false,
      shankoverlay: false
    },
    {
      name: 'Advantage Long',
      handle: 'advantageLong',
      left: 'mediumPortRollerAdvLongLeftKey',
      right: 'mediumPortRollerAdvLongRightKey',
      shank: true,
      shankfinish: true,
      shankoverlay: true
    },
    {
      name: 'Baseline Long',
      handle: 'baselineLong',
      left: 'mediumPortRollerBaseLongLeftKey',
      right: 'mediumPortRollerBaseLongRightKey',
      shank: true,
      shankfinish: false,
      shankoverlay: false
    },
    {
      name: 'Long',
      handle: 'long',
      left: 'mediumPortRollerLongLeftKey',
      right: 'mediumPortRollerLongRightKey',
      shank: true,
      shankfinish: true,
      shankoverlay: true
    },
    {
      name: 'Baseline Advantage Short',
      handle: 'baselineAdvantageShort',
      left: 'mediumPortRollerBaseAdvShortLeftKey',
      right: 'mediumPortRollerBaseAdvShortRightKey',
      shank: true,
      shankfinish: false,
      shankoverlay: false
    },
    {
      name: 'Advantage Short',
      handle: 'advantageShort',
      left: 'mediumPortRollerAdvShortLeftKey',
      right: 'mediumPortRollerAdvShortRightKey',
      shank: true,
      shankfinish: true,
      shankoverlay: true
    },
    {
      name: 'Baseline Short',
      handle: 'baselineShort',
      left: 'mediumPortRollerBaseShortLeftKey',
      right: 'mediumPortRollerBaseShortRightKey',
      shank: true,
      shankfinish: false,
      shankoverlay: false
    },
    {
      name: 'Short',
      handle: 'short',
      left: 'mediumPortRollerShortLeftKey',
      right: 'mediumPortRollerShortRightKey',
      shank: true,
      shankfinish: true,
      shankoverlay: true
    },
    {
      name: 'Baseline Medium S',
      handle: 'baselineMedS',
      left: 'mediumPortRollerBaseMedLeftKey',
      right: 'mediumPortRollerBaseMedRightKey',
      shank: true,
      shankfinish: false,
      shankoverlay: false
    },
    {
      name: 'Medium S',
      handle: 'medS',
      left: 'mediumPortRollerMedLeftKey',
      right: 'mediumPortRollerMedRightKey',
      shank: true,
      shankfinish: true,
      shankoverlay: true
    },
    {
      name: 'Long S',
      handle: 'longS',
      left: 'mediumPortRollerLongSLeftKey',
      right: 'mediumPortRollerLongSRightKey',
      shankfinish: true,
      shankoverlay: true
    },
    {
      name: 'Long Ballhinge',
      handle: 'longBallhinge',
      left: 'mediumPortRollerLongBallhingeLeftKey',
      right: 'mediumPortRollerLongBallhingeRightKey',
      shankfinish: true,
      shankoverlay: true
    },
    {
      name: 'Long S Ballhinge',
      handle: 'longSBallhinge',
      left: 'mediumPortRollerLongSBallhingeLeftKey',
      right: 'mediumPortRollerLongSBallhingeRightKey',
      shankfinish: true,
      shankoverlay: true
    },
    {
      name: 'Long Horn',
      handle: 'longHorn',
      left: 'mediumPortRollerLongHornLeftKey',
      right: 'mediumPortRollerLongHornRightKey',
      shankfinish: true,
      shankoverlay: true
    },
    {
      name: 'Maverick',
      handle: 'maverick',
      left: 'mediumPortRollerMaverickLeftKey',
      right: 'mediumPortRollerMaverickRightKey',
      shankfinish: true,
      shankoverlay: true
    },
    {
      name: 'Medium S Ballhinge',
      handle: 'mediumSBallhinge',
      left: 'mediumPortRollerMediumSBallhingeLeftKey',
      right: 'mediumPortRollerMediumSBallhingeRightKey',
      shankfinish: true,
      shankoverlay: true
    },
    {
      name: 'Mustang',
      handle: 'mustang',
      left: 'mediumPortRollerMustangLeftKey',
      right: 'mediumPortRollerMustangRightKey',
      shankfinish: true,
      shankoverlay: true
    },
    {
      name: 'Predator',
      handle: 'predator',
      left: 'mediumPortRollerPredatorLeftKey',
      right: 'mediumPortRollerPredatorRightKey',
      shankfinish: true,
      shankoverlay: true
    },
    {
      name: 'Raptor',
      handle: 'raptor',
      left: 'mediumPortRollerRaptorLeftKey',
      right: 'mediumPortRollerRaptorRightKey',
      shankfinish: true,
      shankoverlay: true
    },
    {
      name: 'Short Ballhinge',
      handle: 'shortBallhinge',
      left: 'mediumPortRollerShortBallhingeLeftKey',
      right: 'mediumPortRollerShortBallhingeRightKey',
      shankfinish: true,
      shankoverlay: true
    },
    {
      name: 'Short S',
      handle: 'shortS',
      left: 'mediumPortRollerShortSLeftKey',
      right: 'mediumPortRollerShortSRightKey',
      shankfinish: true,
      shankoverlay: true
    },
    {
      name: 'Shorty',
      handle: 'shorty',
      left: 'mediumPortRollerShortyLeftKey',
      right: 'mediumPortRollerShortyRightKey',
      shankfinish: true,
      shankoverlay: true
    },
    {
      name: 'Shorty Ballhinge',
      handle: 'shortyBallhinge',
      left: 'mediumPortRollerShortyBallhingeLeftKey',
      right: 'mediumPortRollerShortyBallhingeRightKey',
      shankfinish: true,
      shankoverlay: true
    },
    {
      name: 'Short Horn',
      handle: 'shortHorn',
      left: 'mediumPortRollerShortHornLeftKey',
      right: 'mediumPortRollerShortHornRightKey',
      shankfinish: true,
      shankoverlay: true
    },
    {
      name: 'Sierra Ballhinge',
      handle: 'sierraBallhinge',
      left: 'mediumPortRollerSierraBallhingeLeftKey',
      right: 'mediumPortRollerSierraBallhingeRightKey',
      shankfinish: true,
      shankoverlay: true
    },
    {
      name: 'Avila',
      handle: 'avila',
      left: 'mediumPortRollerAvilaLeftKey',
      right: 'mediumPortRollerAvilaRightKey',
      shankfinish: true,
      shankoverlay: true
    },
    {
      name: 'Bighorn',
      handle: 'bigHorn',
      left: 'mediumPortRollerBigHornLeftKey',
      right: 'mediumPortRollerBigHornRightKey',
      shankfinish: true,
      shankoverlay: true
    },
    {
      name: 'Cody',
      handle: 'cody',
      left: 'mediumPortRollerCodyLeftKey',
      right: 'mediumPortRollerCodyRightKey',
      shankfinish: true,
      shankoverlay: true
    },
    {
      name: 'Eva Marie',
      handle: 'evaMarie',
      left: 'mediumPortRollerEvaMarieLeftKey',
      right: 'mediumPortRollerEvaMarieRightKey',
      shankfinish: true,
      shankoverlay: true
    },
    {
      name: 'K2',
      handle: 'k2',
      left: 'mediumPortRollerK2LeftKey',
      right: 'mediumPortRollerK2RightKey',
      shankfinish: true,
      shankoverlay: true
    },
    {
      name: 'Powder River',
      handle: 'powderRiver',
      left: 'mediumPortRollerPowderRiverLeftKey',
      right: 'mediumPortRollerPowderRiverRightKey',
      shankfinish: true,
      shankoverlay: true
    },
    {
      name: 'Riviera',
      handle: 'riviera',
      left: 'mediumPortRollerRivieraLeftKey',
      right: 'mediumPortRollerRivieraRightKey',
      shankfinish: true,
      shankoverlay: true
    },
    {
      name: 'Santa Barbara',
      handle: 'santaBarbara',
      left: 'mediumPortRollerSantaBarbaraLeftKey',
      right: 'mediumPortRollerSantaBarbaraRightKey',
      shankfinish: true,
      shankoverlay: true
    },
    {
      name: 'Santa Barbara Short',
      handle: 'santaBarbaraShort',
      left: 'mediumPortRollerSantaBarbaraShortLeftKey',
      right: 'mediumPortRollerSantaBarbaraShortRightKey',
      shankfinish: true,
      shankoverlay: true
    },
    {
      name: 'Santa Maria',
      handle: 'santaMaria',
      left: 'mediumPortRollerSantaMariaLeftKey',
      right: 'mediumPortRollerSantaMariaRightKey',
      shankfinish: true,
      shankoverlay: true
    },
    {
      name: 'Sheridan',
      handle: 'sheridan',
      left: 'mediumPortRollerSheridanLeftKey',
      right: 'mediumPortRollerSheridanRightKey',
      shankfinish: true,
      shankoverlay: true
    },
    {
      name: 'Sheridan 7',
      handle: 'sheridan7',
      left: 'mediumPortRollerSheridan7LeftKey',
      right: 'mediumPortRollerSheridan7RightKey',
      shankfinish: true,
      shankoverlay: true
    },
    {
      name: 'Switchback',
      handle: 'switchback',
      left: 'mediumPortRollerSwitchbackLeftKey',
      right: 'mediumPortRollerSwitchbackRightKey',
      shankfinish: true,
      shankoverlay: true
    },
    {
      name: 'Tahoe',
      handle: 'tahoe',
      left: 'mediumPortRollerTahoeLeftKey',
      right: 'mediumPortRollerTahoeRightKey',
      shankfinish: true,
      shankoverlay: true
    },
    {
      name: 'Teton',
      handle: 'teton',
      left: 'mediumPortRollerTetonLeftKey',
      right: 'mediumPortRollerTetonRightKey',
      shankfinish: true,
      shankoverlay: true
    }
];
const selectshanksSilveradonoRoll = [
    {
      name: 'Baseline Advantage Long',
      handle: 'baselineAdvantageLong',
      left: 'silveradoBaseAdvLongLeftKey',
      right: 'silveradoBaseAdvLongRightKey',
      shank: false,
      shankfinish: false,
      shankoverlay: false
    },
    {
      name: 'Baseline Long',
      handle: 'baselineLong',
      left: 'silveradoBaseLongLeftKey',
      right: 'silveradoBaseLongRightKey',
      shank: true,
      shankfinish: false,
      shankoverlay: false
    },
    {
      name: 'Baseline Advantage Short',
      handle: 'baselineAdvantageShort',
      left: 'silveradoBaseAdvShortLeftKey',
      right: 'silveradoBaseAdvShortRightKey',
      shank: true,
      shankfinish: false,
      shankoverlay: false
    },
    {
      name: 'Advantage Short',
      handle: 'advantageShort',
      left: 'silveradoAdvShortLeftKey',
      right: 'silveradoAdvShortRightKey',
      shank: true,
      shankfinish: true,
      shankoverlay: true
    },
    {
      name: 'Baseline Short',
      handle: 'baselineShort',
      left: 'silveradoBaseShortLeftKey',
      right: 'silveradoBaseShortRightKey',
      shank: true,
      shankfinish: false,
      shankoverlay: false
    },
    {
      name: 'Short',
      handle: 'short',
      left: 'silveradoShortLeftKey',
      right: 'silveradoShortRightKey',
      shank: true,
      shankfinish: true,
      shankoverlay: true
    },
    {
      name: 'Baseline Medium S',
      handle: 'baselineMedS',
      left: 'silveradoBaseMedLeftKey',
      right: 'silveradoBaseMedRightKey',
      shank: true,
      shankfinish: false,
      shankoverlay: false
    },
    {
      name: 'Medium S',
      handle: 'medS',
      left: 'silveradoMedLeftKey',
      right: 'silveradoMedRightKey',
      shank: true,
      shankfinish: true,
      shankoverlay: true
    },
    {
      name: 'Long S',
      handle: 'longS',
      left: 'silveradoLongSLeftKey',
      right: 'silveradoLongSRightKey',
      shankfinish: true,
      shankoverlay: true
    },
    {
      name: 'Long Ballhinge',
      handle: 'longBallhinge',
      left: 'silveradoLongBallhingeLeftKey',
      right: 'silveradoLongBallhingeRightKey',
      shankfinish: true,
      shankoverlay: true
    },
    {
      name: 'Long S Ballhinge',
      handle: 'longSBallhinge',
      left: 'silveradoLongSBallhingeLeftKey',
      right: 'silveradoLongSBallhingeRightKey',
      shankfinish: true,
      shankoverlay: true
    },
    {
      name: 'Long Horn',
      handle: 'longHorn',
      left: 'silveradoLongHornLeftKey',
      right: 'silveradoLongHornRightKey',
      shankfinish: true,
      shankoverlay: true
    },
    {
      name: 'Maverick',
      handle: 'maverick',
      left: 'silveradoMaverickLeftKey',
      right: 'silveradoMaverickRightKey',
      shankfinish: true,
      shankoverlay: true
    },
    {
      name: 'Medium S Ballhinge',
      handle: 'mediumSBallhinge',
      left: 'silveradoMediumSBallhingeLeftKey',
      right: 'silveradoMediumSBallhingeRightKey',
      shankfinish: true,
      shankoverlay: true
    },
    {
      name: 'Mustang',
      handle: 'mustang',
      left: 'silveradoMustangLeftKey',
      right: 'silveradoMustangRightKey',
      shankfinish: true,
      shankoverlay: true
    },
    {
      name: 'Predator',
      handle: 'predator',
      left: 'silveradoPredatorLeftKey',
      right: 'silveradoPredatorRightKey',
      shankfinish: true,
      shankoverlay: true
    },
    {
      name: 'Raptor',
      handle: 'raptor',
      left: 'silveradoRaptorLeftKey',
      right: 'silveradoRaptorRightKey',
      shankfinish: true,
      shankoverlay: true
    },
    {
      name: 'Short Ballhinge',
      handle: 'shortBallhinge',
      left: 'silveradoShortBallhingeLeftKey',
      right: 'silveradoShortBallhingeRightKey',
      shankfinish: true,
      shankoverlay: true
    },
    {
      name: 'Short S',
      handle: 'shortS',
      left: 'silveradoShortSLeftKey',
      right: 'silveradoShortSRightKey',
      shankfinish: true,
      shankoverlay: true
    },
    {
      name: 'Shorty',
      handle: 'shorty',
      left: 'silveradoShortyLeftKey',
      right: 'silveradoShortyRightKey',
      shankfinish: true,
      shankoverlay: true
    },
    {
      name: 'Shorty Ballhinge',
      handle: 'shortyBallhinge',
      left: 'silveradoShortyBallhingeLeftKey',
      right: 'silveradoShortyBallhingeRightKey',
      shankfinish: true,
      shankoverlay: true
    },
    {
      name: 'Short Horn',
      handle: 'shortHorn',
      left: 'silveradoShortHornLeftKey',
      right: 'silveradoShortHornRightKey',
      shankfinish: true,
      shankoverlay: true
    },
    {
      name: 'Sierra Ballhinge',
      handle: 'sierraBallhinge',
      left: 'silveradoSierraBallhingeLeftKey',
      right: 'silveradoSierraBallhingeRightKey',
      shankfinish: true,
      shankoverlay: true
    },
    {
      name: 'Avila',
      handle: 'avila',
      left: 'silveradoAvilaLeftKey',
      right: 'silveradoAvilaRightKey',
      shankfinish: true,
      shankoverlay: true
    },
    {
      name: 'Bighorn',
      handle: 'bigHorn',
      left: 'silveradoBigHornLeftKey',
      right: 'silveradoBigHornRightKey',
      shankfinish: true,
      shankoverlay: true
    },
    {
      name: 'Cody',
      handle: 'cody',
      left: 'silveradoCodyLeftKey',
      right: 'silveradoCodyRightKey',
      shankfinish: true,
      shankoverlay: true
    },
    {
      name: 'Eva Marie',
      handle: 'evaMarie',
      left: 'silveradoEvaMarieLeftKey',
      right: 'silveradoEvaMarieRightKey',
      shankfinish: true,
      shankoverlay: true
    },
    {
      name: 'K2',
      handle: 'k2',
      left: 'silveradoK2LeftKey',
      right: 'silveradoK2RightKey',
      shankfinish: true,
      shankoverlay: true
    },
    {
      name: 'Powder River',
      handle: 'powderRiver',
      left: 'silveradoPowderRiverLeftKey',
      right: 'silveradoPowderRiverRightKey',
      shankfinish: true,
      shankoverlay: true
    },
    {
      name: 'Riviera',
      handle: 'riviera',
      left: 'silveradoRivieraLeftKey',
      right: 'silveradoRivieraRightKey',
      shankfinish: true,
      shankoverlay: true
    },
    {
      name: 'Santa Barbara',
      handle: 'santaBarbara',
      left: 'silveradoSantaBarbaraLeftKey',
      right: 'silveradoSantaBarbaraRightKey',
      shankfinish: true,
      shankoverlay: true
    },
    {
      name: 'Santa Barbara Short',
      handle: 'santaBarbaraShort',
      left: 'silveradoSantaBarbaraShortLeftKey',
      right: 'silveradoSantaBarbaraShortRightKey',
      shankfinish: true,
      shankoverlay: true
    },
    {
      name: 'Santa Maria',
      handle: 'santaMaria',
      left: 'silveradoSantaMariaLeftKey',
      right: 'silveradoSantaMariaRightKey',
      shankfinish: true,
      shankoverlay: true
    },
    {
      name: 'Sheridan',
      handle: 'sheridan',
      left: 'silveradoSheridanLeftKey',
      right: 'silveradoSheridanRightKey',
      shankfinish: true,
      shankoverlay: true
    },
    {
      name: 'Sheridan 7',
      handle: 'sheridan7',
      left: 'silveradoSheridan7LeftKey',
      right: 'silveradoSheridan7RightKey',
      shankfinish: true,
      shankoverlay: true
    },
    {
      name: 'Switchback',
      handle: 'switchback',
      left: 'silveradoSwitchbackLeftKey',
      right: 'silveradoSwitchbackRightKey',
      shankfinish: true,
      shankoverlay: true
    },
    {
      name: 'Tahoe',
      handle: 'tahoe',
      left: 'silveradoTahoeLeftKey',
      right: 'silveradoTahoeRightKey',
      shankfinish: true,
      shankoverlay: true
    },
    {
      name: 'Teton',
      handle: 'teton',
      left: 'silveradoTetonLeftKey',
      right: 'silveradoTetonRightKey',
      shankfinish: true,
      shankoverlay: true
    }
];
const selectshanksSilveradoRoll = [
    {
      name: 'Baseline Advantage Long',
      handle: 'baselineAdvantageLong',
      left: 'silveradoRollerBaseAdvLongLeftKey',
      right: 'silveradoRollerBaseAdvLongRightKey',
      shank: false,
      shankfinish: false,
      shankoverlay: false
    },
    {
      name: 'Baseline Long',
      handle: 'baselineLong',
      left: 'silveradoRollerBaseLongLeftKey',
      right: 'silveradoRollerBaseLongRightKey',
      shank: true,
      shankfinish: false,
      shankoverlay: false
    },
    {
      name: 'Baseline Advantage Short',
      handle: 'baselineAdvantageShort',
      left: 'silveradoRollerBaseAdvShortLeftKey',
      right: 'silveradoRollerBaseAdvShortRightKey',
      shank: true,
      shankfinish: false,
      shankoverlay: false
    },
    {
      name: 'Advantage Short',
      handle: 'advantageShort',
      left: 'silveradoRollerAdvShortLeftKey',
      right: 'silveradoRollerAdvShortRightKey',
      shank: true,
      shankfinish: true,
      shankoverlay: true
    },
    {
      name: 'Baseline Short',
      handle: 'baselineShort',
      left: 'silveradoRollerBaseShortLeftKey',
      right: 'silveradoRollerBaseShortRightKey',
      shank: true,
      shankfinish: false,
      shankoverlay: false
    },
    {
      name: 'Short',
      handle: 'short',
      left: 'silveradoRollerShortLeftKey',
      right: 'silveradoRollerShortRightKey',
      shank: true,
      shankfinish: true,
      shankoverlay: true
    },
    {
      name: 'Baseline Medium S',
      handle: 'baselineMedS',
      left: 'silveradoRollerBaseMedLeftKey',
      right: 'silveradoRollerBaseMedRightKey',
      shank: true,
      shankfinish: false,
      shankoverlay: false
    },
    {
      name: 'Medium S',
      handle: 'medS',
      left: 'silveradoRollerMedLeftKey',
      right: 'silveradoRollerMedRightKey',
      shank: true,
      shankfinish: true,
      shankoverlay: true
    },
    {
      name: 'Long S',
      handle: 'longS',
      left: 'silveradoRollerLongSLeftKey',
      right: 'silveradoRollerLongSRightKey',
      shankfinish: true,
      shankoverlay: true
    },
    {
      name: 'Long Ballhinge',
      handle: 'longBallhinge',
      left: 'silveradoRollerLongBallhingeLeftKey',
      right: 'silveradoRollerLongBallhingeRightKey',
      shankfinish: true,
      shankoverlay: true
    },
    {
      name: 'Long S Ballhinge',
      handle: 'longSBallhinge',
      left: 'silveradoRollerLongSBallhingeLeftKey',
      right: 'silveradoRollerLongSBallhingeRightKey',
      shankfinish: true,
      shankoverlay: true
    },
    {
      name: 'Long Horn',
      handle: 'longHorn',
      left: 'silveradoRollerLongHornLeftKey',
      right: 'silveradoRollerLongHornRightKey',
      shankfinish: true,
      shankoverlay: true
    },
    {
      name: 'Maverick',
      handle: 'maverick',
      left: 'silveradoRollerMaverickLeftKey',
      right: 'silveradoRollerMaverickRightKey',
      shankfinish: true,
      shankoverlay: true
    },
    {
      name: 'Medium S Ballhinge',
      handle: 'mediumSBallhinge',
      left: 'silveradoRollerMediumSBallhingeLeftKey',
      right: 'silveradoRollerMediumSBallhingeRightKey',
      shankfinish: true,
      shankoverlay: true
    },
    {
      name: 'Mustang',
      handle: 'mustang',
      left: 'silveradoRollerMustangLeftKey',
      right: 'silveradoRollerMustangRightKey',
      shankfinish: true,
      shankoverlay: true
    },
    {
      name: 'Predator',
      handle: 'predator',
      left: 'silveradoRollerPredatorLeftKey',
      right: 'silveradoRollerPredatorRightKey',
      shankfinish: true,
      shankoverlay: true
    },
    {
      name: 'Raptor',
      handle: 'raptor',
      left: 'silveradoRollerRaptorLeftKey',
      right: 'silveradoRollerRaptorRightKey',
      shankfinish: true,
      shankoverlay: true
    },
    {
      name: 'Short Ballhinge',
      handle: 'shortBallhinge',
      left: 'silveradoRollerShortBallhingeLeftKey',
      right: 'silveradoRollerShortBallhingeRightKey',
      shankfinish: true,
      shankoverlay: true
    },
    {
      name: 'Short S',
      handle: 'shortS',
      left: 'silveradoRollerShortSLeftKey',
      right: 'silveradoRollerShortSRightKey',
      shankfinish: true,
      shankoverlay: true
    },
    {
      name: 'Shorty',
      handle: 'shorty',
      left: 'silveradoRollerShortyLeftKey',
      right: 'silveradoRollerShortyRightKey',
      shankfinish: true,
      shankoverlay: true
    },
    {
      name: 'Shorty Ballhinge',
      handle: 'shortyBallhinge',
      left: 'silveradoRollerShortyBallhingeLeftKey',
      right: 'silveradoRollerShortyBallhingeRightKey',
      shankfinish: true,
      shankoverlay: true
    },
    {
      name: 'Short Horn',
      handle: 'shortHorn',
      left: 'silveradoRollerShortHornLeftKey',
      right: 'silveradoRollerShortHornRightKey',
      shankfinish: true,
      shankoverlay: true
    },
    {
      name: 'Sierra Ballhinge',
      handle: 'sierraBallhinge',
      left: 'silveradoRollerSierraBallhingeLeftKey',
      right: 'silveradoRollerSierraBallhingeRightKey',
      shankfinish: true,
      shankoverlay: true
    },
    {
      name: 'Avila',
      handle: 'avila',
      left: 'silveradoRollerAvilaLeftKey',
      right: 'silveradoRollerAvilaRightKey',
      shankfinish: true,
      shankoverlay: true
    },
    {
      name: 'Bighorn',
      handle: 'bigHorn',
      left: 'silveradoRollerBigHornLeftKey',
      right: 'silveradoRollerBigHornRightKey',
      shankfinish: true,
      shankoverlay: true
    },
    {
      name: 'Cody',
      handle: 'cody',
      left: 'silveradoRollerCodyLeftKey',
      right: 'silveradoRollerCodyRightKey',
      shankfinish: true,
      shankoverlay: true
    },
    {
      name: 'Eva Marie',
      handle: 'evaMarie',
      left: 'silveradoRollerEvaMarieLeftKey',
      right: 'silveradoRollerEvaMarieRightKey',
      shankfinish: true,
      shankoverlay: true
    },
    {
      name: 'K2',
      handle: 'k2',
      left: 'silveradoRollerK2LeftKey',
      right: 'silveradoRollerK2RightKey',
      shankfinish: true,
      shankoverlay: true
    },
    {
      name: 'Powder River',
      handle: 'powderRiver',
      left: 'silveradoRollerPowderRiverLeftKey',
      right: 'silveradoRollerPowderRiverRightKey',
      shankfinish: true,
      shankoverlay: true
    },
    {
      name: 'Riviera',
      handle: 'riviera',
      left: 'silveradoRollerRivieraLeftKey',
      right: 'silveradoRollerRivieraRightKey',
      shankfinish: true,
      shankoverlay: true
    },
    {
      name: 'Santa Barbara',
      handle: 'santaBarbara',
      left: 'silveradoRollerSantaBarbaraLeftKey',
      right: 'silveradoRollerSantaBarbaraRightKey',
      shankfinish: true,
      shankoverlay: true
    },
    {
      name: 'Santa Barbara Short',
      handle: 'santaBarbaraShort',
      left: 'silveradoRollerSantaBarbaraShortLeftKey',
      right: 'silveradoRollerSantaBarbaraShortRightKey',
      shankfinish: true,
      shankoverlay: true
    },
    {
      name: 'Santa Maria',
      handle: 'santaMaria',
      left: 'silveradoRollerSantaMariaLeftKey',
      right: 'silveradoRollerSantaMariaRightKey',
      shankfinish: true,
      shankoverlay: true
    },
    {
      name: 'Sheridan',
      handle: 'sheridan',
      left: 'silveradoRollerSheridanLeftKey',
      right: 'silveradoRollerSheridanRightKey',
      shankfinish: true,
      shankoverlay: true
    },
    {
      name: 'Sheridan 7',
      handle: 'sheridan7',
      left: 'silveradoRollerSheridan7LeftKey',
      right: 'silveradoRollerSheridan7RightKey',
      shankfinish: true,
      shankoverlay: true
    },
    {
      name: 'Switchback',
      handle: 'switchback',
      left: 'silveradoRollerSwitchbackLeftKey',
      right: 'silveradoRollerSwitchbackRightKey',
      shankfinish: true,
      shankoverlay: true
    },
    {
      name: 'Tahoe',
      handle: 'tahoe',
      left: 'silveradoRollerTahoeLeftKey',
      right: 'silveradoRollerTahoeRightKey',
      shankfinish: true,
      shankoverlay: true
    },
    {
      name: 'Teton',
      handle: 'teton',
      left: 'silveradoRollerTetonLeftKey',
      right: 'silveradoRollerTetonRightKey',
      shankfinish: true,
      shankoverlay: true
    }
];
const selectshanksTwistedLarge = [
    {
      name: 'Baseline Advantage Long',
      handle: 'baselineAdvantageLong',
      left: 'twistedLargeBaseAdvLongLeftKey',
      right: 'twistedLargeBaseAdvLongRightKey',
      shank: false,
      shankfinish: false,
      shankoverlay: false
    },
    {
      name: 'Advantage Long',
      handle: 'advantageLong',
      left: 'twistedLargeAdvLongLeftKey',
      right: 'twistedLargeAdvLongRightKey',
      shank: true,
      shankfinish: true,
      shankoverlay: true
    },
    {
      name: 'Baseline Long',
      handle: 'baselineLong',
      left: 'twistedLargeBaseLongLeftKey',
      right: 'twistedLargeBaseLongRightKey',
      shank: true,
      shankfinish: false,
      shankoverlay: false
    },
    {
      name: 'Long',
      handle: 'long',
      left: 'twistedLargeLongLeftKey',
      right: 'twistedLargeLongRightKey',
      shank: true,
      shankfinish: true,
      shankoverlay: true
    },
    {
      name: 'Baseline Advantage Short',
      handle: 'baselineAdvantageShort',
      left: 'twistedLargeBaseAdvShortLeftKey',
      right: 'twistedLargeBaseAdvShortRightKey',
      shank: true,
      shankfinish: false,
      shankoverlay: false
    },
    {
      name: 'Advantage Short',
      handle: 'advantageShort',
      left: 'twistedLargeAdvShortLeftKey',
      right: 'twistedLargeAdvShortRightKey',
      shank: true,
      shankfinish: true,
      shankoverlay: true
    },
    {
      name: 'Baseline Short',
      handle: 'baselineShort',
      left: 'twistedLargeBaseShortLeftKey',
      right: 'twistedLargeBaseShortRightKey',
      shank: true,
      shankfinish: false,
      shankoverlay: false
    },
    {
      name: 'Short',
      handle: 'short',
      left: 'twistedLargeShortLeftKey',
      right: 'twistedLargeShortRightKey',
      shank: true,
      shankfinish: true,
      shankoverlay: true
    },
    {
      name: 'Baseline Medium S',
      handle: 'baselineMedS',
      left: 'twistedLargeBaseMedLeftKey',
      right: 'twistedLargeBaseMedRightKey',
      shank: true,
      shankfinish: false,
      shankoverlay: false
    },
    {
      name: 'Medium S',
      handle: 'medS',
      left: 'twistedLargeMedLeftKey',
      right: 'twistedLargeMedRightKey',
      shank: true,
      shankfinish: true,
      shankoverlay: true
    },
    {
      name: 'Long S',
      handle: 'longS',
      left: 'twistedLargeLongSLeftKey',
      right: 'twistedLargeLongSRightKey',
      shankfinish: true,
      shankoverlay: true
    },
    {
      name: 'Long Ballhinge',
      handle: 'longBallhinge',
      left: 'twistedLargeLongBallhingeLeftKey',
      right: 'twistedLargeLongBallhingeRightKey',
      shankfinish: true,
      shankoverlay: true
    },
    {
      name: 'Long S Ballhinge',
      handle: 'longSBallhinge',
      left: 'twistedLargeLongSBallhingeLeftKey',
      right: 'twistedLargeLongSBallhingeRightKey',
      shankfinish: true,
      shankoverlay: true
    },
    {
      name: 'Long Horn',
      handle: 'longHorn',
      left: 'twistedLargeLongHornLeftKey',
      right: 'twistedLargeLongHornRightKey',
      shankfinish: true,
      shankoverlay: true
    },
    {
      name: 'Maverick',
      handle: 'maverick',
      left: 'twistedLargeMaverickLeftKey',
      right: 'twistedLargeMaverickRightKey',
      shankfinish: true,
      shankoverlay: true
    },
    {
      name: 'Medium S Ballhinge',
      handle: 'mediumSBallhinge',
      left: 'twistedLargeMediumSBallhingeLeftKey',
      right: 'twistedLargeMediumSBallhingeRightKey',
      shankfinish: true,
      shankoverlay: true
    },
    {
      name: 'Mustang',
      handle: 'mustang',
      left: 'twistedLargeMustangLeftKey',
      right: 'twistedLargeMustangRightKey',
      shankfinish: true,
      shankoverlay: true
    },
    {
      name: 'Predator',
      handle: 'predator',
      left: 'twistedLargePredatorLeftKey',
      right: 'twistedLargePredatorRightKey',
      shankfinish: true,
      shankoverlay: true
    },
    {
      name: 'Raptor',
      handle: 'raptor',
      left: 'twistedLargeRaptorLeftKey',
      right: 'twistedLargeRaptorRightKey',
      shankfinish: true,
      shankoverlay: true
    },
    {
      name: 'Short Ballhinge',
      handle: 'shortBallhinge',
      left: 'twistedLargeShortBallhingeLeftKey',
      right: 'twistedLargeShortBallhingeRightKey',
      shankfinish: true,
      shankoverlay: true
    },
    {
      name: 'Short S',
      handle: 'shortS',
      left: 'twistedLargeShortSLeftKey',
      right: 'twistedLargeShortSRightKey',
      shankfinish: true,
      shankoverlay: true
    },
    {
      name: 'Shorty',
      handle: 'shorty',
      left: 'twistedLargeShortyLeftKey',
      right: 'twistedLargeShortyRightKey',
      shankfinish: true,
      shankoverlay: true
    },
    {
      name: 'Shorty Ballhinge',
      handle: 'shortyBallhinge',
      left: 'twistedLargeShortyBallhingeLeftKey',
      right: 'twistedLargeShortyBallhingeRightKey',
      shankfinish: true,
      shankoverlay: true
    },
    {
      name: 'Short Horn',
      handle: 'shortHorn',
      left: 'twistedLargeShortHornLeftKey',
      right: 'twistedLargeShortHornRightKey',
      shankfinish: true,
      shankoverlay: true
    },
    {
      name: 'Sierra Ballhinge',
      handle: 'sierraBallhinge',
      left: 'twistedLargeSierraBallhingeLeftKey',
      right: 'twistedLargeSierraBallhingeRightKey',
      shankfinish: true,
      shankoverlay: true
    },
    {
      name: 'Avila',
      handle: 'avila',
      left: 'twistedLargeAvilaLeftKey',
      right: 'twistedLargeAvilaRightKey',
      shankfinish: true,
      shankoverlay: true
    },
    {
      name: 'Bighorn',
      handle: 'bigHorn',
      left: 'twistedLargeBigHornLeftKey',
      right: 'twistedLargeBigHornRightKey',
      shankfinish: true,
      shankoverlay: true
    },
    {
      name: 'Cody',
      handle: 'cody',
      left: 'twistedLargeCodyLeftKey',
      right: 'twistedLargeCodyRightKey',
      shankfinish: true,
      shankoverlay: true
    },
    {
      name: 'Eva Marie',
      handle: 'evaMarie',
      left: 'twistedLargeEvaMarieLeftKey',
      right: 'twistedLargeEvaMarieRightKey',
      shankfinish: true,
      shankoverlay: true
    },
    {
      name: 'K2',
      handle: 'k2',
      left: 'twistedLargeK2LeftKey',
      right: 'twistedLargeK2RightKey',
      shankfinish: true,
      shankoverlay: true
    },
    {
      name: 'Powder River',
      handle: 'powderRiver',
      left: 'twistedLargePowderRiverLeftKey',
      right: 'twistedLargePowderRiverRightKey',
      shankfinish: true,
      shankoverlay: true
    },
    {
      name: 'Riviera',
      handle: 'riviera',
      left: 'twistedLargeRivieraLeftKey',
      right: 'twistedLargeRivieraRightKey',
      shankfinish: true,
      shankoverlay: true
    },
    {
      name: 'Santa Barbara',
      handle: 'santaBarbara',
      left: 'twistedLargeSantaBarbaraLeftKey',
      right: 'twistedLargeSantaBarbaraRightKey',
      shankfinish: true,
      shankoverlay: true
    },
    {
      name: 'Santa Barbara Short',
      handle: 'santaBarbaraShort',
      left: 'twistedLargeSantaBarbaraShortLeftKey',
      right: 'twistedLargeSantaBarbaraShortRightKey',
      shankfinish: true,
      shankoverlay: true
    },
    {
      name: 'Santa Maria',
      handle: 'santaMaria',
      left: 'twistedLargeSantaMariaLeftKey',
      right: 'twistedLargeSantaMariaRightKey',
      shankfinish: true,
      shankoverlay: true
    },
    {
      name: 'Sheridan',
      handle: 'sheridan',
      left: 'twistedLargeSheridanLeftKey',
      right: 'twistedLargeSheridanRightKey',
      shankfinish: true,
      shankoverlay: true
    },
    {
      name: 'Sheridan 7',
      handle: 'sheridan7',
      left: 'twistedLargeSheridan7LeftKey',
      right: 'twistedLargeSheridan7RightKey',
      shankfinish: true,
      shankoverlay: true
    },
    {
      name: 'Switchback',
      handle: 'switchback',
      left: 'twistedLargeSwitchbackLeftKey',
      right: 'twistedLargeSwitchbackRightKey',
      shankfinish: true,
      shankoverlay: true
    },
    {
      name: 'Tahoe',
      handle: 'tahoe',
      left: 'twistedLargeTahoeLeftKey',
      right: 'twistedLargeTahoeRightKey',
      shankfinish: true,
      shankoverlay: true
    },
    {
      name: 'Teton',
      handle: 'teton',
      left: 'twistedLargeTetonLeftKey',
      right: 'twistedLargeTetonRightKey',
      shankfinish: true,
      shankoverlay: true
    },
    {
      name: 'Baseline D-Ring Snaffle',
      handle: 'baseline-dring',
      left: 'twistedLargeBaseDRingLeftKey',
      right: 'twistedLargeBaseDRingRightKey',
      shankfinish: true,
      shankoverlay: true
    },
    {
      name: 'D-Ring',
      handle: 'dRing',
      left: 'twistedLargeDRingLeftKey',
      right: 'twistedLargeDRingRightKey',
      shankfinish: true,
      shankoverlay: true
    },
    {
      name: 'Loose Ring',
      handle: 'looseRing',
      left: 'twistedLargeLooseRingLeftKey',
      right: 'twistedLargeLooseRingRightKey',
      shankfinish: true,
      shankoverlay: true
    },
    {
      name: 'West Coast',
      handle: 'westCoast',
      left: 'twistedLargeWestCoastLeftKey',
      right: 'twistedLargeWestCoastRightKey',
      shankfinish: true,
      shankoverlay: true
    },
    {
      name: 'Ballhinge Ring',
      handle: 'ballhingeRing',
      left: 'twistedLargeBallhingeRingLeftKey',
      right: 'twistedLargeBallhingeRingRightKey',
      shankfinish: true,
      shankoverlay: true
    },
    {
      name: 'Ballhinge D-Ring',
      handle: 'ballhingeDRing',
      left: 'twistedLargeBallhingeDRingLeftKey',
      right: 'twistedLargeBallhingeDRingRightKey',
      shankfinish: true,
      shankoverlay: true
    },
    {
      name: 'West Coast Divots & Dots',
      handle: 'westCoastDotsandDivots',
      left: 'twistedLargeWestCoastDandDLeftKey',
      right: 'twistedLargeWestCoastDandDRightKey',
      shankfinish: true,
      shankoverlay: true
    }
];
const selectshanksTwistedMedium = [
    {
      name: 'Baseline Advantage Long',
      handle: 'baselineAdvantageLong',
      left: 'twistedMediumBaseAdvLongLeftKey',
      right: 'twistedMediumBaseAdvLongRightKey',
      shank: false,
      shankfinish: false,
      shankoverlay: false
    },
    {
      name: 'Advantage Long',
      handle: 'advantageLong',
      left: 'twistedMediumAdvLongLeftKey',
      right: 'twistedMediumAdvLongRightKey',
      shank: true,
      shankfinish: true,
      shankoverlay: true
    },
    {
      name: 'Baseline Long',
      handle: 'baselineLong',
      left: 'twistedMediumBaseLongLeftKey',
      right: 'twistedMediumBaseLongRightKey',
      shank: true,
      shankfinish: false,
      shankoverlay: false
    },
    {
      name: 'Long',
      handle: 'long',
      left: 'twistedMediumLongLeftKey',
      right: 'twistedMediumLongRightKey',
      shank: true,
      shankfinish: true,
      shankoverlay: true
    },
    {
      name: 'Baseline Advantage Short',
      handle: 'baselineAdvantageShort',
      left: 'twistedMediumBaseAdvShortLeftKey',
      right: 'twistedMediumBaseAdvShortRightKey',
      shank: true,
      shankfinish: false,
      shankoverlay: false
    },
    {
      name: 'Advantage Short',
      handle: 'advantageShort',
      left: 'twistedMediumAdvShortLeftKey',
      right: 'twistedMediumAdvShortRightKey',
      shank: true,
      shankfinish: true,
      shankoverlay: true
    },
    {
      name: 'Baseline Short',
      handle: 'baselineShort',
      left: 'twistedMediumBaseShortLeftKey',
      right: 'twistedMediumBaseShortRightKey',
      shank: true,
      shankfinish: false,
      shankoverlay: false
    },
    {
      name: 'Short',
      handle: 'short',
      left: 'twistedMediumShortLeftKey',
      right: 'twistedMediumShortRightKey',
      shank: true,
      shankfinish: true,
      shankoverlay: true
    },
    {
      name: 'Baseline Medium S',
      handle: 'baselineMedS',
      left: 'twistedMediumBaseMedLeftKey',
      right: 'twistedMediumBaseMedRightKey',
      shank: true,
      shankfinish: false,
      shankoverlay: false
    },
    {
      name: 'Medium S',
      handle: 'medS',
      left: 'twistedMediumMedLeftKey',
      right: 'twistedMediumMedRightKey',
      shank: true,
      shankfinish: true,
      shankoverlay: true
    },
    {
      name: 'Long S',
      handle: 'longS',
      left: 'twistedMediumLongSLeftKey',
      right: 'twistedMediumLongSRightKey',
      shankfinish: true,
      shankoverlay: true
    },
    {
      name: 'Long Ballhinge',
      handle: 'longBallhinge',
      left: 'twistedMediumLongBallhingeLeftKey',
      right: 'twistedMediumLongBallhingeRightKey',
      shankfinish: true,
      shankoverlay: true
    },
    {
      name: 'Long S Ballhinge',
      handle: 'longSBallhinge',
      left: 'twistedMediumLongSBallhingeLeftKey',
      right: 'twistedMediumLongSBallhingeRightKey',
      shankfinish: true,
      shankoverlay: true
    },
    {
      name: 'Long Horn',
      handle: 'longHorn',
      left: 'twistedMediumLongHornLeftKey',
      right: 'twistedMediumLongHornRightKey',
      shankfinish: true,
      shankoverlay: true
    },
    {
      name: 'Maverick',
      handle: 'maverick',
      left: 'twistedMediumMaverickLeftKey',
      right: 'twistedMediumMaverickRightKey',
      shankfinish: true,
      shankoverlay: true
    },
    {
      name: 'Medium S Ballhinge',
      handle: 'mediumSBallhinge',
      left: 'twistedMediumMediumSBallhingeLeftKey',
      right: 'twistedMediumMediumSBallhingeRightKey',
      shankfinish: true,
      shankoverlay: true
    },
    {
      name: 'Mustang',
      handle: 'mustang',
      left: 'twistedMediumMustangLeftKey',
      right: 'twistedMediumMustangRightKey',
      shankfinish: true,
      shankoverlay: true
    },
    {
      name: 'Predator',
      handle: 'predator',
      left: 'twistedMediumPredatorLeftKey',
      right: 'twistedMediumPredatorRightKey',
      shankfinish: true,
      shankoverlay: true
    },
    {
      name: 'Raptor',
      handle: 'raptor',
      left: 'twistedMediumRaptorLeftKey',
      right: 'twistedMediumRaptorRightKey',
      shankfinish: true,
      shankoverlay: true
    },
    {
      name: 'Short Ballhinge',
      handle: 'shortBallhinge',
      left: 'twistedMediumShortBallhingeLeftKey',
      right: 'twistedMediumShortBallhingeRightKey',
      shankfinish: true,
      shankoverlay: true
    },
    {
      name: 'Short S',
      handle: 'shortS',
      left: 'twistedMediumShortSLeftKey',
      right: 'twistedMediumShortSRightKey',
      shankfinish: true,
      shankoverlay: true
    },
    {
      name: 'Shorty',
      handle: 'shorty',
      left: 'twistedMediumShortyLeftKey',
      right: 'twistedMediumShortyRightKey',
      shankfinish: true,
      shankoverlay: true
    },
    {
      name: 'Shorty Ballhinge',
      handle: 'shortyBallhinge',
      left: 'twistedMediumShortyBallhingeLeftKey',
      right: 'twistedMediumShortyBallhingeRightKey',
      shankfinish: true,
      shankoverlay: true
    },
    {
      name: 'Short Horn',
      handle: 'shortHorn',
      left: 'twistedMediumShortHornLeftKey',
      right: 'twistedMediumShortHornRightKey',
      shankfinish: true,
      shankoverlay: true
    },
    {
      name: 'Sierra Ballhinge',
      handle: 'sierraBallhinge',
      left: 'twistedMediumSierraBallhingeLeftKey',
      right: 'twistedMediumSierraBallhingeRightKey',
      shankfinish: true,
      shankoverlay: true
    },
    {
      name: 'Avila',
      handle: 'avila',
      left: 'twistedMediumAvilaLeftKey',
      right: 'twistedMediumAvilaRightKey',
      shankfinish: true,
      shankoverlay: true
    },
    {
      name: 'Bighorn',
      handle: 'bigHorn',
      left: 'twistedMediumBigHornLeftKey',
      right: 'twistedMediumBigHornRightKey',
      shankfinish: true,
      shankoverlay: true
    },
    {
      name: 'Cody',
      handle: 'cody',
      left: 'twistedMediumCodyLeftKey',
      right: 'twistedMediumCodyRightKey',
      shankfinish: true,
      shankoverlay: true
    },
    {
      name: 'Eva Marie',
      handle: 'evaMarie',
      left: 'twistedMediumEvaMarieLeftKey',
      right: 'twistedMediumEvaMarieRightKey',
      shankfinish: true,
      shankoverlay: true
    },
    {
      name: 'K2',
      handle: 'k2',
      left: 'twistedMediumK2LeftKey',
      right: 'twistedMediumK2RightKey',
      shankfinish: true,
      shankoverlay: true
    },
    {
      name: 'Powder River',
      handle: 'powderRiver',
      left: 'twistedMediumPowderRiverLeftKey',
      right: 'twistedMediumPowderRiverRightKey',
      shankfinish: true,
      shankoverlay: true
    },
    {
      name: 'Riviera',
      handle: 'riviera',
      left: 'twistedMediumRivieraLeftKey',
      right: 'twistedMediumRivieraRightKey',
      shankfinish: true,
      shankoverlay: true
    },
    {
      name: 'Santa Barbara',
      handle: 'santaBarbara',
      left: 'twistedMediumSantaBarbaraLeftKey',
      right: 'twistedMediumSantaBarbaraRightKey',
      shankfinish: true,
      shankoverlay: true
    },
    {
      name: 'Santa Barbara Short',
      handle: 'santaBarbaraShort',
      left: 'twistedMediumSantaBarbaraShortLeftKey',
      right: 'twistedMediumSantaBarbaraShortRightKey',
      shankfinish: true,
      shankoverlay: true
    },
    {
      name: 'Santa Maria',
      handle: 'santaMaria',
      left: 'twistedMediumSantaMariaLeftKey',
      right: 'twistedMediumSantaMariaRightKey',
      shankfinish: true,
      shankoverlay: true
    },
    {
      name: 'Sheridan',
      handle: 'sheridan',
      left: 'twistedMediumSheridanLeftKey',
      right: 'twistedMediumSheridanRightKey',
      shankfinish: true,
      shankoverlay: true
    },
    {
      name: 'Sheridan 7',
      handle: 'sheridan7',
      left: 'twistedMediumSheridan7LeftKey',
      right: 'twistedMediumSheridan7RightKey',
      shankfinish: true,
      shankoverlay: true
    },
    {
      name: 'Switchback',
      handle: 'switchback',
      left: 'twistedMediumSwitchbackLeftKey',
      right: 'twistedMediumSwitchbackRightKey',
      shankfinish: true,
      shankoverlay: true
    },
    {
      name: 'Tahoe',
      handle: 'tahoe',
      left: 'twistedMediumTahoeLeftKey',
      right: 'twistedMediumTahoeRightKey',
      shankfinish: true,
      shankoverlay: true
    },
    {
      name: 'Teton',
      handle: 'teton',
      left: 'twistedMediumTetonLeftKey',
      right: 'twistedMediumTetonRightKey',
      shankfinish: true,
      shankoverlay: true
    },
    {
      name: 'Baseline D-Ring Snaffle',
      handle: 'baseline-dring',
      left: 'twistedMediumBaseDRingLeftKey',
      right: 'twistedMediumBaseDRingRightKey',
      shankfinish: true,
      shankoverlay: true
    },
    {
      name: 'D-Ring',
      handle: 'dRing',
      left: 'twistedMediumDRingLeftKey',
      right: 'twistedMediumDRingRightKey',
      shankfinish: true,
      shankoverlay: true
    },
    {
      name: 'Loose Ring',
      handle: 'looseRing',
      left: 'twistedMediumLooseRingLeftKey',
      right: 'twistedMediumLooseRingRightKey',
      shankfinish: true,
      shankoverlay: true
    },
    {
      name: 'West Coast',
      handle: 'westCoast',
      left: 'twistedMediumWestCoastLeftKey',
      right: 'twistedMediumWestCoastRightKey',
      shankfinish: true,
      shankoverlay: true
    },
    {
      name: 'Ballhinge Ring',
      handle: 'ballhingeRing',
      left: 'twistedMediumBallhingeRingLeftKey',
      right: 'twistedMediumBallhingeRingRightKey',
      shankfinish: true,
      shankoverlay: true
    },
    {
      name: 'Ballhinge D-Ring',
      handle: 'ballhingeDRing',
      left: 'twistedMediumBallhingeDRingLeftKey',
      right: 'twistedMediumBallhingeDRingRightKey',
      shankfinish: true,
      shankoverlay: true
    },
    {
      name: 'West Coast Divots & Dots',
      handle: 'westCoastDotsandDivots',
      left: 'twistedMediumWestCoastDandDLeftKey',
      right: 'twistedMediumWestCoastDandDRightKey',
      shankfinish: true,
      shankoverlay: true
    }
];
const selectshanksTwistedSmall = [
    {
      name: 'Baseline Advantage Long',
      handle: 'baselineAdvantageLong',
      left: 'twistedSmallBaseAdvLongLeftKey',
      right: 'twistedSmallBaseAdvLongRightKey',
      shank: false,
      shankfinish: false,
      shankoverlay: false
    },
    {
      name: 'Baseline Long',
      handle: 'baselineLong',
      left: 'twistedSmallBaseLongLeftKey',
      right: 'twistedSmallBaseLongRightKey',
      shank: true,
      shankfinish: false,
      shankoverlay: false
    },
    {
      name: 'Baseline Advantage Short',
      handle: 'baselineAdvantageShort',
      left: 'twistedSmallBaseAdvShortLeftKey',
      right: 'twistedSmallBaseAdvShortRightKey',
      shank: true,
      shankfinish: false,
      shankoverlay: false
    },
    {
      name: 'Advantage Short',
      handle: 'advantageShort',
      left: 'twistedSmallAdvShortLeftKey',
      right: 'twistedSmallAdvShortRightKey',
      shank: true,
      shankfinish: true,
      shankoverlay: true
    },
    {
      name: 'Baseline Short',
      handle: 'baselineShort',
      left: 'twistedSmallBaseShortLeftKey',
      right: 'twistedSmallBaseShortRightKey',
      shank: true,
      shankfinish: false,
      shankoverlay: false
    },
    {
      name: 'Short',
      handle: 'short',
      left: 'twistedSmallShortLeftKey',
      right: 'twistedSmallShortRightKey',
      shank: true,
      shankfinish: true,
      shankoverlay: true
    },
    {
      name: 'Baseline Medium S',
      handle: 'baselineMedS',
      left: 'twistedSmallBaseMedLeftKey',
      right: 'twistedSmallBaseMedRightKey',
      shank: true,
      shankfinish: false,
      shankoverlay: false
    },
    {
      name: 'Medium S',
      handle: 'medS',
      left: 'twistedSmallMedLeftKey',
      right: 'twistedSmallMedRightKey',
      shank: true,
      shankfinish: true,
      shankoverlay: true
    },
    {
      name: 'Long S',
      handle: 'longS',
      left: 'twistedSmallLongSLeftKey',
      right: 'twistedSmallLongSRightKey',
      shankfinish: true,
      shankoverlay: true
    },
    {
      name: 'Long Ballhinge',
      handle: 'longBallhinge',
      left: 'twistedSmallLongBallhingeLeftKey',
      right: 'twistedSmallLongBallhingeRightKey',
      shankfinish: true,
      shankoverlay: true
    },
    {
      name: 'Long S Ballhinge',
      handle: 'longSBallhinge',
      left: 'twistedSmallLongSBallhingeLeftKey',
      right: 'twistedSmallLongSBallhingeRightKey',
      shankfinish: true,
      shankoverlay: true
    },
    {
      name: 'Long Horn',
      handle: 'longHorn',
      left: 'twistedSmallLongHornLeftKey',
      right: 'twistedSmallLongHornRightKey',
      shankfinish: true,
      shankoverlay: true
    },
    {
      name: 'Maverick',
      handle: 'maverick',
      left: 'twistedSmallMaverickLeftKey',
      right: 'twistedSmallMaverickRightKey',
      shankfinish: true,
      shankoverlay: true
    },
    {
      name: 'Medium S Ballhinge',
      handle: 'mediumSBallhinge',
      left: 'twistedSmallMediumSBallhingeLeftKey',
      right: 'twistedSmallMediumSBallhingeRightKey',
      shankfinish: true,
      shankoverlay: true
    },
    {
      name: 'Mustang',
      handle: 'mustang',
      left: 'twistedSmallMustangLeftKey',
      right: 'twistedSmallMustangRightKey',
      shankfinish: true,
      shankoverlay: true
    },
    {
      name: 'Predator',
      handle: 'predator',
      left: 'twistedSmallPredatorLeftKey',
      right: 'twistedSmallPredatorRightKey',
      shankfinish: true,
      shankoverlay: true
    },
    {
      name: 'Raptor',
      handle: 'raptor',
      left: 'twistedSmallRaptorLeftKey',
      right: 'twistedSmallRaptorRightKey',
      shankfinish: true,
      shankoverlay: true
    },
    {
      name: 'Short Ballhinge',
      handle: 'shortBallhinge',
      left: 'twistedSmallShortBallhingeLeftKey',
      right: 'twistedSmallShortBallhingeRightKey',
      shankfinish: true,
      shankoverlay: true
    },
    {
      name: 'Short S',
      handle: 'shortS',
      left: 'twistedSmallShortSLeftKey',
      right: 'twistedSmallShortSRightKey',
      shankfinish: true,
      shankoverlay: true
    },
    {
      name: 'Shorty',
      handle: 'shorty',
      left: 'twistedSmallShortyLeftKey',
      right: 'twistedSmallShortyRightKey',
      shankfinish: true,
      shankoverlay: true
    },
    {
      name: 'Shorty Ballhinge',
      handle: 'shortyBallhinge',
      left: 'twistedSmallShortyBallhingeLeftKey',
      right: 'twistedSmallShortyBallhingeRightKey',
      shankfinish: true,
      shankoverlay: true
    },
    {
      name: 'Short Horn',
      handle: 'shortHorn',
      left: 'twistedSmallShortHornLeftKey',
      right: 'twistedSmallShortHornRightKey',
      shankfinish: true,
      shankoverlay: true
    },
    {
      name: 'Sierra Ballhinge',
      handle: 'sierraBallhinge',
      left: 'twistedSmallSierraBallhingeLeftKey',
      right: 'twistedSmallSierraBallhingeRightKey',
      shankfinish: true,
      shankoverlay: true
    },
    {
      name: 'Avila',
      handle: 'avila',
      left: 'twistedSmallAvilaLeftKey',
      right: 'twistedSmallAvilaRightKey',
      shankfinish: true,
      shankoverlay: true
    },
    {
      name: 'Bighorn',
      handle: 'bigHorn',
      left: 'twistedSmallBigHornLeftKey',
      right: 'twistedSmallBigHornRightKey',
      shankfinish: true,
      shankoverlay: true
    },
    {
      name: 'Cody',
      handle: 'cody',
      left: 'twistedSmallCodyLeftKey',
      right: 'twistedSmallCodyRightKey',
      shankfinish: true,
      shankoverlay: true
    },
    {
      name: 'Eva Marie',
      handle: 'evaMarie',
      left: 'twistedSmallEvaMarieLeftKey',
      right: 'twistedSmallEvaMarieRightKey',
      shankfinish: true,
      shankoverlay: true
    },
    {
      name: 'K2',
      handle: 'k2',
      left: 'twistedSmallK2LeftKey',
      right: 'twistedSmallK2RightKey',
      shankfinish: true,
      shankoverlay: true
    },
    {
      name: 'Powder River',
      handle: 'powderRiver',
      left: 'twistedSmallPowderRiverLeftKey',
      right: 'twistedSmallPowderRiverRightKey',
      shankfinish: true,
      shankoverlay: true
    },
    {
      name: 'Riviera',
      handle: 'riviera',
      left: 'twistedSmallRivieraLeftKey',
      right: 'twistedSmallRivieraRightKey',
      shankfinish: true,
      shankoverlay: true
    },
    {
      name: 'Santa Barbara',
      handle: 'santaBarbara',
      left: 'twistedSmallSantaBarbaraLeftKey',
      right: 'twistedSmallSantaBarbaraRightKey',
      shankfinish: true,
      shankoverlay: true
    },
    {
      name: 'Santa Barbara Short',
      handle: 'santaBarbaraShort',
      left: 'twistedSmallSantaBarbaraShortLeftKey',
      right: 'twistedSmallSantaBarbaraShortRightKey',
      shankfinish: true,
      shankoverlay: true
    },
    {
      name: 'Santa Maria',
      handle: 'santaMaria',
      left: 'twistedSmallSantaMariaLeftKey',
      right: 'twistedSmallSantaMariaRightKey',
      shankfinish: true,
      shankoverlay: true
    },
    {
      name: 'Sheridan',
      handle: 'sheridan',
      left: 'twistedSmallSheridanLeftKey',
      right: 'twistedSmallSheridanRightKey',
      shankfinish: true,
      shankoverlay: true
    },
    {
      name: 'Sheridan 7',
      handle: 'sheridan7',
      left: 'twistedSmallSheridan7LeftKey',
      right: 'twistedSmallSheridan7RightKey',
      shankfinish: true,
      shankoverlay: true
    },
    {
      name: 'Switchback',
      handle: 'switchback',
      left: 'twistedSmallSwitchbackLeftKey',
      right: 'twistedSmallSwitchbackRightKey',
      shankfinish: true,
      shankoverlay: true
    },
    {
      name: 'Tahoe',
      handle: 'tahoe',
      left: 'twistedSmallTahoeLeftKey',
      right: 'twistedSmallTahoeRightKey',
      shankfinish: true,
      shankoverlay: true
    },
    {
      name: 'Teton',
      handle: 'teton',
      left: 'twistedSmallTetonLeftKey',
      right: 'twistedSmallTetonRightKey',
      shankfinish: true,
      shankoverlay: true
    },
    {
      name: 'Baseline D-Ring Snaffle',
      handle: 'baseline-dring',
      left: 'twistedSmallBaseDRingLeftKey',
      right: 'twistedSmallBaseDRingRightKey',
      shankfinish: true,
      shankoverlay: true
    },
    {
      name: 'D-Ring',
      handle: 'dRing',
      left: 'twistedSmallDRingLeftKey',
      right: 'twistedSmallDRingRightKey',
      shankfinish: true,
      shankoverlay: true
    },
    {
      name: 'Loose Ring',
      handle: 'looseRing',
      left: 'twistedSmallLooseRingLeftKey',
      right: 'twistedSmallLooseRingRightKey',
      shankfinish: true,
      shankoverlay: true
    },
    {
      name: 'West Coast',
      handle: 'westCoast',
      left: 'twistedSmallWestCoastLeftKey',
      right: 'twistedSmallWestCoastRightKey',
      shankfinish: true,
      shankoverlay: true
    },
    {
      name: 'Ballhinge Ring',
      handle: 'ballhingeRing',
      left: 'twistedSmallBallhingeRingLeftKey',
      right: 'twistedSmallBallhingeRingRightKey',
      shankfinish: true,
      shankoverlay: true
    },
    {
      name: 'Ballhinge D-Ring',
      handle: 'ballhingeDRing',
      left: 'twistedSmallBallhingeDRingLeftKey',
      right: 'twistedSmallBallhingeDRingRightKey',
      shankfinish: true,
      shankoverlay: true
    },
    {
      name: 'West Coast Divots & Dots',
      handle: 'westCoastDotsandDivots',
      left: 'twistedSmallWestCoastDandDLeftKey',
      right: 'twistedSmallWestCoastDandDRightKey',
      shankfinish: true,
      shankoverlay: true
    }
];
const selectshanksTwistedHex = [
    {
      name: 'Baseline Advantage Long',
      handle: 'baselineAdvantageLong',
      left: 'twistedHexBaseAdvLongLeftKey',
      right: 'twistedHexBaseAdvLongRightKey',
      shank: false,
      shankfinish: false,
      shankoverlay: false
    },
    {
      name: 'Advantage Long',
      handle: 'advantageLong',
      left: 'twistedHexAdvLongLeftKey',
      right: 'twistedHexAdvLongRightKey',
      shank: true,
      shankfinish: true,
      shankoverlay: true
    },
    {
      name: 'Baseline Long',
      handle: 'baselineLong',
      left: 'twistedHexBaseLongLeftKey',
      right: 'twistedHexBaseLongRightKey',
      shank: true,
      shankfinish: false,
      shankoverlay: false
    },
    {
      name: 'Long',
      handle: 'long',
      left: 'twistedHexLongLeftKey',
      right: 'twistedHexLongRightKey',
      shank: true,
      shankfinish: true,
      shankoverlay: true
    },
    {
      name: 'Baseline Advantage Short',
      handle: 'baselineAdvantageShort',
      left: 'twistedHexBaseAdvShortLeftKey',
      right: 'twistedHexBaseAdvShortRightKey',
      shank: true,
      shankfinish: false,
      shankoverlay: false
    },
    {
      name: 'Advantage Short',
      handle: 'advantageShort',
      left: 'twistedHexAdvShortLeftKey',
      right: 'twistedHexAdvShortRightKey',
      shank: true,
      shankfinish: true,
      shankoverlay: true
    },
    {
      name: 'Baseline Short',
      handle: 'baselineShort',
      left: 'twistedHexBaseShortLeftKey',
      right: 'twistedHexBaseShortRightKey',
      shank: true,
      shankfinish: false,
      shankoverlay: false
    },
    {
      name: 'Short',
      handle: 'short',
      left: 'twistedHexShortLeftKey',
      right: 'twistedHexShortRightKey',
      shank: true,
      shankfinish: true,
      shankoverlay: true
    },
    {
      name: 'Baseline Medium S',
      handle: 'baselineMedS',
      left: 'twistedHexBaseMedLeftKey',
      right: 'twistedHexBaseMedRightKey',
      shank: true,
      shankfinish: false,
      shankoverlay: false
    },
    {
      name: 'Medium S',
      handle: 'medS',
      left: 'twistedHexMedLeftKey',
      right: 'twistedHexMedRightKey',
      shank: true,
      shankfinish: true,
      shankoverlay: true
    },
    {
      name: 'Long S',
      handle: 'longS',
      left: 'twistedHexLongSLeftKey',
      right: 'twistedHexLongSRightKey',
      shankfinish: true,
      shankoverlay: true
    },
    {
      name: 'Long Ballhinge',
      handle: 'longBallhinge',
      left: 'twistedHexLongBallhingeLeftKey',
      right: 'twistedHexLongBallhingeRightKey',
      shankfinish: true,
      shankoverlay: true
    },
    {
      name: 'Long S Ballhinge',
      handle: 'longSBallhinge',
      left: 'twistedHexLongSBallhingeLeftKey',
      right: 'twistedHexLongSBallhingeRightKey',
      shankfinish: true,
      shankoverlay: true
    },
    {
      name: 'Long Horn',
      handle: 'longHorn',
      left: 'twistedHexLongHornLeftKey',
      right: 'twistedHexLongHornRightKey',
      shankfinish: true,
      shankoverlay: true
    },
    {
      name: 'Maverick',
      handle: 'maverick',
      left: 'twistedHexMaverickLeftKey',
      right: 'twistedHexMaverickRightKey',
      shankfinish: true,
      shankoverlay: true
    },
    {
      name: 'Medium S Ballhinge',
      handle: 'mediumSBallhinge',
      left: 'twistedHexMediumSBallhingeLeftKey',
      right: 'twistedHexMediumSBallhingeRightKey',
      shankfinish: true,
      shankoverlay: true
    },
    {
      name: 'Mustang',
      handle: 'mustang',
      left: 'twistedHexMustangLeftKey',
      right: 'twistedHexMustangRightKey',
      shankfinish: true,
      shankoverlay: true
    },
    {
      name: 'Predator',
      handle: 'predator',
      left: 'twistedHexPredatorLeftKey',
      right: 'twistedHexPredatorRightKey',
      shankfinish: true,
      shankoverlay: true
    },
    {
      name: 'Raptor',
      handle: 'raptor',
      left: 'twistedHexRaptorLeftKey',
      right: 'twistedHexRaptorRightKey',
      shankfinish: true,
      shankoverlay: true
    },
    {
      name: 'Short Ballhinge',
      handle: 'shortBallhinge',
      left: 'twistedHexShortBallhingeLeftKey',
      right: 'twistedHexShortBallhingeRightKey',
      shankfinish: true,
      shankoverlay: true
    },
    {
      name: 'Short S',
      handle: 'shortS',
      left: 'twistedHexShortSLeftKey',
      right: 'twistedHexShortSRightKey',
      shankfinish: true,
      shankoverlay: true
    },
    {
      name: 'Shorty',
      handle: 'shorty',
      left: 'twistedHexShortyLeftKey',
      right: 'twistedHexShortyRightKey',
      shankfinish: true,
      shankoverlay: true
    },
    {
      name: 'Shorty Ballhinge',
      handle: 'shortyBallhinge',
      left: 'twistedHexShortyBallhingeLeftKey',
      right: 'twistedHexShortyBallhingeRightKey',
      shankfinish: true,
      shankoverlay: true
    },
    {
      name: 'Short Horn',
      handle: 'shortHorn',
      left: 'twistedHexShortHornLeftKey',
      right: 'twistedHexShortHornRightKey',
      shankfinish: true,
      shankoverlay: true
    },
    {
      name: 'Sierra Ballhinge',
      handle: 'sierraBallhinge',
      left: 'twistedHexSierraBallhingeLeftKey',
      right: 'twistedHexSierraBallhingeRightKey',
      shankfinish: true,
      shankoverlay: true
    },
    {
      name: 'Avila',
      handle: 'avila',
      left: 'twistedHexAvilaLeftKey',
      right: 'twistedHexAvilaRightKey',
      shankfinish: true,
      shankoverlay: true
    },
    {
      name: 'Bighorn',
      handle: 'bigHorn',
      left: 'twistedHexBigHornLeftKey',
      right: 'twistedHexBigHornRightKey',
      shankfinish: true,
      shankoverlay: true
    },
    {
      name: 'Cody',
      handle: 'cody',
      left: 'twistedHexCodyLeftKey',
      right: 'twistedHexCodyRightKey',
      shankfinish: true,
      shankoverlay: true
    },
    {
      name: 'Eva Marie',
      handle: 'evaMarie',
      left: 'twistedHexEvaMarieLeftKey',
      right: 'twistedHexEvaMarieRightKey',
      shankfinish: true,
      shankoverlay: true
    },
    {
      name: 'K2',
      handle: 'k2',
      left: 'twistedHexK2LeftKey',
      right: 'twistedHexK2RightKey',
      shankfinish: true,
      shankoverlay: true
    },
    {
      name: 'Powder River',
      handle: 'powderRiver',
      left: 'twistedHexPowderRiverLeftKey',
      right: 'twistedHexPowderRiverRightKey',
      shankfinish: true,
      shankoverlay: true
    },
    {
      name: 'Riviera',
      handle: 'riviera',
      left: 'twistedHexRivieraLeftKey',
      right: 'twistedHexRivieraRightKey',
      shankfinish: true,
      shankoverlay: true
    },
    {
      name: 'Santa Barbara',
      handle: 'santaBarbara',
      left: 'twistedHexSantaBarbaraLeftKey',
      right: 'twistedHexSantaBarbaraRightKey',
      shankfinish: true,
      shankoverlay: true
    },
    {
      name: 'Santa Barbara Short',
      handle: 'santaBarbaraShort',
      left: 'twistedHexSantaBarbaraShortLeftKey',
      right: 'twistedHexSantaBarbaraShortRightKey',
      shankfinish: true,
      shankoverlay: true
    },
    {
      name: 'Santa Maria',
      handle: 'santaMaria',
      left: 'twistedHexSantaMariaLeftKey',
      right: 'twistedHexSantaMariaRightKey',
      shankfinish: true,
      shankoverlay: true
    },
    {
      name: 'Sheridan',
      handle: 'sheridan',
      left: 'twistedHexSheridanLeftKey',
      right: 'twistedHexSheridanRightKey',
      shankfinish: true,
      shankoverlay: true
    },
    {
      name: 'Sheridan 7',
      handle: 'sheridan7',
      left: 'twistedHexSheridan7LeftKey',
      right: 'twistedHexSheridan7RightKey',
      shankfinish: true,
      shankoverlay: true
    },
    {
      name: 'Switchback',
      handle: 'switchback',
      left: 'twistedHexSwitchbackLeftKey',
      right: 'twistedHexSwitchbackRightKey',
      shankfinish: true,
      shankoverlay: true
    },
    {
      name: 'Tahoe',
      handle: 'tahoe',
      left: 'twistedHexTahoeLeftKey',
      right: 'twistedHexTahoeRightKey',
      shankfinish: true,
      shankoverlay: true
    },
    {
      name: 'Teton',
      handle: 'teton',
      left: 'twistedHexTetonLeftKey',
      right: 'twistedHexTetonRightKey',
      shankfinish: true,
      shankoverlay: true
    },
    {
      name: 'Baseline D-Ring Snaffle',
      handle: 'baseline-dring',
      left: 'twistedHexBaseDRingLeftKey',
      right: 'twistedHexBaseDRingRightKey',
      shankfinish: true,
      shankoverlay: true
    },
    {
      name: 'D-Ring',
      handle: 'dRing',
      left: 'twistedHexDRingLeftKey',
      right: 'twistedHexDRingRightKey',
      shankfinish: true,
      shankoverlay: true
    },
    {
      name: 'Loose Ring',
      handle: 'looseRing',
      left: 'twistedHexLooseRingLeftKey',
      right: 'twistedHexLooseRingRightKey',
      shankfinish: true,
      shankoverlay: true
    },
    {
      name: 'West Coast',
      handle: 'westCoast',
      left: 'twistedHexWestCoastLeftKey',
      right: 'twistedHexWestCoastRightKey',
      shankfinish: true,
      shankoverlay: true
    },
    {
      name: 'Ballhinge Ring',
      handle: 'ballhingeRing',
      left: 'twistedHexBallhingeRingLeftKey',
      right: 'twistedHexBallhingeRingRightKey',
      shankfinish: true,
      shankoverlay: true
    },
    {
      name: 'Ballhinge D-Ring',
      handle: 'ballhingeDRing',
      left: 'twistedHexBallhingeDRingLeftKey',
      right: 'twistedHexBallhingeDRingRightKey',
      shankfinish: true,
      shankoverlay: true
    },
    {
      name: 'West Coast Divots & Dots',
      handle: 'westCoastDotsandDivots',
      left: 'twistedHexWestCoastDandDLeftKey',
      right: 'twistedHexWestCoastDandDRightKey',
      shankfinish: true,
      shankoverlay: true
    }
];
const selectshanksTwistedSquare = [
    {
      name: 'Baseline Advantage Long',
      handle: 'baselineAdvantageLong',
      left: 'twistedSquareBaseAdvLongLeftKey',
      right: 'twistedSquareBaseAdvLongRightKey',
      shank: false,
      shankfinish: false,
      shankoverlay: false
    },
    {
      name: 'Advantage Long',
      handle: 'advantageLong',
      left: 'twistedSquareAdvLongLeftKey',
      right: 'twistedSquareAdvLongRightKey',
      shank: true,
      shankfinish: true,
      shankoverlay: true
    },
    {
      name: 'Baseline Long',
      handle: 'baselineLong',
      left: 'twistedSquareBaseLongLeftKey',
      right: 'twistedSquareBaseLongRightKey',
      shank: true,
      shankfinish: false,
      shankoverlay: false
    },
    {
      name: 'Long',
      handle: 'long',
      left: 'twistedSquareLongLeftKey',
      right: 'twistedSquareLongRightKey',
      shank: true,
      shankfinish: true,
      shankoverlay: true
    },
    {
      name: 'Baseline Advantage Short',
      handle: 'baselineAdvantageShort',
      left: 'twistedSquareBaseAdvShortLeftKey',
      right: 'twistedSquareBaseAdvShortRightKey',
      shank: true,
      shankfinish: false,
      shankoverlay: false
    },
    {
      name: 'Advantage Short',
      handle: 'advantageShort',
      left: 'twistedSquareAdvShortLeftKey',
      right: 'twistedSquareAdvShortRightKey',
      shank: true,
      shankfinish: true,
      shankoverlay: true
    },
    {
      name: 'Baseline Short',
      handle: 'baselineShort',
      left: 'twistedSquareBaseShortLeftKey',
      right: 'twistedSquareBaseShortRightKey',
      shank: true,
      shankfinish: false,
      shankoverlay: false
    },
    {
      name: 'Short',
      handle: 'short',
      left: 'twistedSquareShortLeftKey',
      right: 'twistedSquareShortRightKey',
      shank: true,
      shankfinish: true,
      shankoverlay: true
    },
    {
      name: 'Baseline Medium S',
      handle: 'baselineMedS',
      left: 'twistedSquareBaseMedLeftKey',
      right: 'twistedSquareBaseMedRightKey',
      shank: true,
      shankfinish: false,
      shankoverlay: false
    },
    {
      name: 'Medium S',
      handle: 'medS',
      left: 'twistedSquareMedLeftKey',
      right: 'twistedSquareMedRightKey',
      shank: true,
      shankfinish: true,
      shankoverlay: true
    },
    {
      name: 'Long S',
      handle: 'longS',
      left: 'twistedSquareLongSLeftKey',
      right: 'twistedSquareLongSRightKey',
      shankfinish: true,
      shankoverlay: true
    },
    {
      name: 'Long Ballhinge',
      handle: 'longBallhinge',
      left: 'twistedSquareLongBallhingeLeftKey',
      right: 'twistedSquareLongBallhingeRightKey',
      shankfinish: true,
      shankoverlay: true
    },
    {
      name: 'Long S Ballhinge',
      handle: 'longSBallhinge',
      left: 'twistedSquareLongSBallhingeLeftKey',
      right: 'twistedSquareLongSBallhingeRightKey',
      shankfinish: true,
      shankoverlay: true
    },
    {
      name: 'Long Horn',
      handle: 'longHorn',
      left: 'twistedSquareLongHornLeftKey',
      right: 'twistedSquareLongHornRightKey',
      shankfinish: true,
      shankoverlay: true
    },
    {
      name: 'Maverick',
      handle: 'maverick',
      left: 'twistedSquareMaverickLeftKey',
      right: 'twistedSquareMaverickRightKey',
      shankfinish: true,
      shankoverlay: true
    },
    {
      name: 'Medium S Ballhinge',
      handle: 'mediumSBallhinge',
      left: 'twistedSquareMediumSBallhingeLeftKey',
      right: 'twistedSquareMediumSBallhingeRightKey',
      shankfinish: true,
      shankoverlay: true
    },
    {
      name: 'Mustang',
      handle: 'mustang',
      left: 'twistedSquareMustangLeftKey',
      right: 'twistedSquareMustangRightKey',
      shankfinish: true,
      shankoverlay: true
    },
    {
      name: 'Predator',
      handle: 'predator',
      left: 'twistedSquarePredatorLeftKey',
      right: 'twistedSquarePredatorRightKey',
      shankfinish: true,
      shankoverlay: true
    },
    {
      name: 'Raptor',
      handle: 'raptor',
      left: 'twistedSquareRaptorLeftKey',
      right: 'twistedSquareRaptorRightKey',
      shankfinish: true,
      shankoverlay: true
    },
    {
      name: 'Short Ballhinge',
      handle: 'shortBallhinge',
      left: 'twistedSquareShortBallhingeLeftKey',
      right: 'twistedSquareShortBallhingeRightKey',
      shankfinish: true,
      shankoverlay: true
    },
    {
      name: 'Short S',
      handle: 'shortS',
      left: 'twistedSquareShortSLeftKey',
      right: 'twistedSquareShortSRightKey',
      shankfinish: true,
      shankoverlay: true
    },
    {
      name: 'Shorty',
      handle: 'shorty',
      left: 'twistedSquareShortyLeftKey',
      right: 'twistedSquareShortyRightKey',
      shankfinish: true,
      shankoverlay: true
    },
    {
      name: 'Shorty Ballhinge',
      handle: 'shortyBallhinge',
      left: 'twistedSquareShortyBallhingeLeftKey',
      right: 'twistedSquareShortyBallhingeRightKey',
      shankfinish: true,
      shankoverlay: true
    },
    {
      name: 'Short Horn',
      handle: 'shortHorn',
      left: 'twistedSquareShortHornLeftKey',
      right: 'twistedSquareShortHornRightKey',
      shankfinish: true,
      shankoverlay: true
    },
    {
      name: 'Sierra Ballhinge',
      handle: 'sierraBallhinge',
      left: 'twistedSquareSierraBallhingeLeftKey',
      right: 'twistedSquareSierraBallhingeRightKey',
      shankfinish: true,
      shankoverlay: true
    },
    {
      name: 'Avila',
      handle: 'avila',
      left: 'twistedSquareAvilaLeftKey',
      right: 'twistedSquareAvilaRightKey',
      shankfinish: true,
      shankoverlay: true
    },
    {
      name: 'Bighorn',
      handle: 'bigHorn',
      left: 'twistedSquareBigHornLeftKey',
      right: 'twistedSquareBigHornRightKey',
      shankfinish: true,
      shankoverlay: true
    },
    {
      name: 'Cody',
      handle: 'cody',
      left: 'twistedSquareCodyLeftKey',
      right: 'twistedSquareCodyRightKey',
      shankfinish: true,
      shankoverlay: true
    },
    {
      name: 'Eva Marie',
      handle: 'evaMarie',
      left: 'twistedSquareEvaMarieLeftKey',
      right: 'twistedSquareEvaMarieRightKey',
      shankfinish: true,
      shankoverlay: true
    },
    {
      name: 'K2',
      handle: 'k2',
      left: 'twistedSquareK2LeftKey',
      right: 'twistedSquareK2RightKey',
      shankfinish: true,
      shankoverlay: true
    },
    {
      name: 'Powder River',
      handle: 'powderRiver',
      left: 'twistedSquarePowderRiverLeftKey',
      right: 'twistedSquarePowderRiverRightKey',
      shankfinish: true,
      shankoverlay: true
    },
    {
      name: 'Riviera',
      handle: 'riviera',
      left: 'twistedSquareRivieraLeftKey',
      right: 'twistedSquareRivieraRightKey',
      shankfinish: true,
      shankoverlay: true
    },
    {
      name: 'Santa Barbara',
      handle: 'santaBarbara',
      left: 'twistedSquareSantaBarbaraLeftKey',
      right: 'twistedSquareSantaBarbaraRightKey',
      shankfinish: true,
      shankoverlay: true
    },
    {
      name: 'Santa Barbara Short',
      handle: 'santaBarbaraShort',
      left: 'twistedSquareSantaBarbaraShortLeftKey',
      right: 'twistedSquareSantaBarbaraShortRightKey',
      shankfinish: true,
      shankoverlay: true
    },
    {
      name: 'Santa Maria',
      handle: 'santaMaria',
      left: 'twistedSquareSantaMariaLeftKey',
      right: 'twistedSquareSantaMariaRightKey',
      shankfinish: true,
      shankoverlay: true
    },
    {
      name: 'Sheridan',
      handle: 'sheridan',
      left: 'twistedSquareSheridanLeftKey',
      right: 'twistedSquareSheridanRightKey',
      shankfinish: true,
      shankoverlay: true
    },
    {
      name: 'Sheridan 7',
      handle: 'sheridan7',
      left: 'twistedSquareSheridan7LeftKey',
      right: 'twistedSquareSheridan7RightKey',
      shankfinish: true,
      shankoverlay: true
    },
    {
      name: 'Switchback',
      handle: 'switchback',
      left: 'twistedSquareSwitchbackLeftKey',
      right: 'twistedSquareSwitchbackRightKey',
      shankfinish: true,
      shankoverlay: true
    },
    {
      name: 'Tahoe',
      handle: 'tahoe',
      left: 'twistedSquareTahoeLeftKey',
      right: 'twistedSquareTahoeRightKey',
      shankfinish: true,
      shankoverlay: true
    },
    {
      name: 'Teton',
      handle: 'teton',
      left: 'twistedSquareTetonLeftKey',
      right: 'twistedSquareTetonRightKey',
      shankfinish: true,
      shankoverlay: true
    },
    {
      name: 'Baseline D-Ring Snaffle',
      handle: 'baseline-dring',
      left: 'twistedSquareBaseDRingLeftKey',
      right: 'twistedSquareBaseDRingRightKey',
      shankfinish: true,
      shankoverlay: true
    },
    {
      name: 'D-Ring',
      handle: 'dRing',
      left: 'twistedSquareDRingLeftKey',
      right: 'twistedSquareDRingRightKey',
      shankfinish: true,
      shankoverlay: true
    },
    {
      name: 'Loose Ring',
      handle: 'looseRing',
      left: 'twistedSquareLooseRingLeftKey',
      right: 'twistedSquareLooseRingRightKey',
      shankfinish: true,
      shankoverlay: true
    },
    {
      name: 'West Coast',
      handle: 'westCoast',
      left: 'twistedSquareWestCoastLeftKey',
      right: 'twistedSquareWestCoastRightKey',
      shankfinish: true,
      shankoverlay: true
    },
    {
      name: 'Ballhinge Ring',
      handle: 'ballhingeRing',
      left: 'twistedSquareBallhingeRingLeftKey',
      right: 'twistedSquareBallhingeRingRightKey',
      shankfinish: true,
      shankoverlay: true
    },
    {
      name: 'Ballhinge D-Ring',
      handle: 'ballhingeDRing',
      left: 'twistedSquareBallhingeDRingLeftKey',
      right: 'twistedSquareBallhingeDRingRightKey',
      shankfinish: true,
      shankoverlay: true
    },
    {
      name: 'West Coast Divots & Dots',
      handle: 'westCoastDotsandDivots',
      left: 'twistedSquareWestCoastDandDLeftKey',
      right: 'twistedSquareWestCoastDandDRightKey',
      shankfinish: true,
      shankoverlay: true
    }
];
const selectoverlay = [
    {
      name: 'Advantage Long',
      handle: 'advantage-long',
      showlist: ["Brass Dots__brassDots","Dots__dots","None__none"]
    },
    {
      name: 'Long',
      handle: 'long',
      showlist: ["Brass Dots__brassDots","Dots__dots","None__none"]
    },
    {
      name: 'Advantage Short',
      handle: 'advantage-short',
      showlist: ["Brass Dots__brassDots","Dots__dots","None__none"]
    },
    {
      name: 'Short',
      handle: 'short',
      showlist: ["Brass Dots__brassDots","Dots__dots","None__none"]
    },
    {
      name: 'Medium S',
      handle: 'mediumS',
      showlist: ["Brass Dots__brassDots","Dots__dots","None__none"]
    },
    {
      name: 'Long S',
      handle: 'longS', 
      showlist: ["Brass Dots__brassDots","Dots__dots","None__none"]
    },
    {
      name: 'Long Ballhinge',
      handle: 'longBallhinge',
      showlist: ["Brass Dots__brassDots","Dots__dots","None__none"]
    },
    {
      name: 'Long S Ballhinge',
      handle: 'longSBallhinge',
      showlist: ["Brass Dots__brassDots","Dots__dots","None__none"]
    },
    {
      name: 'Long Horn',
      handle: 'longHorn',
      showlist: ["Brass Dots__brassDots","Dots__dots","None__none"]
    },
    {
      name: 'Maverick',
      handle: 'maverick',
      showlist: ["Brass Dots__brassDots","Dots__dots","None__none"]
    },
    {
      name: 'Medium S Ballhinge',
      handle: 'mediumSBallhinge',
      showlist: ["Brass Dots__brassDots","Dots__dots","None__none"]
    },
    {
      name: 'Mustang',
      handle: 'mustang',
      showlist: ["Brass Dots__brassDots","Dots__dots","None__none"]
    },
    {
      name: 'Predator',
      handle: 'predator',
      showlist: ["Brass Dots__brassDots","Dots__dots","None__none"]
    },
    {
      name: 'Raptor',
      handle: 'raptor',
      showlist: ["Brass Dots__brassDots","Dots__dots","None__none"]
    },
    {
      name: 'Short Ballhinge',
      handle: 'shortBallhinge',
      showlist: ["Brass Dots__brassDots","Dots__dots","None__none"]
    },
    {
      name: 'Short S',
      handle: 'shortS',
      showlist: ["Brass Dots__brassDots","Dots__dots","None__none"]
    },
    {
      name: 'Shorty',
      handle: 'shorty',
      showlist: ["Brass Dots__brassDots","Dots__dots","None__none"]
    },
    {
      name: 'Shorty Ballhinge',
      handle: 'shortyBallhinge',
      showlist: ["Brass Dots__brassDots","Dots__dots","None__none"]
    },
    {
      name: 'Short Horn',
      handle: 'shortHorn',
      showlist: ["Brass Dots__brassDots","Dots__dots","None__none"]
    },
    {
      name: 'Sierra Ballhinge',
      handle: 'sierraBallhinge',
      showlist: ["Brass Dots__brassDots","Dots__dots","None__none"]
    },
    {
      name: 'Avila',
      handle: 'avila',
      showlist: ["Sterling Floral__sterlingFloral","Dots__dots","Brass Dots__brassDots","Brass Floral__brassFloral","Plate and Dots__plateDots","Brass Plate and Dots__brassPlateDots","Floral and Dots__floralDots","Brass Floral and Dots__brassFloralDots","None__none"]
    },
    {
      name: 'Bighorn',
      handle: 'bigHorn',
      showlist: ["Brass Dots__brassDots","Dots__dots","None__none"]
    },
    {
      name: 'Cody',
      handle: 'cody',
      showlist: ["Sterling Floral__sterlingFloral","Dots__dots","Brass Dots__brassDots","Brass Floral__brassFloral","Plate and Dots__plateDots","Brass Plate and Dots__brassPlateDots","Floral and Dots__floralDots","Brass Floral and Dots__brassFloralDots","None__none"]
    },
    {
      name: 'Eva Marie',
      handle: 'evaMarie',
      showlist: ["Dots__dots","Brass Dots__brassDots","Plate and Dots__plateDots","Brass Plate and Dots__brassPlateDots","None__none"]
    },
    {
      name: 'K2',
      handle: 'k2',
      showlist: ["Dots__dots","Brass Dots__brassDots","Floral and Dots__floralDots","Brass Floral and Dots__brassFloralDots","Plate and Dots__plateDots","Brass Plate and Dots__brassPlateDots","Legend__legend","Brass Legend__brassLegend","Legend and Dots__legendDots","Brass Legend and Dots__brassLegendDots","None__none"]
    },
    {
      name: 'Powder River',
      handle: 'powderRiver',
      showlist: ["Dots__dots","Brass Dots__brassDots","Plate and Dots__plateDots","Brass Plate and Dots__brassPlateDots","None__none"]
    },
    {
      name: 'Riviera',
      handle: 'riviera',
      showlist: ["Brass Dots__brassDots","Dots__dots","None__none"]
    },
    {
      name: 'Santa Barbara',
      handle: 'santaBarbara',
      showlist: ["Dots__dots","Brass Dots__brassDots","Plate and Dots__plateDots","Brass Plate and Dots__brassPlateDots","None__none"]
    },
    {
      name: 'Santa Barbara Short',
      handle: 'santaBarbaraShort',
      showlist: ["Dots__dots","Brass Dots__brassDots","Plate and Dots__plateDots","Brass Plate and Dots__brassPlateDots","None__none"]
    },
    {
      name: 'Santa Maria',
      handle: 'santaMaria',
      showlist: ["Brass Dots__brassDots","Dots__dots","None__none"]
    },
    {
      name: 'Sheridan',
      handle: 'sheridan',
      showlist: ["Sterling Floral__sterlingFloral","Dots__dots","Brass Dots__brassDots","Brass Floral__brassFloral","Plate and Dots__plateDots","Brass Plate and Dots__brassPlateDots","Floral and Dots__floralDots","Brass Floral and Dots__brassFloralDots","Tuxedo__tuxedo","None__none"]
    },
    {
      name: 'Sheridan 7',
      handle: 'sheridan7',
      showlist: ["Dots__dots","Brass Dots__brassDots","Floral and Dots__floralDots","Brass Floral and Dots__brassFloralDots","Plate and Dots__plateDots","Brass Plate and Dots__brassPlateDots","None__none"]
    },
    {
      name: 'Switchback',
      handle: 'switchback',
      showlist: ["Dots__dots","Brass Dots__brassDots","Floral and Dots__floralDots","Brass Floral and Dots__brassFloralDots","Plate and Dots__plateDots","Brass Plate and Dots__brassPlateDots","None__none"]
    },
    {
      name: 'Tahoe',
      handle: 'tahoe',
      showlist: ["Dots__dots","Brass Dots__brassDots","Plate and Dots__plateDots","Brass Plate and Dots__brassPlateDots","None__none"]
    },
    {
      name: 'Teton',
      handle: 'teton',
      showlist: ["Dots__dots","Brass Dots__brassDots","Tuxedo__tuxedo","None__none"]
    },
    {
      name: 'D-Ring',
      handle: 'dRing',
      showlist: ["Brass Dots__brassDots","Dots__dots","None__none"]
    },
    {
      name: 'Ballhinge Ring',
      handle: 'ballhingeRing',
      showlist: ["Brass Dots__brassDots","Dots__dots","None__none"]
    },
    {
      name: 'Ballhinge D-Ring',
      handle: 'ballhingeDRing',
      showlist: ["Brass Dots__brassDots","Dots__dots","None__none"]
    },
    {
      name: 'West Coast Divots & Dots',
      handle: 'westCoastDotsandDivots',
      showlist: ["Brass Dots__brassDots","Dots__dots"]
    }
];
const defaultValues = {
  '3-in-1': [
    { property: 'shankmoth', value: '3-in-1' },
    { property: 'shankSelection', value: 'advantage-short' },
    { property: 'santaBarbaraFinish', value: 'stainless' },
    { property: 'advShortLeftKey.shank', value: 'advantageShort' },
    { property: 'advShortRightKey.shank', value: 'advantageShort' },
    { property: 'advShortLeftKey.shankFinish', value: 'stainless' },
    { property: 'advShortRightKey.shankFinish', value: 'stainless' },
    { property: 'advShortLeftKey.shankOverlay', value: 'none' },
    { property: 'advShortRightKey.shankOverlay', value: 'none' }
  ],
  '4-runner': [
    { property: 'shankmoth', value: '4-runner' },
    { property: 'shankSelection', value: 'advantage-short' },
    { property: 'santaBarbaraFinish', value: 'stainless' },
    { property: 'advShortLeftKey.shank', value: 'advantageShort' },
    { property: 'advShortRightKey.shank', value: 'advantageShort' },
    { property: 'advShortLeftKey.shankFinish', value: 'stainless' },
    { property: 'advShortRightKey.shankFinish', value: 'stainless' },
    { property: 'advShortLeftKey.shankOverlay', value: 'none' },
    { property: 'advShortRightKey.shankOverlay', value: 'none' }
  ],
  'balanced-snaffle': [
    { property: 'shankmoth', value: 'balanced-snaffle' },
    { property: 'mouthpiece', value: 'balancedSnaffle' },
    { property: 'shankSelection', value: 'advantage-short' },
    { property: 'santaBarbaraFinish', value: 'stainless' },
    { property: 'advShortLeftKey.shank', value: 'advantageShort' },
    { property: 'advShortRightKey.shank', value: 'advantageShort' },
    { property: 'advShortLeftKey.shankFinish', value: 'stainless' },
    { property: 'advShortRightKey.shankFinish', value: 'stainless' },
    { property: 'advShortLeftKey.shankOverlay', value: 'none' },
    { property: 'advShortRightKey.shankOverlay', value: 'none' }
  ],
  'billy-allen': [
    { property: 'shankmoth', value: 'billy-allen' },
    { property: 'mouthpiece', value: 'billyAllen' },
    { property: 'shankSelection', value: 'advantage-short' },
    { property: 'santaBarbaraFinish', value: 'stainless' },
    { property: 'advShortLeftKey.shank', value: 'advantageShort' },
    { property: 'advShortRightKey.shank', value: 'advantageShort' },
    { property: 'advShortLeftKey.shankFinish', value: 'stainless' },
    { property: 'advShortRightKey.shankFinish', value: 'stainless' },
    { property: 'advShortLeftKey.shankOverlay', value: 'none' },
    { property: 'advShortRightKey.shankOverlay', value: 'none' }
  ],
  'chain': [
      { property: 'shankmoth', value: 'chain' },
      { property: 'shankSelection', value: 'advantage-short' },
      { property: 'santaBarbaraFinish', value: 'stainless' },
      { property: 'advShortLeftKey.shank', value: 'advantageShort' },
      { property: 'advShortRightKey.shank', value: 'advantageShort' },
      { property: 'advShortLeftKey.shankFinish', value: 'stainless' },
      { property: 'advShortRightKey.shankFinish', value: 'stainless' },
      { property: 'advShortLeftKey.shankOverlay', value: 'none' },
      { property: 'advShortRightKey.shankOverlay', value: 'none' }
  ],
  'clearwater': [
    { property: 'shankmoth', value: 'clearwater' },
    { property: 'mouthpiece', value: 'clearwater_Roller' },
    { property: 'shankSelection', value: 'advantage-short' },
    { property: 'santaBarbaraFinish', value: 'stainless' },
    { property: 'advShortLeftKey.shank', value: 'advantageShort' },
    { property: 'advShortRightKey.shank', value: 'advantageShort' },
    { property: 'advShortLeftKey.shankFinish', value: 'stainless' },
    { property: 'advShortRightKey.shankFinish', value: 'stainless' },
    { property: 'advShortLeftKey.shankOverlay', value: 'none' },
    { property: 'advShortRightKey.shankOverlay', value: 'none' }
  ],
  'correction': [
    { property: 'shankmoth', value: 'correction' },
    { property: 'mouthpiece', value: 'correction1Ball' },
    { property: 'shankSelection', value: 'advantage-short' },
    { property: 'santaBarbaraFinish', value: 'stainless' },
    { property: 'advShortLeftKey.shank', value: 'advantageShort' },
    { property: 'advShortRightKey.shank', value: 'advantageShort' },
    { property: 'advShortLeftKey.shankFinish', value: 'stainless' },
    { property: 'advShortRightKey.shankFinish', value: 'stainless' },
    { property: 'advShortLeftKey.shankOverlay', value: 'none' },
    { property: 'advShortRightKey.shankOverlay', value: 'none' }
  ],
  'double-cross': [
    { property: 'shankmoth', value: 'double-cross' },
    { property: 'shankSelection', value: 'advantage-short' },
    { property: 'santaBarbaraFinish', value: 'stainless' },
    { property: 'advShortLeftKey.shank', value: 'advantageShort' },
    { property: 'advShortRightKey.shank', value: 'advantageShort' },
    { property: 'advShortLeftKey.shankFinish', value: 'stainless' },
    { property: 'advShortRightKey.shankFinish', value: 'stainless' },
    { property: 'advShortLeftKey.shankOverlay', value: 'none' },
    { property: 'advShortRightKey.shankOverlay', value: 'none' }
  ],
  'dr-tom': [
    { property: 'shankmoth', value: 'dr-tom' },
    { property: 'mouthpiece', value: 'drTom' },
    { property: 'shankSelection', value: 'advantage-short' },
    { property: 'santaBarbaraFinish', value: 'stainless' },
    { property: 'advShortLeftKey.shank', value: 'advantageShort' },
    { property: 'advShortRightKey.shank', value: 'advantageShort' },
    { property: 'advShortLeftKey.shankFinish', value: 'stainless' },
    { property: 'advShortRightKey.shankFinish', value: 'stainless' },
    { property: 'advShortLeftKey.shankOverlay', value: 'none' },
    { property: 'advShortRightKey.shankOverlay', value: 'none' }
  ],
  'flat-bar': [
    { property: 'shankmoth', value: 'flat-bar' },
    { property: 'shankSelection', value: 'advantage-short' },
    { property: 'santaBarbaraFinish', value: 'stainless' },
    { property: 'advShortLeftKey.shank', value: 'advantageShort' },
    { property: 'advShortRightKey.shank', value: 'advantageShort' },
    { property: 'advShortLeftKey.shankFinish', value: 'stainless' },
    { property: 'advShortRightKey.shankFinish', value: 'stainless' },
    { property: 'advShortLeftKey.shankOverlay', value: 'none' },
    { property: 'advShortRightKey.shankOverlay', value: 'none' }
  ],
  'half-half': [
    { property: 'shankmoth', value: 'half-half' },
    { property: 'shankSelection', value: 'advantage-short' },
    { property: 'santaBarbaraFinish', value: 'stainless' },
    { property: 'advShortLeftKey.shank', value: 'advantageShort' },
    { property: 'advShortRightKey.shank', value: 'advantageShort' },
    { property: 'advShortLeftKey.shankFinish', value: 'stainless' },
    { property: 'advShortRightKey.shankFinish', value: 'stainless' },
    { property: 'advShortLeftKey.shankOverlay', value: 'none' },
    { property: 'advShortRightKey.shankOverlay', value: 'none' }
  ],
  'high-port': [
    { property: 'shankmoth', value: 'high-port' },
    { property: 'mouthpiece', value: 'highPort_Roller' },
    { property: 'shankSelection', value: 'advantage-short' },
    { property: 'santaBarbaraFinish', value: 'stainless' },
    { property: 'advShortLeftKey.shank', value: 'advantageShort' },
    { property: 'advShortRightKey.shank', value: 'advantageShort' },
    { property: 'advShortLeftKey.shankFinish', value: 'stainless' },
    { property: 'advShortRightKey.shankFinish', value: 'stainless' },
    { property: 'advShortLeftKey.shankOverlay', value: 'none' },
    { property: 'advShortRightKey.shankOverlay', value: 'none' }
  ],
  'hinge-port': [
    { property: 'shankmoth', value: 'hinge-port' },
    { property: 'mouthpiece', value: 'hingePort_Roller' },
    { property: 'shankSelection', value: 'advantage-short' },
    { property: 'santaBarbaraFinish', value: 'stainless' },
    { property: 'advShortLeftKey.shank', value: 'advantageShort' },
    { property: 'advShortRightKey.shank', value: 'advantageShort' },
    { property: 'advShortLeftKey.shankFinish', value: 'stainless' },
    { property: 'advShortRightKey.shankFinish', value: 'stainless' },
    { property: 'advShortLeftKey.shankOverlay', value: 'none' },
    { property: 'advShortRightKey.shankOverlay', value: 'none' }
  ],
  'house-snaffle': [
    { property: 'shankmoth', value: 'house-snaffle' },
    { property: 'mouthpiece', value: 'houseSnaffle' },
    { property: 'shankSelection', value: 'advantage-short' },
    { property: 'santaBarbaraFinish', value: 'stainless' },
    { property: 'advShortLeftKey.shank', value: 'advantageShort' },
    { property: 'advShortRightKey.shank', value: 'advantageShort' },
    { property: 'advShortLeftKey.shankFinish', value: 'stainless' },
    { property: 'advShortRightKey.shankFinish', value: 'stainless' },
    { property: 'advShortLeftKey.shankOverlay', value: 'none' },
    { property: 'advShortRightKey.shankOverlay', value: 'none' }
  ],
  'iron-worker': [
    { property: 'shankmoth', value: 'iron-worker' },
    { property: 'mouthpiece', value: 'ironWorkerLarge' },
    { property: 'shankSelection', value: 'advantage-short' },
    { property: 'santaBarbaraFinish', value: 'stainless' },
    { property: 'advShortLeftKey.shank', value: 'advantageShort' },
    { property: 'advShortRightKey.shank', value: 'advantageShort' },
    { property: 'advShortLeftKey.shankFinish', value: 'stainless' },
    { property: 'advShortRightKey.shankFinish', value: 'stainless' },
    { property: 'advShortLeftKey.shankOverlay', value: 'none' },
    { property: 'advShortRightKey.shankOverlay', value: 'none' }
  ],
  'life-saver': [
    { property: 'shankmoth', value: 'life-saver' },
    { property: 'shankSelection', value: 'advantage-short' },
    { property: 'santaBarbaraFinish', value: 'stainless' },
    { property: 'advShortLeftKey.shank', value: 'advantageShort' },
    { property: 'advShortRightKey.shank', value: 'advantageShort' },
    { property: 'advShortLeftKey.shankFinish', value: 'stainless' },
    { property: 'advShortRightKey.shankFinish', value: 'stainless' },
    { property: 'advShortLeftKey.shankOverlay', value: 'none' },
    { property: 'advShortRightKey.shankOverlay', value: 'none' }
  ],
  'low-hinge-port': [
    { property: 'shankmoth', value: 'low-hinge-port' },
    { property: 'mouthpiece', value: 'lowHingePort_Roller' },
    { property: 'shankSelection', value: 'advantage-short' },
    { property: 'santaBarbaraFinish', value: 'stainless' },
    { property: 'advShortLeftKey.shank', value: 'advantageShort' },
    { property: 'advShortRightKey.shank', value: 'advantageShort' },
    { property: 'advShortLeftKey.shankFinish', value: 'stainless' },
    { property: 'advShortRightKey.shankFinish', value: 'stainless' },
    { property: 'advShortLeftKey.shankOverlay', value: 'none' },
    { property: 'advShortRightKey.shankOverlay', value: 'none' }
  ],
  'low-port': [
    { property: 'shankmoth', value: 'low-port' },
    { property: 'mouthpiece', value: 'lowPort' },
    { property: 'shankSelection', value: 'advantage-short' },
    { property: 'santaBarbaraFinish', value: 'stainless' },
    { property: 'advShortLeftKey.shank', value: 'advantageShort' },
    { property: 'advShortRightKey.shank', value: 'advantageShort' },
    { property: 'advShortLeftKey.shankFinish', value: 'stainless' },
    { property: 'advShortRightKey.shankFinish', value: 'stainless' },
    { property: 'advShortLeftKey.shankOverlay', value: 'none' },
    { property: 'advShortRightKey.shankOverlay', value: 'none' }
  ],
  'low-rider': [
    { property: 'shankmoth', value: 'low-rider' },
    { property: 'mouthpiece', value: 'lowRider' },
    { property: 'shankSelection', value: 'advantage-short' },
    { property: 'santaBarbaraFinish', value: 'stainless' },
    { property: 'advShortLeftKey.shank', value: 'advantageShort' },
    { property: 'advShortRightKey.shank', value: 'advantageShort' },
    { property: 'advShortLeftKey.shankFinish', value: 'stainless' },
    { property: 'advShortRightKey.shankFinish', value: 'stainless' },
    { property: 'advShortLeftKey.shankOverlay', value: 'none' },
    { property: 'advShortRightKey.shankOverlay', value: 'none' }
  ],
  'malibu': [
    { property: 'shankmoth', value: 'malibu' },
    { property: 'mouthpiece', value: 'malibu_Roller' },
    { property: 'shankSelection', value: 'advantage-short' },
    { property: 'santaBarbaraFinish', value: 'stainless' },
    { property: 'advShortLeftKey.shank', value: 'advantageShort' },
    { property: 'advShortRightKey.shank', value: 'advantageShort' },
    { property: 'advShortLeftKey.shankFinish', value: 'stainless' },
    { property: 'advShortRightKey.shankFinish', value: 'stainless' },
    { property: 'advShortLeftKey.shankOverlay', value: 'none' },
    { property: 'advShortRightKey.shankOverlay', value: 'none' }
  ],
  'med-low-port': [
    { property: 'shankmoth', value: 'medium-low-port' },
    { property: 'mouthpiece', value: 'mediumLowPort_Roller' },
    { property: 'shankSelection', value: 'advantage-short' },
    { property: 'santaBarbaraFinish', value: 'stainless' },
    { property: 'advShortLeftKey.shank', value: 'advantageShort' },
    { property: 'advShortRightKey.shank', value: 'advantageShort' },
    { property: 'advShortLeftKey.shankFinish', value: 'stainless' },
    { property: 'advShortRightKey.shankFinish', value: 'stainless' },
    { property: 'advShortLeftKey.shankOverlay', value: 'none' },
    { property: 'advShortRightKey.shankOverlay', value: 'none' }
  ],
  'med-port': [
    { property: 'shankmoth', value: 'medium-port' },
    { property: 'mouthpiece', value: 'mediumPort_Roller' },
    { property: 'shankSelection', value: 'advantage-short' },
    { property: 'santaBarbaraFinish', value: 'stainless' },
    { property: 'mediumPortRollerAdvShortLeftKey.shank', value: 'advantageShort' },
    { property: 'mediumPortRollerAdvShortRightKey.shank', value: 'advantageShort' },
    { property: 'mediumPortRollerAdvShortLeftKey.shankFinish', value: 'stainless' },
    { property: 'mediumPortRollerAdvShortRightKey.shankFinish', value: 'stainless' },
    { property: 'mediumPortRollerAdvShortLeftKey.shankOverlay', value: 'none' },
    { property: 'mediumPortRollerAdvShortRightKey.shankOverlay', value: 'none' }
  ],
  'mullened-correction': [
    { property: 'shankmoth', value: 'mullened-correction' },
    { property: 'mouthpiece', value: 'mullenedCorrection' },
    { property: 'shankSelection', value: 'advantage-short' },
    { property: 'santaBarbaraFinish', value: 'stainless' },
    { property: 'advShortLeftKey.shank', value: 'advantageShort' },
    { property: 'advShortRightKey.shank', value: 'advantageShort' },
    { property: 'advShortLeftKey.shankFinish', value: 'stainless' },
    { property: 'advShortRightKey.shankFinish', value: 'stainless' },
    { property: 'advShortLeftKey.shankOverlay', value: 'none' },
    { property: 'advShortRightKey.shankOverlay', value: 'none' }
  ],
  'ported-chain': [
    { property: 'shankmoth', value: 'ported_chain' },
    { property: 'shankSelection', value: 'advantage-short' },
    { property: 'santaBarbaraFinish', value: 'stainless' },
    { property: 'advShortLeftKey.shank', value: 'advantageShort' },
    { property: 'advShortRightKey.shank', value: 'advantageShort' },
    { property: 'advShortLeftKey.shankFinish', value: 'stainless' },
    { property: 'advShortRightKey.shankFinish', value: 'stainless' },
    { property: 'advShortLeftKey.shankOverlay', value: 'none' },
    { property: 'advShortRightKey.shankOverlay', value: 'none' }
  ],
  'renegade': [
    { property: 'shankmoth', value: 'renegade' },
    { property: 'shankSelection', value: 'advantage-short' },
    { property: 'santaBarbaraFinish', value: 'stainless' },
    { property: 'advShortLeftKey.shank', value: 'advantageShort' },
    { property: 'advShortRightKey.shank', value: 'advantageShort' },
    { property: 'advShortLeftKey.shankFinish', value: 'stainless' },
    { property: 'advShortRightKey.shankFinish', value: 'stainless' },
    { property: 'advShortLeftKey.shankOverlay', value: 'none' },
    { property: 'advShortRightKey.shankOverlay', value: 'none' }
  ],
  'silverado': [
    { property: 'shankmoth', value: 'silverado' },
    { property: 'mouthpiece', value: 'silverado_Roller' },
    { property: 'shankSelection', value: 'advantage-short' },
    { property: 'santaBarbaraFinish', value: 'stainless' },
    { property: 'silveradoRollerAdvShortLeftKey.shank', value: 'advantageShort' },
    { property: 'silveradoRollerAdvShortRightKey.shank', value: 'advantageShort' },
    { property: 'silveradoRollerAdvShortLeftKey.shankFinish', value: 'stainless' },
    { property: 'silveradoRollerAdvShortRightKey.shankFinish', value: 'stainless' },
    { property: 'silveradoRollerAdvShortLeftKey.shankOverlay', value: 'none' },
    { property: 'silveradoRollerAdvShortRightKey.shankOverlay', value: 'none' }
  ],
  'slick-50': [
    { property: 'shankmoth', value: 'slick-50' },
    { property: 'mouthpiece', value: 'slick50' },
    { property: 'shankSelection', value: 'advantage-short' },
    { property: 'santaBarbaraFinish', value: 'stainless' },
    { property: 'advShortLeftKey.shank', value: 'advantageShort' },
    { property: 'advShortRightKey.shank', value: 'advantageShort' },
    { property: 'advShortLeftKey.shankFinish', value: 'stainless' },
    { property: 'advShortRightKey.shankFinish', value: 'stainless' },
    { property: 'advShortLeftKey.shankOverlay', value: 'none' },
    { property: 'advShortRightKey.shankOverlay', value: 'none' }
  ],
  'snaffle': [
    { property: 'shankmoth', value: 'snaffle' },
    { property: 'mouthpiece', value: 'snaffle' },
    { property: 'shankSelection', value: 'advantage-short' },
    { property: 'santaBarbaraFinish', value: 'stainless' },
    { property: 'advShortLeftKey.shank', value: 'advantageShort' },
    { property: 'advShortRightKey.shank', value: 'advantageShort' },
    { property: 'advShortLeftKey.shankFinish', value: 'stainless' },
    { property: 'advShortRightKey.shankFinish', value: 'stainless' },
    { property: 'advShortLeftKey.shankOverlay', value: 'none' },
    { property: 'advShortRightKey.shankOverlay', value: 'none' }
  ],
  'square-port': [
    { property: 'shankmoth', value: 'square-port' },
    { property: 'mouthpiece', value: 'squarePort_Roller' },
    { property: 'shankSelection', value: 'advantage-short' },
    { property: 'santaBarbaraFinish', value: 'stainless' },
    { property: 'advShortLeftKey.shank', value: 'advantageShort' },
    { property: 'advShortRightKey.shank', value: 'advantageShort' },
    { property: 'advShortLeftKey.shankFinish', value: 'stainless' },
    { property: 'advShortRightKey.shankFinish', value: 'stainless' },
    { property: 'advShortLeftKey.shankOverlay', value: 'none' },
    { property: 'advShortRightKey.shankOverlay', value: 'none' }
  ],
  'sweet-water': [
    { property: 'shankmoth', value: 'sweet-water' },
    { property: 'mouthpiece', value: 'sweetWater' },
    { property: 'shankSelection', value: 'advantage-short' },
    { property: 'santaBarbaraFinish', value: 'stainless' },
    { property: 'advShortLeftKey.shank', value: 'advantageShort' },
    { property: 'advShortRightKey.shank', value: 'advantageShort' },
    { property: 'advShortLeftKey.shankFinish', value: 'stainless' },
    { property: 'advShortRightKey.shankFinish', value: 'stainless' },
    { property: 'advShortLeftKey.shankOverlay', value: 'none' },
    { property: 'advShortRightKey.shankOverlay', value: 'none' }
  ],
  'twisted': [
    { property: 'shankmoth', value: 'twisted-snaffle' },
    { property: 'mouthpiece', value: 'twistedHex' },
    { property: 'shankSelection', value: 'advantage-short' },
    { property: 'santaBarbaraFinish', value: 'stainless' },
    { property: 'twistedHexAdvShortLeftKey.shank', value: 'advantageShort' },
    { property: 'twistedHexAdvShortRightKey.shank', value: 'advantageShort' },
    { property: 'twistedHexAdvShortLeftKey.shankFinish', value: 'stainless' },
    { property: 'twistedHexAdvShortRightKey.shankFinish', value: 'stainless' },
    { property: 'twistedHexAdvShortLeftKey.shankOverlay', value: 'none' },
    { property: 'twistedHexAdvShortRightKey.shankOverlay', value: 'none' }
  ],
  'verona': [
    { property: 'shankmoth', value: 'verona' },
    { property: 'mouthpiece', value: 'verona_Roller' },
    { property: 'shankSelection', value: 'advantage-short' },
    { property: 'santaBarbaraFinish', value: 'stainless' },
    { property: 'advShortLeftKey.shank', value: 'advantageShort' },
    { property: 'advShortRightKey.shank', value: 'advantageShort' },
    { property: 'advShortLeftKey.shankFinish', value: 'stainless' },
    { property: 'advShortRightKey.shankFinish', value: 'stainless' },
    { property: 'advShortLeftKey.shankOverlay', value: 'none' },
    { property: 'advShortRightKey.shankOverlay', value: 'none' }
  ],
  'ace-of-spades': [
    { property: 'shankmoth', value: 'ace-of-spades' },
    { property: 'mouthpiece', value: 'aceOfSpades_Roller' },
    { property: 'shankSelection', value: 'advantage-short' },
    { property: 'santaBarbaraFinish', value: 'stainless' },
    { property: 'advShortLeftKey.shank', value: 'advantageShort' },
    { property: 'advShortRightKey.shank', value: 'advantageShort' },
    { property: 'advShortLeftKey.shankFinish', value: 'stainless' },
    { property: 'advShortRightKey.shankFinish', value: 'stainless' },
    { property: 'advShortLeftKey.shankOverlay', value: 'none' },
    { property: 'advShortRightKey.shankOverlay', value: 'none' }
  ],
  'catalina': [
    { property: 'shankmoth', value: 'catalina' },
    { property: 'mouthpiece', value: 'catalina_Roller' },
    { property: 'shankSelection', value: 'advantage-short' },
    { property: 'santaBarbaraFinish', value: 'stainless' },
    { property: 'advShortLeftKey.shank', value: 'advantageShort' },
    { property: 'advShortRightKey.shank', value: 'advantageShort' },
    { property: 'advShortLeftKey.shankFinish', value: 'stainless' },
    { property: 'advShortRightKey.shankFinish', value: 'stainless' },
    { property: 'advShortLeftKey.shankOverlay', value: 'none' },
    { property: 'advShortRightKey.shankOverlay', value: 'none' }
  ],
  'catalina-royal': [
    { property: 'shankmoth', value: 'catalina-royal' },
    { property: 'mouthpiece', value: 'catalinaRoyal_Roller' },
    { property: 'shankSelection', value: 'advantage-short' },
    { property: 'santaBarbaraFinish', value: 'stainless' },
    { property: 'advShortLeftKey.shank', value: 'advantageShort' },
    { property: 'advShortRightKey.shank', value: 'advantageShort' },
    { property: 'advShortLeftKey.shankFinish', value: 'stainless' },
    { property: 'advShortRightKey.shankFinish', value: 'stainless' },
    { property: 'advShortLeftKey.shankOverlay', value: 'none' },
    { property: 'advShortRightKey.shankOverlay', value: 'none' }
  ],
  'cathedral-a': [
    { property: 'shankmoth', value: 'cathedral-a' },
    { property: 'shankSelection', value: 'advantage-short' },
    { property: 'santaBarbaraFinish', value: 'stainless' },
    { property: 'advShortLeftKey.shank', value: 'advantageShort' },
    { property: 'advShortRightKey.shank', value: 'advantageShort' },
    { property: 'advShortLeftKey.shankFinish', value: 'stainless' },
    { property: 'advShortRightKey.shankFinish', value: 'stainless' },
    { property: 'advShortLeftKey.shankOverlay', value: 'none' },
    { property: 'advShortRightKey.shankOverlay', value: 'none' }
  ],
  'crown-royal': [
    { property: 'shankmoth', value: 'crown-royal' },
    { property: 'shankSelection', value: 'advantage-short' },
    { property: 'santaBarbaraFinish', value: 'stainless' },
    { property: 'advShortLeftKey.shank', value: 'advantageShort' },
    { property: 'advShortRightKey.shank', value: 'advantageShort' },
    { property: 'advShortLeftKey.shankFinish', value: 'stainless' },
    { property: 'advShortRightKey.shankFinish', value: 'stainless' },
    { property: 'advShortLeftKey.shankOverlay', value: 'none' },
    { property: 'advShortRightKey.shankOverlay', value: 'none' }
  ],
  'equalizer': [
    { property: 'shankmoth', value: 'equalizer' },
    { property: 'mouthpiece', value: 'equalizer_Roller' },
    { property: 'shankSelection', value: 'advantage-short' },
    { property: 'santaBarbaraFinish', value: 'stainless' },
    { property: 'advShortLeftKey.shank', value: 'advantageShort' },
    { property: 'advShortRightKey.shank', value: 'advantageShort' },
    { property: 'advShortLeftKey.shankFinish', value: 'stainless' },
    { property: 'advShortRightKey.shankFinish', value: 'stainless' },
    { property: 'advShortLeftKey.shankOverlay', value: 'none' },
    { property: 'advShortRightKey.shankOverlay', value: 'none' }
  ],
  'half-breed': [
    { property: 'shankmoth', value: 'half-breed' },
    { property: 'shankSelection', value: 'advantage-short' },
    { property: 'santaBarbaraFinish', value: 'stainless' },
    { property: 'advShortLeftKey.shank', value: 'advantageShort' },
    { property: 'advShortRightKey.shank', value: 'advantageShort' },
    { property: 'advShortLeftKey.shankFinish', value: 'stainless' },
    { property: 'advShortRightKey.shankFinish', value: 'stainless' },
    { property: 'advShortLeftKey.shankOverlay', value: 'none' },
    { property: 'advShortRightKey.shankOverlay', value: 'none' }
  ],
  'klapper': [
    { property: 'shankmoth', value: 'klapper' },
    { property: 'mouthpiece', value: 'klapper_Roller' },
    { property: 'shankSelection', value: 'advantage-short' },
    { property: 'santaBarbaraFinish', value: 'stainless' },
    { property: 'advShortLeftKey.shank', value: 'advantageShort' },
    { property: 'advShortRightKey.shank', value: 'advantageShort' },
    { property: 'advShortLeftKey.shankFinish', value: 'stainless' },
    { property: 'advShortRightKey.shankFinish', value: 'stainless' },
    { property: 'advShortLeftKey.shankOverlay', value: 'none' },
    { property: 'advShortRightKey.shankOverlay', value: 'none' }
  ],
  'liberator': [
    { property: 'shankmoth', value: 'liberator' },
    { property: 'shankSelection', value: 'advantage-short' },
    { property: 'santaBarbaraFinish', value: 'stainless' },
    { property: 'advShortLeftKey.shank', value: 'advantageShort' },
    { property: 'advShortRightKey.shank', value: 'advantageShort' },
    { property: 'advShortLeftKey.shankFinish', value: 'stainless' },
    { property: 'advShortRightKey.shankFinish', value: 'stainless' },
    { property: 'advShortLeftKey.shankOverlay', value: 'none' },
    { property: 'advShortRightKey.shankOverlay', value: 'none' }
  ],
  'pro-roller': [
    { property: 'shankmoth', value: 'pro-roller' },
    { property: 'mouthpiece', value: 'rollerDerby' },
    { property: 'shankSelection', value: 'advantage-short' },
    { property: 'santaBarbaraFinish', value: 'stainless' },
    { property: 'advShortLeftKey.shank', value: 'advantageShort' },
    { property: 'advShortRightKey.shank', value: 'advantageShort' },
    { property: 'advShortLeftKey.shankFinish', value: 'stainless' },
    { property: 'advShortRightKey.shankFinish', value: 'stainless' },
    { property: 'advShortLeftKey.shankOverlay', value: 'none' },
    { property: 'advShortRightKey.shankOverlay', value: 'none' }
  ],
  'sr': [
    { property: 'shankmoth', value: 'sr' },
    { property: 'mouthpiece', value: 'sr_Roller' },
    { property: 'shankSelection', value: 'advantage-short' },
    { property: 'santaBarbaraFinish', value: 'stainless' },
    { property: 'srAdvShortLeftKey.shank', value: 'advantageShort' },
    { property: 'srAdvShortRightKey.shank', value: 'advantageShort' },
    { property: 'srAdvShortLeftKey.shankFinish', value: 'stainless' },
    { property: 'srAdvShortRightKey.shankFinish', value: 'stainless' },
    { property: 'srAdvShortLeftKey.shankOverlay', value: 'none' },
    { property: 'srAdvShortRightKey.shankOverlay', value: 'none' }
  ],
  'summit': [
    { property: 'shankmoth', value: 'summit' },
    { property: 'mouthpiece', value: 'summit_Roller' },
    { property: 'shankSelection', value: 'advantage-short' },
    { property: 'santaBarbaraFinish', value: 'stainless' },
    { property: 'advShortLeftKey.shank', value: 'advantageShort' },
    { property: 'advShortRightKey.shank', value: 'advantageShort' },
    { property: 'advShortLeftKey.shankFinish', value: 'stainless' },
    { property: 'advShortRightKey.shankFinish', value: 'stainless' },
    { property: 'advShortLeftKey.shankOverlay', value: 'none' },
    { property: 'advShortRightKey.shankOverlay', value: 'none' }
  ]
}

async function loadNewProduct(loadProductValue, loadURL, searchParams) {

  // // Start loader overlay (if not already started)
  if (!document.querySelector('body').classList.contains('overlay_canvas_show')) {
    await document.querySelector('body').classList.add('overlay_canvas_show');
  }
  
  if (!document.querySelector('.product-personalizer').classList.contains('disabled_btn')) {
    await document.querySelector('.product-personalizer').classList.add('disabled_btn');
  }

  
  // Get the canvas element
  const renderCanvas = document.getElementById('dopple-render-canvas'); 
  console.log("1: renderCanvas", renderCanvas);
  
  // Assign Visual instance on window
  visual = window.Atlatl.Visual.getInstances()[0]; 
  console.log("2: visual", visual);

  // Create Product Template
  prodTemplate = visual.getProductTemplates()[0];
  console.log("3: Create prodTemplet", prodTemplate);

  LoadProduct = loadProductValue;
  console.log("Product_Load: ", LoadProduct);

  // Destroy Old Product Template
  await prodTemplate.destroy();
  console.log('4: Product Template Destroyed');

  // Load the New Product Template
  prodTemplate = new Atlatl.ProductTemplate(visual, namespace, LoadProduct); 
  console.log('5: Load productTemplate', prodTemplate);

  await prodTemplate.load();
  console.log('5.5: New Product Template Loaded');
  
  // Initialize New Product
  product = new Atlatl.Product(prodTemplate);
  await product.ready();
  window.doppleShopify.product = product;
  console.log('6: Product', product);
  
  
  // Setting LoadProduct Values
  if(loadURL) {
    console.log("I already have values");
    console.log('SearchParams:', searchParams);


    var $th_id_array = [];
    
    var chainpiece = searchParams.get('chainpiece');
    var mouthpiece = searchParams.get('mouthpiece');
    var fancyShank = searchParams.get('fancyshank');
    var plainShank = searchParams.get('plainshank');
    var shankColor = searchParams.get('shankcolor');
    var shankOverlay = searchParams.get('shankovarlay');
    var custInscription = searchParams.get('custinscription');
    var custMouthWidth = searchParams.get('custmouthwidth');
    var custSilverLetter = searchParams.get('custsilverletter');

    if(loadProductValue){
      $th_id_array.push({ "property": "loadProduct" , "value": loadProductValue });
    }
    if(chainpiece){
      $th_id_array.push({ "property": "chainpiece" , "value": chainpiece });
    }
    if(mouthpiece){
      $th_id_array.push({ "property": "mouthpiece" , "value": mouthpiece });
    }
    if(fancyShank){
      $th_id_array.push({ "property": "fancyShank" , "value": fancyShank });
    }
    if(plainShank){
      $th_id_array.push({ "property": "plainShank" , "value": plainShank });
    }
    if(shankColor){
      $th_id_array.push({ "property": "shankColor" , "value": shankColor });
    }
    if(shankOverlay){
      $th_id_array.push({ "property": "shankOverlay" , "value": shankOverlay });
    }
    if(custInscription){
      $th_id_array.push({ "property": "custInscription" , "value": custInscription });
    }
    if(custMouthWidth){
      $th_id_array.push({ "property": "custMouthWidth" , "value": custMouthWidth });
    }
    if(custSilverLetter){
      $th_id_array.push({ "property": "custSilverLetter" , "value": custSilverLetter });
    };

    await document.querySelector('.product-personalizer').classList.remove('disabled_btn');
    var DataselectCIname = "";
    var DataselectMouthset = "";
    var bitMouthpieceDropdown = document.querySelector('.pplr-bit-mouthpiece:not(.pplr_no_preview)'); 
    if (bitMouthpieceDropdown) {
      bitMouthpieceDropdown.querySelectorAll('.pplr-drop-item').forEach((bit) => {
        var DATAOPT = bit.dataset.value.split('__');
        if (DATAOPT[1] === loadProductValue) {
          DataselectCIname = DATAOPT[0];
          DataselectMouthset = DATAOPT[1];
          return true;
        }
      });
    }  
    var DataValueLeft = "";
    var DataValueRight = "";
    var DataValueHandle = "";
    var DataValueProperty = "";
    var DataValueShank = false;
    var DataValueShankfinish = false;
    var DataValueShankoverlay = false;
    let PPLshanksplit = '', SHANKFirst = '', ShankNamspace = '', ShankProperty = '', Rightkey_shank = '', Leftkey_shank = '', Rightkey_shankfinish = '', Leftkey_shankfinish = '', Rightkey_shankoverlay = '', Leftkey_shankoverlay = '', Handlekey = '', shank = false, shankfinish = false, shankoverlay = false;

    await Signatureoptionload($th_id_array,DataselectCIname,loadProductValue,custInscription,custMouthWidth,custSilverLetter);
    
  } else {
    console.log("SETTING VALUES");

    let setProduct = defaultValues[LoadProduct];

    await product.setValue(setProduct[1].property, setProduct[1].value);
    await product.setValue(setProduct[2].property, setProduct[2].value);
    await product.setValue(setProduct[3].property, setProduct[3].value);
    await product.setValue(setProduct[4].property, setProduct[4].value);
    await product.setValue(setProduct[5].property, setProduct[5].value);
    await product.setValue(setProduct[6].property, setProduct[6].value);
    await product.setValue(setProduct[7].property, setProduct[7].value);
    await product.setValue(setProduct[8].property, setProduct[8].value);
    
    if (setProduct[9]?.property && setProduct[9]?.value) {
      await product.setValue(setProduct[9].property, setProduct[9].value); 
    }
    
    console.log("VALUES SET:", product.getValues());

    await setButtonsActive(setProduct);
  }
  
  // Stop loader overlay
  await document.querySelector('body').classList.remove('overlay_canvas_show');
  await document.querySelector('.product-personalizer').classList.remove('disabled_btn');
  document.getElementById('dopple-loading-screen').style.display = "none";

  // Start 3D render Rotation
  await setupRotationControl(modalElement,product)
}

async function setButtonsActive(setProduct) {
  console.log("setProduct:", setProduct);

  if (setProduct[0].property == "shankmoth") {
    if(document.querySelector('.pplr-mouthpiecechain:not(.pplr_no_preview)')) {
      document.querySelector('.pplr-mouthpiecechain:not(.pplr_no_preview)').querySelectorAll(".pplr-drop-item").forEach(async (e) => {
        let shankmoth = e.dataset.value.split("__")[1];  
        if (shankmoth == setProduct[0].value) {
          e.classList.add('active');
        }
      });
    }
  }
  
  if (setProduct[1].property == "mouthpiece") {
    if(document.querySelector('.pplr-mouthpiece:not(.pplr_no_preview)')) {
      document.querySelector('.pplr-mouthpiece:not(.pplr_no_preview)').querySelectorAll(".pplr-drop-item").forEach(async (e) => {
        let mouthpiece = e.dataset.value.split("__")[1];  
        if (mouthpiece == setProduct[1].value) {
          e.click();
          // e.classList.add('active');
        }
      });
    }
  }
  
  if (setProduct[2].property == "shankSelection" || setProduct[1].property == "shankSelection" ){
    if (document.querySelector('.pplr-fancy-shanks:not(.pplr_no_preview)')) {
      document.querySelector('.pplr-fancy-shanks:not(.pplr_no_preview)').querySelectorAll(".pplr-drop-item").forEach(async (e) => {
        let shankSelection = e.dataset.value.split("__")[1];
        let setShankSelection = shankSelection.split("***")[0];     
        if(setShankSelection == setProduct[1].value || setShankSelection == setProduct[2].value){
          e.classList.add('active');
        }
      });
    } else if (document.querySelector('.pplr-plain-shanks:not(.pplr_no_preview)')) {
        document.querySelector('.pplr-plain-shanks:not(.pplr_no_preview)').querySelectorAll(".pplr-drop-item").forEach(async (e) => {
          let shankSelection = e.dataset.value.split("__")[1];
          let setShankSelection = shankSelection.split("***")[0];
          if(setShankSelection == setProduct[1].value || setShankSelection == setProduct[2].value){
            e.classList.add('active');
          }
        });
      }
  }

  if (setProduct[3].property == "santaBarbaraFinish" || setProduct[2].property == "santaBarbaraFinish") {
    if(document.querySelector('.pplr-bit-shank-color:not(.pplr_no_preview)')) {
      document.querySelector('.pplr-bit-shank-color:not(.pplr_no_preview)').querySelectorAll(".pplr-drop-item").forEach(async (e) => {
        let santaBarbaraFinish = e.dataset.value.split("__")[1];  
        if (santaBarbaraFinish == setProduct[3].value || santaBarbaraFinish == setProduct[2].value) {
          e.classList.add('active');
        }
      });
    }
  }

  if (setProduct[8].property.includes('shankOverlay') || setProduct[7].property == "santaBarbaraFinish") {
    if(document.querySelector('.pplr-bit-overlays:not(.pplr_no_preview)')) {
      document.querySelector('.pplr-bit-overlays:not(.pplr_no_preview)').querySelectorAll(".pplr-drop-item").forEach(async (e) => {
        let shankOverlay = e.dataset.value.split("__")[1];  
        if (shankOverlay == setProduct[8].value || shankOverlay == setProduct[7].value) {
          e.classList.add('active');
        }
      });
    }
  }
}

async function captureScreenShot() {
  if (!visual) {
    visual = window.Atlatl.Visual.getInstances()[0]
  }
  const handleImg = async (base64) => {
    //console.log('The base64 encoded image data is Calledd....!');
    document.querySelector('.product-variantoptions-img').value = base64;
    return Promise.resolve();
  };
  await visual.captureImage({
      imageHandler: handleImg,
      sizeOptions: {
        height: 400,
        width: 400
      },
      antialiasing: true
  })
}

async function setValue(property, value){
  console.log(`%csetValue('${property}', '${value}');`, 'background:#15803D;border-radius:1rem;color:#FFF; padding:0.25rem 0.5rem;');
  console.log('previous values:', product.getValues());
  //const loadingDiv = document.getElementById('custom-loading-screen');
  //loadingDiv.style.display = 'grid';
  return new Promise(async (resolve) => {
    await product.setValue(property, value)
    console.log('done');
    resolve()
    //loadingDiv.style.display = 'none';
  });
}

async function SetProperty(){
 LoadCIProduct = "";LoadChainpiece = "";LoadMouthpiece = "",LoadFancyshank = "",LoadPlainshank = "",LoadColorshank = "",LoadOvarlayshank = "",DataPropertyUrl="",LoadCustInscription="",LoadCustMouthwidth="",LoadSilverLetter="";
  
 if(document.querySelector('.pplr-bit-mouthpiece')){
  var ProductshankOPT = document.querySelector('.pplr-bit-mouthpiece').querySelector('.pplr_select').value.split('__')[1];
  if(ProductshankOPT != undefined){    
   LoadCIProduct = ProductshankOPT;
  }
 }
 if(document.querySelector('.pplr-mouthpiecechain:not(.pplr_no_preview)')){
  var ProductchainOPT = document.querySelector('.pplr-mouthpiecechain:not(.pplr_no_preview)').querySelector('.pplr_select').value.split('__')[1];
  if(ProductchainOPT != undefined){    
   LoadChainpiece = ProductchainOPT;
  }
 }
 if(document.querySelector('.pplr-mouthpiece:not(.pplr_no_preview)')){
    var MouthpieceshankOPT = document.querySelector('.pplr-mouthpiece:not(.pplr_no_preview)').querySelector('.pplr_select').value.split('__')[1];
    if(MouthpieceshankOPT != undefined){    
     LoadMouthpiece = MouthpieceshankOPT;
    }
 }
 if(document.querySelector('.pplr-fancy-shanks:not(.pplr_no_preview)')){
  var FancyshankOPT = document.querySelector('.pplr-fancy-shanks:not(.pplr_no_preview)').querySelector('.pplr_select').value.split('__')[1];
  if(FancyshankOPT != undefined){
   if(FancyshankOPT.includes('***')){
    LoadFancyshank = FancyshankOPT.split('***')[0]
   }else{
    LoadFancyshank = FancyshankOPT;
   }
  }
 }
 if(document.querySelector('.pplr-plain-shanks:not(.pplr_no_preview)')){
  var PlainshankOPT = document.querySelector('.pplr-plain-shanks:not(.pplr_no_preview)').querySelector('.pplr_select').value.split('__')[1];
  if(PlainshankOPT != undefined){
   if(PlainshankOPT.includes('***')){
    LoadPlainshank = PlainshankOPT.split('***')[0]
   }else{
    LoadPlainshank = PlainshankOPT;
   }
  }
 }
 if(document.querySelector('.pplr-bit-shank-color:not(.pplr_no_preview)')){
  var ColorshankOPT = document.querySelector('.pplr-bit-shank-color:not(.pplr_no_preview)').querySelector('.pplr_select').value.split('__')[1];
  if(ColorshankOPT != undefined){    
   LoadColorshank = ColorshankOPT;
  }
 }
 if(document.querySelector('.pplr-bit-overlays:not(.pplr_no_preview)')){
  if(document.querySelector('.pplr-bit-overlays:not(.pplr_no_preview)').style.display != "none"){
   var OvarlayshankOPT = document.querySelector('.pplr-bit-overlays:not(.pplr_no_preview)').querySelector('.pplr_select').value.split('__')[1];
   if(OvarlayshankOPT != undefined){    
    LoadOvarlayshank = OvarlayshankOPT;
   }
  }
 }
 if(document.querySelector('.pplr-custom-inscription--5000')){
   var LoadCustInscription = document.querySelector('.pplr-custom-inscription--5000').querySelector('.pplr_text').value;
 }
 if(document.querySelector('.pplr-custom-mouth-width-5000')){
   var LoadCustMouthwidth = document.querySelector('.pplr-custom-mouth-width-5000').querySelector('.pplr_text').value;
 }
 if(document.querySelector('.pplr-316-silver-letters-14-per-letter')){
   var LoadSilverLetter = document.querySelector('.pplr-316-silver-letters-14-per-letter').querySelector('.pplr_text').value;
 }
  

  if(document.querySelector('.product-variantoptions')){
    var saveLoginBtnLength = Number(document.querySelectorAll('#save_bit_btn_login').length);
    var bitLoginURL = '';
    if(saveLoginBtnLength > 0){
      var saveLoginBtn = document.getElementById('save_bit_btn_login');
      bitLoginURL = saveLoginBtn.getAttribute('data-link') + '?';
    }
    DataPropertyUrl = document.querySelector('.product-variantoptions').getAttribute('data-value');
    DataPropertyUrl = DataPropertyUrl + "?";
    if(LoadCIProduct != ""){
      DataPropertyUrl = DataPropertyUrl + "loadproduct=" + LoadCIProduct;
      bitLoginURL = bitLoginURL + "loadproduct=" + LoadCIProduct;
    }
    if(LoadChainpiece != ""){
      DataPropertyUrl = DataPropertyUrl + "&chainpiece=" + LoadChainpiece;
      bitLoginURL = bitLoginURL + "&chainpiece=" + LoadChainpiece;
    }
    if(LoadMouthpiece != ""){
      DataPropertyUrl = DataPropertyUrl + "&mouthpiece=" + LoadMouthpiece;
      bitLoginURL = bitLoginURL + "&mouthpiece=" + LoadMouthpiece;
    }
    if(LoadFancyshank != ""){
      DataPropertyUrl = DataPropertyUrl + "&fancyshank=" + LoadFancyshank;
      bitLoginURL = bitLoginURL + "&fancyshank=" + LoadFancyshank;
    }
    if(LoadPlainshank != ""){
      DataPropertyUrl = DataPropertyUrl + "&plainshank=" + LoadPlainshank;
      bitLoginURL = bitLoginURL + "&plainshank=" + LoadPlainshank;
    }
    if(LoadColorshank != ""){
      DataPropertyUrl = DataPropertyUrl + "&shankcolor=" + LoadColorshank;
      bitLoginURL = bitLoginURL + "&shankcolor=" + LoadColorshank;
    }
    if(LoadOvarlayshank != ""){
      DataPropertyUrl = DataPropertyUrl + "&shankovarlay=" + LoadOvarlayshank;
      bitLoginURL = bitLoginURL + "&shankovarlay=" + LoadOvarlayshank;
    }
    if(LoadCustInscription != ""){
      DataPropertyUrl = DataPropertyUrl + "&custinscription=" + LoadCustInscription;
      bitLoginURL = bitLoginURL + "&custinscription=" + LoadCustInscription;
    }
    if(LoadCustMouthwidth != ""){
      DataPropertyUrl = DataPropertyUrl + "&custmouthwidth=" + LoadCustMouthwidth;
      bitLoginURL = bitLoginURL + "&custmouthwidth=" + LoadCustMouthwidth;
    }
    if(LoadSilverLetter != ""){
      DataPropertyUrl = DataPropertyUrl + "&custsilverletter=" + LoadSilverLetter;
      bitLoginURL = bitLoginURL + "&custsilverletter=" + LoadSilverLetter;
    }
    //console.log("After Load Final --> ",DataPropertyUrl);
    DataPropertyUrl = DataPropertyUrl.replaceAll(" ",'~');
    const encodedURL = encodeURIComponent(DataPropertyUrl);
    // document.querySelector('.product-variantoptions').value = DataPropertyUrl;
    document.querySelector('.product-variantoptions').value = encodedURL;

    bitLoginURL = bitLoginURL.replaceAll(" ",'~');
    // const LoginencodedURL = encodeURIComponent(bitLoginURL);
    if(saveLoginBtnLength > 0){
      document.getElementById('save_bit_btn_login').setAttribute('href',bitLoginURL);
    }
    /* Save Bit code start */
    if(document.querySelectorAll('#SaveBitBtn').length > 0){
      document.getElementById('SaveBitBtn').classList.remove('hidden');
    }
    /* Save Bit code end */
  }
}

async function setupRotationControl(modalElement,product) {
  modalElement.onmousemove = function(e) {
    product.setValue('rotateProduct', false);
  }
  modalElement.onmouseout = function(e) {
    product.setValue('rotateProduct', true);
  }
  modalElement.addEventListener('touchstart', function(e) {
    product.setValue('rotateProduct', false);
  });
  modalElement.addEventListener('touchend', function(e) {
    product.setValue('rotateProduct', true);
  });
  modalElement.addEventListener('touchcancel', function(e) {
    product.setValue('rotateProduct', true);
  });
  document.getElementById('dopple-render-canvas').addEventListener('pointerdown', () => {
    document.body.classList.add('is-dragging');
  });
  document.body.addEventListener('pointerup', () => {
    document.body.classList.remove('is-dragging');
  });
}

let SETMOUTHCHAIN, SETMOUTH, SETFSPLIT, SETFANCY, SETPSPLIT, SETPLAIN, SETCOLOR, SETOVERLAY;

function wait(ms = 0) {
  return new Promise((resolve) => {
    setTimeout(resolve, ms);
  });
}

window.intervalId = 0;

async function Signatureoption($th_id_arrayload){
  //console.log("$th_id_array",$th_id_array);
  if($th_id_arrayload.length > 0){
    async function checkOverlayRemoved() {
      var ProdPersonalizer = document.querySelector(".product-personalizer");
      if(!ProdPersonalizer.classList.contains('disabled_btn')){
        var $th_request = $th_id_arrayload.shift();
        if($th_request){
        var $th_tempTitle = $th_request.title;
        var $th_tempVal = $th_request.Value;
        //console.log('$th_tempTitle::::::::::::::::::::::::::::::::::::::::::::::::::::',$th_tempTitle, $th_tempVal,$th_id_arrayload);
        //console.log("$th_tempTitle --->>",$th_tempTitle);
        if( $th_tempTitle == "shankmoth" ){
          //console.log("Chainpiece Selected --->>>>  ");
          if(document.querySelector('.pplr-mouthpiecechain:not(.pplr_no_preview)')){
            document.querySelector('.pplr-mouthpiecechain:not(.pplr_no_preview)').querySelectorAll(".pplr-drop-item").forEach(async (Che) => {
            SETMOUTHCHAIN = Che.dataset.value.split("__")[1];
              if(SETMOUTHCHAIN == $th_tempVal){
                //console.log(SETMOUTHCHAIN+"  --->>>>  "+$th_tempVal);
                Che.click();
              }
            })
          }
        }
        if( $th_tempTitle == "mouthpiece" ){
          //console.log("Mouthpiece Selected --->>>>  ");
          if(document.querySelector('.pplr-mouthpiece:not(.pplr_no_preview)')){
              document.querySelector('.pplr-mouthpiece:not(.pplr_no_preview)').querySelectorAll(".pplr-drop-item").forEach(async (Me) => {
              SETMOUTH = Me.dataset.value.split("__")[1];
                if(SETMOUTH == $th_tempVal){
                  //console.log(SETMOUTH+"  --->>>>  "+$th_tempVal);
                  Me.click();
                }
              })
          }
        }
        if( $th_tempTitle == "fancyShank" ){
          //console.log("FancyShank Selected --->>>>  ");
          if(document.querySelector('.pplr-fancy-shanks:not(.pplr_no_preview)')){
            document.querySelector('.pplr-fancy-shanks:not(.pplr_no_preview)').querySelectorAll(".pplr-drop-item").forEach(async (Fe) => {
              SETFSPLIT = Fe.dataset.value.split("__")[1];
              SETFANCY = SETFSPLIT.split("***")[0];
              if(SETFANCY == $th_tempVal){
                //console.log(SETFANCY+"  --->>>>  "+$th_tempVal);
                Fe.click();
              }
            })
          }
        }
        if( $th_tempTitle == "plainShank" ){
          //console.log("PlainShank Selected --->>>>  ");
          if(document.querySelector('.pplr-plain-shanks:not(.pplr_no_preview)')){
            document.querySelector('.pplr-plain-shanks:not(.pplr_no_preview)').querySelectorAll(".pplr-drop-item").forEach(async (Pe) => {
              SETPSPLIT = Pe.dataset.value.split("__")[1];
              SETPLAIN = SETPSPLIT.split("***")[0];
              if(SETPLAIN == $th_tempVal){
                //console.log(SETPLAIN+"  --->>>>  "+$th_tempVal);
                Pe.click();
              }
              await document.querySelector('.pplr-bit-mouthpiece').classList.remove("orderby-loadprod");
              await document.querySelector('body').classList.remove('overlay_canvas_show');
            })
          }
        }
        if( $th_tempTitle == "shankColor" ){
          //console.log("ShankColor Selected --->>>>  ");
          if(document.querySelector('.pplr-bit-shank-color:not(.pplr_no_preview)')){
            document.querySelector('.pplr-bit-shank-color:not(.pplr_no_preview)').querySelectorAll(".pplr-drop-item").forEach(async (COe) => {
              SETCOLOR = COe.dataset.value.split("__")[1];
              if(SETCOLOR == $th_tempVal){
                //console.log(SETCOLOR+"  --->>>>  "+$th_tempVal);
                COe.click();
              }
            })
          }
        }
        if( $th_tempTitle == "shankOverlay" ){
          //console.log("ShankOverlay Selected --->>>>  ");
          if(document.querySelector('.pplr-bit-overlays:not(.pplr_no_preview)')){
            document.querySelector('.pplr-bit-overlays:not(.pplr_no_preview)').querySelectorAll(".pplr-drop-item").forEach(async (OVE) => {
              SETOVERLAY = OVE.dataset.value.split("__")[1];
              if(SETOVERLAY == $th_tempVal){
                //console.log(SETOVERLAY+"  --->>>>  "+$th_tempVal);
                OVE.click();
              }
              await document.querySelector('.pplr-bit-mouthpiece').classList.remove("orderby-loadprod");
              await document.querySelector('body').classList.remove('overlay_canvas_show');
            })
          }
        }
       } else{
         // console.log('Outer clear called', intervalId);
      }
     }
    }
    setTimeout(checkOverlayRemoved, 2000);
    await wait(1000);
    await Signatureoption($th_id_arrayload);
  } else{
    setupRotationControl(modalElement,product)
    setTimeout(async () => {
      document.getElementById('dopple-loading-screen').style.display = "none";
      document.querySelector('.product-personalizer').classList.remove('disabled_btn');
      await SetProperty();
      await product.setValue('rotateProduct', false);
      await product.setValue('restoreInitialCameraView', true)
      setTimeout(async () => {
        captureScreenShot()  
        await product.setValue('rotateProduct', true);
      },500);
    }, 500);
    await wait(5000);
    if(document.querySelector('.loading_widget_load')){
      await document.querySelector('body').classList.remove('overlay_wrapp_show');
    }
    //await document.querySelector('body').classList.remove('loading_widget_show');
  }
}

window.intervalId_load = 0;

async function Signatureoptionload($th_id_array,DataselectCIname,loadProduct,custInscription,custMouthWidth,custSilverLetter){
  if($th_id_array.length > 0){
    //console.log('$th_id_array-->> ',$th_id_array);
    async function checkOverlayRemovedload() {
      var ProdPersonalizer = document.querySelector(".product-personalizer");
      if(!ProdPersonalizer.classList.contains('disabled_btn')){
        var $th_request = $th_id_array.shift();
        if($th_request){
          var $th_tempTitle = $th_request.property;
          var $th_tempVal = $th_request.value;
          if($th_tempTitle == "loadProduct"){
            var DataloadProduct = DataselectCIname+'__'+loadProduct;
            await document.querySelector('.pplr-bit-mouthpiece').classList.add("clickby-cartprod");
            await document.querySelector('.pplr-bit-mouthpiece').querySelector('.pplr-drop-item[data-value="'+DataloadProduct+'"]').click();
            await document.querySelector('.product-personalizer').classList.remove('disabled_btn');
          } 
          if( $th_tempTitle == "chainpiece" ){
            if(document.querySelector('.pplr-mouthpiecechain:not(.pplr_no_preview)')){
              document.querySelector('.pplr-mouthpiecechain:not(.pplr_no_preview)').querySelectorAll(".pplr-drop-item").forEach(async (Che) => {
              var SETMOUTH = Che.dataset.value.split("__")[1];
                if(SETMOUTH == $th_tempVal){
                  Che.click();
                }
              })
            }
          } 
          if( $th_tempTitle == "mouthpiece" ){
            if(document.querySelector('.pplr-mouthpiece:not(.pplr_no_preview)')){
              document.querySelector('.pplr-mouthpiece:not(.pplr_no_preview)').querySelectorAll(".pplr-drop-item").forEach(async (Me) => {
              var SETMOUTH = Me.dataset.value.split("__")[1];
                if(SETMOUTH == $th_tempVal){
                  Me.click();
                }
              })
            }
          } 
          if( $th_tempTitle == "fancyShank" ){
            if(document.querySelector('.pplr-fancy-shanks:not(.pplr_no_preview)')){
              document.querySelector('.pplr-fancy-shanks:not(.pplr_no_preview)').querySelectorAll(".pplr-drop-item").forEach(async (Fe) => {
                var SETFSPLIT = Fe.dataset.value.split("__")[1];
                var SETFANCY = SETFSPLIT.split("***")[0];
                if(SETFANCY == $th_tempVal){
                  Fe.click();
                }
              })
            }
          } 
          if( $th_tempTitle == "plainShank" ){
            if(document.querySelector('.pplr-plain-shanks:not(.pplr_no_preview)')){
              document.querySelector('.pplr-plain-shanks:not(.pplr_no_preview)').querySelectorAll(".pplr-drop-item").forEach(async (Pe) => {
                var SETPSPLIT = Pe.dataset.value.split("__")[1];
                var SETPLAIN = SETPSPLIT.split("***")[0];
                if(SETPLAIN == $th_tempVal){
                  Pe.click();
                  await wait(1500);
                  await document.querySelector('.pplr-bit-mouthpiece').classList.remove("orderby-loadprod");
                  await document.querySelector('.pplr-bit-mouthpiece').classList.remove("clickby-cartprod");
                  if(document.querySelector('.loading_widget_load')){
                    await document.querySelector('body').classList.remove('overlay_wrapp_show');
                  }
                  await document.querySelector('body').classList.remove('overlay_canvas_show');
                  //await document.querySelector('body').classList.remove('loading_widget_show');
                }
              })
            }
          } 
          if( $th_tempTitle == "shankColor" ){
            if(document.querySelector('.pplr-bit-shank-color:not(.pplr_no_preview)')){
              document.querySelector('.pplr-bit-shank-color:not(.pplr_no_preview)').querySelectorAll(".pplr-drop-item").forEach(async (COe) => {
                var SETCOLOR = COe.dataset.value.split("__")[1];
                if(SETCOLOR == $th_tempVal){
                  COe.click();
                }
              })
            }
          } 
          if( $th_tempTitle == "shankOverlay" ){
            if(document.querySelector('.pplr-bit-overlays:not(.pplr_no_preview)')){
              document.querySelector('.pplr-bit-overlays:not(.pplr_no_preview)').querySelectorAll(".pplr-drop-item").forEach(async (OVE) => {
                var SETOVERLAY = OVE.dataset.value.split("__")[1];
                if(SETOVERLAY == $th_tempVal){
                  OVE.click();
                  await wait(1500);
                  await document.querySelector('.pplr-bit-mouthpiece').classList.remove("orderby-loadprod");
                  await document.querySelector('.pplr-bit-mouthpiece').classList.remove("clickby-cartprod");
                  if(document.querySelector('.loading_widget_load')){
                    await document.querySelector('body').classList.remove('overlay_wrapp_show');
                    
                  }
                  await document.querySelector('body').classList.remove('overlay_canvas_show');
                  //await document.querySelector('body').classList.remove('loading_widget_show');
                }
              })
            }
          }
        } else{
          //console.log('Outer clear called', intervalId_load);
        }
      }
    }
    setTimeout(checkOverlayRemovedload, 2000);
    await wait(3500);
    await Signatureoptionload($th_id_array,DataselectCIname,loadProduct,custInscription,custMouthWidth,custSilverLetter);
  } else{
    if(custInscription){
      document.querySelector('.pplr-custom-inscription--5000').querySelector('.pplr_text').value = custInscription.replaceAll('~'," ");
    }
    if(custMouthWidth){
      document.querySelector('.pplr-custom-mouth-width-5000').querySelector('.pplr_text').value = custMouthWidth.replaceAll('~'," ");
    }
    if(custSilverLetter){
      document.querySelector('.pplr-316-silver-letters-14-per-letter').querySelector('.pplr_text').value = custSilverLetter.replaceAll('~'," ");
    }
    setupRotationControl(modalElement,product)
    setTimeout(async () => {
      document.getElementById('dopple-loading-screen').style.display = "none";
      document.querySelector('.product-personalizer').classList.remove('disabled_btn');
      await SetProperty();
      await product.setValue('rotateProduct', false);
      await product.setValue('restoreInitialCameraView', true)
      setTimeout(async () => {
        captureScreenShot()  
        await product.setValue('rotateProduct', true);
      },500);
    }, 500);
  }
}

window.addEventListener('pplrAppInitiated' , function(e) {
  const PPLBTNS = document.querySelectorAll('.pplr-wrapper:not(.pplr-brand-upload)');
  PPLBTNS.forEach(PPLBTN => {
    const PPLABELSPLIT = PPLBTN.querySelector('.pplrlabel').textContent.split("__")[0];
    PPLBTN.querySelector('.pplrlabel').textContent = PPLABELSPLIT;
    const PPLABELHANDLE = PPLABELSPLIT.toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/-$/, '').replace(/^-/, '');
    if(PPLBTN.classList.contains("pplr-_mouthpiece__chain3in1") || PPLBTN.classList.contains("pplr-_mouthpiece__chain4runner") || PPLBTN.classList.contains("pplr-_mouthpiece__chain") || PPLBTN.classList.contains("pplr-_mouthpiece__chaindoublecross") || PPLBTN.classList.contains("pplr-_mouthpiece__chainflatbar") || PPLBTN.classList.contains("pplr-_mouthpiece__chainhalf-half") || PPLBTN.classList.contains("pplr-_mouthpiece__chainiron-worker") || PPLBTN.classList.contains("pplr-_mouthpiece__chainlife-saver") || PPLBTN.classList.contains("pplr-_mouthpiece__chainported") || PPLBTN.classList.contains("pplr-_mouthpiece__chainrenegade") || PPLBTN.classList.contains("pplr-_mouthpiece__chaintwisted-snaffle")){
      PPLBTN.classList.add("pplr-mouthpiecechain");
    }else{
      PPLBTN.classList.add("pplr-"+PPLABELHANDLE);
    }
    const buttons = PPLBTN.querySelectorAll('.pplr-drop-item');
    buttons.forEach(button => {
      var TextContent = button.dataset.value.split("__");
      if(button.textContent.includes("Baseline Advantage Long")  || button.textContent.includes("Baseline Advantage Short")){
        var finaltext = TextContent[0].replace('Baseline ','');
      }else{
        var finaltext = TextContent[0];
      }
      button.textContent = finaltext;
    });
  });
  setTimeout(() => {
    // Load after Add Image Start
    var SilverLatter = document.querySelector('.pplr-316-silver-letters-14-per-letter');
    if(SilverLatter) {
      var imageWrapper = document.createElement("div");
      imageWrapper.className = "PPLRLatter_image_wrapper";
      var imageElement = document.createElement("img");
      imageElement.src = "https://cdn.shopify.com/s/files/1/0548/8613/7900/files/silver_letter.png?v=1685532862";
      imageElement.className = "PPLRLatter__image";
      imageElement.id = "SilverLatter__image";
      imageWrapper.appendChild(imageElement);
      var inputElement = SilverLatter.querySelector('input[type="text"].pplr_text');
      
      if(inputElement) {
        inputElement.parentNode.insertBefore(imageWrapper, inputElement.nextSibling);
      }
    }
    var BrandUpload = document.querySelectorAll('.pplr-brand-upload');
    BrandUpload.forEach(function(element) {
      var inputParent = element.querySelector('.pplrfileuploadbutton');
      var imageWrapper = document.createElement("div");
      imageWrapper.className = "PPLRLatter_image_wrapper";
      
      var imageElement = document.createElement("img");
      imageElement.src = "https://cdn.shopify.com/s/files/1/0548/8613/7900/files/d80f13d4-088a-44d4-bdbe-c5e6a4ac3e19.png?v=1715690627";
      imageElement.className = "PPLRLatter__image";
      imageElement.id = "BrandUpload__image";
      imageWrapper.appendChild(imageElement);
      inputParent.parentNode.insertBefore(imageWrapper, inputParent.nextSibling);
    });
    var InscriptionLatter = document.querySelector('.pplr-custom-inscription--5000');
    if(InscriptionLatter) {
      var imageWrapper = document.createElement("div");
      imageWrapper.className = "PPLRLatter_image_wrapper";
      var imageElement = document.createElement("img");
      imageElement.src = "https://cdn.shopify.com/s/files/1/0548/8613/7900/files/BIT_INSCRIPTION_STAMPED_2_b80fb985-c7e9-4536-9cee-d4853e005c11.png?v=1686027431";
      imageElement.className = "PPLRLatter__image";
      imageElement.id = "InscriptionLatter__image";
      imageWrapper.appendChild(imageElement);
      var inputElement = InscriptionLatter.querySelector('input[type="text"].pplr_text');
      if (inputElement) {
        inputElement.parentNode.insertBefore(imageWrapper, inputElement.nextSibling);
      }
    }
    document.querySelectorAll('.PPLRLatter_image_wrapper .PPLRLatter__image').forEach(PPLWRIMG => {
      PPLWRIMG.addEventListener('click', (simg) => {
        var IMGURL = simg.target.getAttribute("src");
        simg.target.closest('section').querySelector('.incription_image_popup').classList.add('active');
        simg.target.closest('section').querySelector('.incription_image_popup').querySelector('#incription_image').src = IMGURL;
      });
    });
  }, 3000);

  
  PPLBTNS.forEach(PPLWRAPP => {
    const buttons = PPLWRAPP.querySelectorAll('.pplr-drop-item');
    buttons.forEach(button => {
      button.addEventListener('click', async (event) => {
        if(document.querySelector('.pplr-bit-mouthpiece')){
          const SElPPLBTNS = document.querySelectorAll('.pplr-wrapper:not(.pplr_no_preview)');
          var DataValueLeft = "";
          var DataValueRight = "";
          var DataValueHandle = "";
          var DataValueShank = false;
          var DataValueShankfinish = false;
          var DataValueShankoverlay = false;
          var DataValueDefine = false; 
          var DataValueBtn = event.target.dataset.value;
          var DataValueBtnsplit = DataValueBtn.split("__");
          var DataValueProperty = DataValueBtnsplit[0];
          var DataselectMouthset = '';
  
          var DataselectCIname = document.querySelector('.pplr-bit-mouthpiece').querySelector('.pplr_select').value.split("__")[0];
          if (document.querySelector('.pplr-mouthpiece.pplr_show_preview')){
              if(document.querySelector('.pplr-mouthpiece.pplr_show_preview').querySelector('.pplr_select').value == 'none'){
                DataselectMouthset = "";
              }else{
                DataselectMouthset = document.querySelector('.pplr-mouthpiece.pplr_show_preview').querySelector('.pplr_select').value.split("__")[1];
              }
            }
          if(DataselectCIname == "SR"){
              if(DataselectMouthset.includes('sr2_')){
                selectshanksSR2.forEach((item) => {
                  if(item.name == DataValueProperty){
                    DataValueLeft = item.left;
                    DataValueRight = item.right;
                    DataValueHandle = item.handle;
                    DataValueShank = item.shank;
                    DataValueShankfinish = item.shankfinish;
                    DataValueShankoverlay = item.shankoverlay;
                    DataValueDefine = true;
                  }
                })
              }else{
                selectshanksSR.forEach((item) => {
                  if(item.name == DataValueProperty){
                    DataValueLeft = item.left;
                    DataValueRight = item.right;
                    DataValueHandle = item.handle;
                    DataValueShank = item.shank;
                    DataValueShankfinish = item.shankfinish;
                    DataValueShankoverlay = item.shankoverlay;
                    DataValueDefine = true;
                  }
                })
              }
            }else if(DataselectCIname == "Med Port"){
              if(DataselectMouthset.includes('_NoRoller')){
                selectshanksMedPortnoRoll.forEach((item) => {
                  if(item.name == DataValueProperty){
                    DataValueLeft = item.left;
                    DataValueRight = item.right;
                    DataValueHandle = item.handle;
                    DataValueShank = item.shank;
                    DataValueShankfinish = item.shankfinish;
                    DataValueShankoverlay = item.shankoverlay;
                    DataValueDefine = true;
                  }
                })
            }else{
            selectshanksMedPort.forEach((item) => {
             if(item.name == DataValueProperty){
              DataValueLeft = item.left;
              DataValueRight = item.right;
              DataValueHandle = item.handle;
              DataValueShank = item.shank;
              DataValueShankfinish = item.shankfinish;
              DataValueShankoverlay = item.shankoverlay;
              DataValueDefine = true;
             }
            })
           }
          }else if(DataselectCIname == "Silverado"){
           if(DataselectMouthset.includes('_NoRoller')){
            selectshanksSilveradonoRoll.forEach((item) => {
             if(item.name == DataValueProperty){
              DataValueLeft = item.left;
              DataValueRight = item.right;
              DataValueHandle = item.handle;
              DataValueShank = item.shank;
              DataValueShankfinish = item.shankfinish;
              DataValueShankoverlay = item.shankoverlay;
              DataValueDefine = true;
             }
            })
           }else{
            selectshanksSilveradoRoll.forEach((item) => {
             if(item.name == DataValueProperty){
              DataValueLeft = item.left;
              DataValueRight = item.right;
              DataValueHandle = item.handle;
              DataValueShank = item.shank;
              DataValueShankfinish = item.shankfinish;
              DataValueShankoverlay = item.shankoverlay;
              DataValueDefine = true;
             }
            })
           }
          }else if(DataselectCIname == "Twisted Snaffle"){
           if(DataselectMouthset.includes('twistedWireLarge')){
            selectshanksTwistedLarge.forEach((item) => {
             if(item.name == DataValueProperty){
              DataValueLeft = item.left;
              DataValueRight = item.right;
              DataValueHandle = item.handle;
              DataValueShank = item.shank;
              DataValueShankfinish = item.shankfinish;
              DataValueShankoverlay = item.shankoverlay;
              DataValueDefine = true;
             }
            })
           }else if(DataselectMouthset.includes('twistedWireMedium')){
            selectshanksTwistedMedium.forEach((item) => {
             if(item.name == DataValueProperty){
              DataValueLeft = item.left;
              DataValueRight = item.right;
              DataValueHandle = item.handle;
              DataValueShank = item.shank;
              DataValueShankfinish = item.shankfinish;
              DataValueShankoverlay = item.shankoverlay;
              DataValueDefine = true;
             }
            })
           }else if(DataselectMouthset.includes('twistedWireSmall')){
            selectshanksTwistedSmall.forEach((item) => {
             if(item.name == DataValueProperty){
              DataValueLeft = item.left;
              DataValueRight = item.right;
              DataValueHandle = item.handle;
              DataValueShank = item.shank;
              DataValueShankfinish = item.shankfinish;
              DataValueShankoverlay = item.shankoverlay;
              DataValueDefine = true;
             }
            })
           }else if(DataselectMouthset.includes('twistedSquare')){
            selectshanksTwistedSquare.forEach((item) => {
             if(item.name == DataValueProperty){
              DataValueLeft = item.left;
              DataValueRight = item.right;
              DataValueHandle = item.handle;
              DataValueShank = item.shank;
              DataValueShankfinish = item.shankfinish;
              DataValueShankoverlay = item.shankoverlay;
              DataValueDefine = true;
             }
            })
           }else{
            selectshanksTwistedHex.forEach((item) => {
             if(item.name == DataValueProperty){
              DataValueLeft = item.left;
              DataValueRight = item.right;
              DataValueHandle = item.handle;
              DataValueShank = item.shank;
              DataValueShankfinish = item.shankfinish;
              DataValueShankoverlay = item.shankoverlay;
              DataValueDefine = true;
             }
            })
           }
          }else{ 
           selectshanks.forEach((item) => {
            if(item.name == DataValueProperty){
             DataValueLeft = item.left;
             DataValueRight = item.right;
             DataValueHandle = item.handle;
             DataValueShank = item.shank;
             DataValueShankfinish = item.shankfinish;
             DataValueShankoverlay = item.shankoverlay;
             DataValueDefine = true;
            }
           })
          }
          var PPLWrapp = event.target.closest('.pplr-wrapper');
          if(DataValueDefine == false){ 
           var FancyShank = document.querySelector('.pplr-fancy-shanks:not(.pplr_no_preview)');
           if(FancyShank){
            var FancyShankVal = FancyShank.querySelector('.pplr_select').value.split("__");
            var DataValueProperty = FancyShankVal[0];
            var DataselectCIname = document.querySelector('.pplr-bit-mouthpiece').querySelector('.pplr_select').value.split("__")[0];
            if (document.querySelector('.pplr-mouthpiece.pplr_show_preview')){
             if(document.querySelector('.pplr-mouthpiece.pplr_show_preview').querySelector('.pplr_select').value == 'none'){
                DataselectMouthset = "";
              }else{
                DataselectMouthset = document.querySelector('.pplr-mouthpiece.pplr_show_preview').querySelector('.pplr_select').value.split("__")[1];
              }
            }
            if(DataselectCIname == "SR"){
             if(DataselectMouthset.includes('sr2_')){
              selectshanksSR2.forEach((item) => {
               if(item.name == DataValueProperty){
                DataValueLeft = item.left;
                DataValueRight = item.right;
                DataValueHandle = item.handle;
                DataValueShank = item.shank;
                DataValueShankfinish = item.shankfinish;
                DataValueShankoverlay = item.shankoverlay;
                DataValueDefine = true;
               }
              })
             }else{
              selectshanksSR.forEach((item) => {
               if(item.name == DataValueProperty){
                DataValueLeft = item.left;
                DataValueRight = item.right;
                DataValueHandle = item.handle;
                DataValueShank = item.shank;
                DataValueShankfinish = item.shankfinish;
                DataValueShankoverlay = item.shankoverlay;
                DataValueDefine = true;
               }
              })
             }
            }else if(DataselectCIname == "Med Port"){
             if(DataselectMouthset.includes('_NoRoller')){
              selectshanksMedPortnoRoll.forEach((item) => {
               if(item.name == DataValueProperty){
                DataValueLeft = item.left;
                DataValueRight = item.right;
                DataValueHandle = item.handle;
                DataValueShank = item.shank;
                DataValueShankfinish = item.shankfinish;
                DataValueShankoverlay = item.shankoverlay;
                DataValueDefine = true;
               }
              })
             }else{
              selectshanksMedPort.forEach((item) => {
               if(item.name == DataValueProperty){
                DataValueLeft = item.left;
                DataValueRight = item.right;
                DataValueHandle = item.handle;
                DataValueShank = item.shank;
                DataValueShankfinish = item.shankfinish;
                DataValueShankoverlay = item.shankoverlay;
                DataValueDefine = true;
               }
              })
             }
            }else if(DataselectCIname == "Silverado"){
             if(DataselectMouthset.includes('_NoRoller')){
              selectshanksSilveradonoRoll.forEach((item) => {
               if(item.name == DataValueProperty){
                DataValueLeft = item.left;
                DataValueRight = item.right;
                DataValueHandle = item.handle;
                DataValueShank = item.shank;
                DataValueShankfinish = item.shankfinish;
                DataValueShankoverlay = item.shankoverlay;
                DataValueDefine = true;
               }
              })
             }else{
              selectshanksSilveradoRoll.forEach((item) => {
               if(item.name == DataValueProperty){
                DataValueLeft = item.left;
                DataValueRight = item.right;
                DataValueHandle = item.handle;
                DataValueShank = item.shank;
                DataValueShankfinish = item.shankfinish;
                DataValueShankoverlay = item.shankoverlay;
                DataValueDefine = true;
               }
              })
             }
            }else if(DataselectCIname == "Twisted Snaffle"){
             if(DataselectMouthset.includes('twistedWireLarge')){
              selectshanksTwistedLarge.forEach((item) => {
               if(item.name == DataValueProperty){
                DataValueLeft = item.left;
                DataValueRight = item.right;
                DataValueHandle = item.handle;
                DataValueShank = item.shank;
                DataValueShankfinish = item.shankfinish;
                DataValueShankoverlay = item.shankoverlay;
                DataValueDefine = true;
               }
              })
             }else if(DataselectMouthset.includes('twistedWireMedium')){
              selectshanksTwistedMedium.forEach((item) => {
               if(item.name == DataValueProperty){
                DataValueLeft = item.left;
                DataValueRight = item.right;
                DataValueHandle = item.handle;
                DataValueShank = item.shank;
                DataValueShankfinish = item.shankfinish;
                DataValueShankoverlay = item.shankoverlay;
                DataValueDefine = true;
               }
              })
             }else if(DataselectMouthset.includes('twistedWireSmall')){
              selectshanksTwistedSmall.forEach((item) => {
               if(item.name == DataValueProperty){
                DataValueLeft = item.left;
                DataValueRight = item.right;
                DataValueHandle = item.handle;
                DataValueShank = item.shank;
                DataValueShankfinish = item.shankfinish;
                DataValueShankoverlay = item.shankoverlay;
                DataValueDefine = true;
               }
              })
             }else if(DataselectMouthset.includes('twistedSquare')){
              selectshanksTwistedSquare.forEach((item) => {
               if(item.name == DataValueProperty){
                DataValueLeft = item.left;
                DataValueRight = item.right;
                DataValueHandle = item.handle;
                DataValueShank = item.shank;
                DataValueShankfinish = item.shankfinish;
                DataValueShankoverlay = item.shankoverlay;
                DataValueDefine = true;
               }
              })
             }else{
              selectshanksTwistedHex.forEach((item) => {
               if(item.name == DataValueProperty){
                DataValueLeft = item.left;
                DataValueRight = item.right;
                DataValueHandle = item.handle;
                DataValueShank = item.shank;
                DataValueShankfinish = item.shankfinish;
                DataValueShankoverlay = item.shankoverlay;
                DataValueDefine = true;
               }
              })
             }
            }else{
             selectshanks.forEach((item) => {
              if(item.name == DataValueProperty){
               DataValueLeft = item.left;
               DataValueRight = item.right;
               DataValueHandle = item.handle;
               DataValueShank = item.shank;
               DataValueShankfinish = item.shankfinish;
               DataValueShankoverlay = item.shankoverlay;
              }
             })
            }
           }
          }
          var PPLWrapp = event.target.closest('.pplr-wrapper');
          document.getElementById('dopple-loading-screen').style.display = "flex";
          if(PPLWrapp.classList.contains("pplr-bit-mouthpiece")){
            document.querySelector('body').classList.add('loading_widget_show');
            SElPPLBTNS.forEach(SElPPLBTN => {
             if(!SElPPLBTN.classList.contains("pplr-bit-mouthpiece")){
              var ClassActive = SElPPLBTN.querySelector('.pplr-drop-item.active');
              if(ClassActive){ 
               SElPPLBTN.querySelector('.pplr_select').value = "none";
               ClassActive.classList.remove('active');
              }
             }
            });
            
            console.log('loadNewProduct(', DataValueBtnsplit[1], ');')
            await loadNewProduct(DataValueBtnsplit[1]);

            
          } else {
            //console.log("checked Click is workd for options");
            // if(!document.querySelector('.loading_widget_show')){
            //   document.getElementById('dopple-loading-screen').style.display = "flex";
            // }
            document.querySelector('.product-personalizer').classList.add('disabled_btn');
            const copyItems = [];
            const SElPPLWRAPPS = document.querySelectorAll('.pplr-wrapper:not(.pplr_no_preview)');
            SElPPLWRAPPS.forEach(SElPPLWRAPP => {
              if(SElPPLWRAPP.querySelector('.pplr_select')){
                let KeyVAL =  SElPPLWRAPP.querySelector('.pplr_select').value;
                var Keyvalsplit = KeyVAL.split("__");
                var Property = Keyvalsplit[0];
                var Namspace = Keyvalsplit[1];
                if(Namspace != 'undefined' && Namspace != null && Namspace != ''){
                  copyItems.push(Namspace);
                }
              }
            });
            // Start Show Hide Shanks Button Activation
            if(PPLWrapp.classList.contains("pplr-fancy-shanks")){
              if(document.querySelector('.pplr-plain-shanks:not(.pplr_no_preview)')){
                const PLAINSHANK = document.querySelector('.pplr-plain-shanks:not(.pplr_no_preview)');
                PLAINSHANK.querySelector('.pplr_select').value = "none";
                var ClassActive = PLAINSHANK.querySelector('.pplr-drop-item.active');
                if(ClassActive){ 
                  ClassActive.classList.remove('active');
                }
              }
            }
            if(PPLWrapp.classList.contains("pplr-plain-shanks")){
              const PLAINSHANKS = document.querySelectorAll('.pplr-wrapper:not(.pplr_no_preview)');
              PLAINSHANKS.forEach(PLAINSHANK => {
                if(PLAINSHANK.classList.contains("pplr-fancy-shanks")){
                  
                  PLAINSHANK.querySelector('.pplr_select').value = "none";
                  var ClassActive = PLAINSHANK.querySelector('.pplr-drop-item.active');
                  if(ClassActive){ 
                    ClassActive.classList.remove('active');
                  }
                }else if(PLAINSHANK.classList.contains("pplr-bit-shank-color")){
                  
                  PLAINSHANK.classList.add('pplr_no_preview');
                  PLAINSHANK.classList.remove('pplr_show_preview');
                  PLAINSHANK.style.display = "none";
                }
              });
            }
            const OVERLAYSHANKS = document.querySelector('.pplr-bit-overlays');
            if(document.querySelectorAll('.pplr-bit-shank-color:not(.pplr_no_preview)').length > 0) {
              OVERLAYSHANKS.style.display = "block";
            }else{
              OVERLAYSHANKS.style.display = "none";
            }
            // End Show Hide Shanks Button Activation
            let PPLshanksplit = '', SHANKFirst = '', ShankNamspace = '', ShankProperty = '', Rightkey_shank = '', Leftkey_shank = '', Rightkey_shankfinish = '', Leftkey_shankfinish = '', Rightkey_shankoverlay = '', Leftkey_shankoverlay = '', Handlekey = '', shank = false, shankfinish = false, shankoverlay = false;
            if(PPLWrapp.classList.contains("pplr-mouthpiecechain")){
               //console.log("PPLR MouthPiece Chain --->>>");
               if(document.querySelector('.pplr-fancy-shanks:not(.pplr_no_preview)')){
                 var ClassActive = document.querySelector('.pplr-fancy-shanks:not(.pplr_no_preview)').querySelector('.pplr-drop-item.active');
                 if(ClassActive){ 
                   document.querySelector('.pplr-fancy-shanks:not(.pplr_no_preview)').querySelector('.pplr_select').value = "none";
                   ClassActive.classList.remove('active');
                 }
                 if(!document.querySelector(".pplr-bit-mouthpiece").classList.contains('clickby-cartprod')){
                   if(!document.querySelector('.pplr-bit-mouthpiece').classList.contains("orderby-loadprod")){
                     document.querySelector('.pplr-fancy-shanks:not(.pplr_no_preview)').querySelectorAll(".pplr-drop-item")[0].click();
                   }
                 }
               }
               if(document.querySelector('.pplr-plain-shanks:not(.pplr_no_preview)')){
                 var ClassActive = document.querySelector('.pplr-plain-shanks:not(.pplr_no_preview)').querySelector('.pplr-drop-item.active');
                 if(ClassActive){ 
                   document.querySelector('.pplr-plain-shanks:not(.pplr_no_preview)').querySelector('.pplr_select').value = "none";
                   ClassActive.classList.remove('active');
                 }
                 if(!document.querySelector(".pplr-bit-mouthpiece").classList.contains('clickby-cartprod')){
                   if(!document.querySelector('.pplr-fancy-shanks:not(.pplr_no_preview)')){
                     if(!document.querySelector('.pplr-bit-mouthpiece').classList.contains("orderby-loadprod")){
                       document.querySelector('.pplr-plain-shanks:not(.pplr_no_preview)').querySelectorAll(".pplr-drop-item")[0].click();
                     }
                   }
                 }
               }
            }else if(PPLWrapp.classList.contains("pplr-mouthpiece")){
              //console.log("PPLR MouthPiece Main --->>>");
              DataSplitmouth = document.querySelector('.pplr-mouthpiece:not(.pplr_no_preview)').querySelector('.pplr_select').value.split("__");
              DataValuemouth = DataSplitmouth[1];
              await setValue('mouthpiece', DataValuemouth);
              
               if(document.querySelector('.pplr-fancy-shanks:not(.pplr_no_preview)')){
                 var ClassActive = document.querySelector('.pplr-fancy-shanks:not(.pplr_no_preview)').querySelector('.pplr-drop-item.active');
                 if(ClassActive){ 
                   document.querySelector('.pplr-fancy-shanks:not(.pplr_no_preview)').querySelector('.pplr_select').value = "none";
                   ClassActive.classList.remove('active');
                 }
                 if(!document.querySelector('.pplr-bit-mouthpiece').classList.contains("orderby-loadprod")){
                   document.querySelector('.pplr-fancy-shanks:not(.pplr_no_preview)').querySelectorAll(".pplr-drop-item")[0].click();
                 }
               }
               if(document.querySelector('.pplr-plain-shanks:not(.pplr_no_preview)')){
                 var ClassActive = document.querySelector('.pplr-plain-shanks:not(.pplr_no_preview)').querySelector('.pplr-drop-item.active');
                 if(ClassActive){ 
                   document.querySelector('.pplr-plain-shanks:not(.pplr_no_preview)').querySelector('.pplr_select').value = "none";
                   ClassActive.classList.remove('active');
                 }
                 if(!document.querySelector('.pplr-fancy-shanks:not(.pplr_no_preview)')){
                   if(!document.querySelector('.pplr-bit-mouthpiece').classList.contains("orderby-loadprod")){
                     document.querySelector('.pplr-plain-shanks:not(.pplr_no_preview)').querySelectorAll(".pplr-drop-item")[0].click();
                   }
                 }
               }
            }else if(PPLWrapp.classList.contains("pplr-fancy-shanks") || PPLWrapp.classList.contains("pplr-plain-shanks")){
              SHANKFirst = PPLWrapp.querySelector('.pplr_select').value.split("__");
              PPLshanksplit = SHANKFirst[1].split("***");
              if(SHANKFirst[0] == 'Ballhinge Ring' || SHANKFirst[0] == 'Ballhinge D-Ring' || SHANKFirst[0] == 'D-Ring' || SHANKFirst[0] == 'West Coast Divots & Dots' || SHANKFirst[0] == 'Baseline D-Ring Snaffle'){
                Rightkey_shank = DataValueRight+".snaffle", Leftkey_shank = DataValueLeft+".snaffle";
              }else{
                Rightkey_shank = DataValueRight+".shank", Leftkey_shank = DataValueLeft+".shank";
              }
              ShankNamspace = PPLshanksplit[0], ShankProperty = PPLshanksplit[1], Handlekey = DataValueHandle, shank = DataValueShank;
              let SELECTEDSHANK = PPLshanksplit[0];
              selectoverlay.forEach((item) => {
                if(item.handle == SELECTEDSHANK){
                  if(document.querySelector('.pplr-bit-overlays:not(.pplr_no_preview)')){
                    document.querySelector('.pplr-bit-overlays:not(.pplr_no_preview)').querySelectorAll('.pplr-drop-item').forEach(($this_id) => {
                      let shank_overlay_val = $this_id.getAttribute('data-value');
                      if(item.showlist.includes(shank_overlay_val)){
                        $this_id.classList.add('overlay_found');
                        $this_id.classList.remove('overlay_not_found');
                      }else{
                        $this_id.classList.remove('overlay_found');
                        $this_id.classList.add('overlay_not_found');
                      }
                    });
                  }
                }
              });
                
              let DataSplitmouth= "", DataValuemouth = "", DataValueBtn = document.querySelector('.pplr-bit-mouthpiece .pplr_select').value, DataValueBtnsplit = DataValueBtn.split("__"), DataValueProperty = DataValueBtnsplit[1];
              
              await setValue(ShankProperty, ShankNamspace);
              
              if(PPLWrapp.classList.contains("pplr-fancy-shanks")){
                if(shank){
                
                  await setValue(Leftkey_shank, Handlekey);
                  await setValue(Rightkey_shank, Handlekey);
                }
                if(!document.querySelector('.pplr-bit-mouthpiece').classList.contains("orderby-loadprod")){
                  
                 const COLORSHANKS = document.querySelector('.pplr-bit-shank-color:not(.pplr_no_preview)');

                 let shank_color_status = false;
                 if(COLORSHANKS){
                   COLORSHANKS.querySelectorAll('.pplr-drop-item').forEach(function (e) {
                     if(e.dataset.value == 'Stainless__stainless'){
                       shank_color_status = true;
                     }  
                   })
                   if(shank_color_status){
                     COLORSHANKS.querySelector('.pplr-drop-item[data-value="Stainless__stainless"]').click();
                   }else{
                     COLORSHANKS.querySelector('.pplr-drop-item[data-value="Brown__brown"]').click();
                   }
                 }
                }
               }
              if(PPLWrapp.classList.contains("pplr-plain-shanks")){
                document.querySelector('body').classList.remove('loading_widget_show');
              }
              //console.log("URL Wrapp false -->>>", Leftkey_shank , Rightkey_shank);
            }else if(PPLWrapp.classList.contains("pplr-bit-shank-color")){
              //console.log("PPLR BIT Shanks Color --->>>");
              var FancyShankVal = document.querySelector('.pplr-fancy-shanks:not(.pplr_no_preview)').querySelector('.pplr_select').value;
              if(FancyShankVal != 'none' || FancyShankVal != ''){
                var ShankValColor = FancyShankVal.split("__")[0];
              }
              Rightkey_shankfinish = DataValueRight+".shankFinish";
              Leftkey_shankfinish = DataValueLeft+".shankFinish";
              if(ShankValColor == 'Ballhinge Ring' || ShankValColor == 'Ballhinge D-Ring' || ShankValColor == 'D-Ring' || ShankValColor == 'West Coast Divots & Dots'){
                Rightkey_shankfinish = DataValueRight+".snaffleFinish";
                Leftkey_shankfinish = DataValueLeft+".snaffleFinish";
              }
              shankfinish = DataValueShankfinish;
              
              if(document.querySelector('.pplr-bit-shank-color:not(.pplr_no_preview)')){
                const COLORSHANKSfinish = document.querySelector('.pplr-bit-shank-color:not(.pplr_no_preview)').querySelector('.pplr_select').value.split("__");
                let COLORfinish = COLORSHANKSfinish[1];
                if(ShankValColor == "Santa Barbara"){
                  await setValue("santaBarbaraFinish", COLORfinish);
                }
                if(shankfinish){
                  await setValue(Leftkey_shankfinish, COLORfinish);
                  await setValue(Rightkey_shankfinish, COLORfinish);
                }
                
                const BitOverlays = document.querySelector('.pplr-wrapper.pplr-bit-overlays:not(.pplr_no_preview)');
                var BitOverlaysselect = false;
                if(BitOverlays){
                  if(!document.querySelector('.pplr-bit-mouthpiece').classList.contains("orderby-loadprod")){
                  // Hide Brass Value On Black Shank Color Start
                  if(COLORfinish == 'black'){
                    BitOverlays.querySelectorAll('.pplr-drop-item').forEach(($this_id) => {
                      let shank_overlay_val = $this_id.getAttribute('data-value').split("__")[1];
                      if(shank_overlay_val.includes('brass')){
                        $this_id.classList.add('overlaybrass_not_found');
                      }
                    });
                  }else{
                    BitOverlays.querySelectorAll('.pplr-drop-item').forEach(($this_id) => {
                      $this_id.classList.remove('overlaybrass_not_found');
                    });
                  }
                  // Hide Brass Value On Black Shank Color End
                  // Select Default None Overlay on Shank Color Selection Start
                  BitOverlays.querySelector('.pplr_select').value = "None__none";
                  BitOverlays.querySelectorAll(".pplr-drop-item.overlay_found").forEach(function(e){
                   if(e.getAttribute('data-value') == "None__none"){
                    e.click();
                    BitOverlaysselect = true;
                   }
                  });
                  if(!BitOverlaysselect){
                   BitOverlays.querySelector('.pplr_select').value = "Dots__dots";
                    BitOverlays.querySelectorAll(".pplr-drop-item.overlay_found").forEach(function(e){
                    if(e.getAttribute('data-value') == "Dots__dots"){
                     e.click();
                    }
                   });
                  }
                  // Select Default None Overlay on Shank Color Selection End
                  }
                }
              }
            }else if(PPLWrapp.classList.contains("pplr-bit-overlays")){
              //console.log("PPLR BIT Overlay Prop --->>>");
              var FancyShankVal = document.querySelector('.pplr-fancy-shanks:not(.pplr_no_preview)').querySelector('.pplr_select').value;
              if(FancyShankVal != 'none' || FancyShankVal != ''){
                var ShankValOverlay = FancyShankVal.split("__")[0];
              }
              Rightkey_shankoverlay = DataValueRight+".shankOverlay";
              Leftkey_shankoverlay = DataValueLeft+".shankOverlay";
              if(ShankValOverlay == 'Ballhinge Ring' || ShankValOverlay == 'Ballhinge D-Ring' || ShankValOverlay == 'D-Ring' || ShankValOverlay == 'West Coast Divots & Dots'){
                Rightkey_shankoverlay = DataValueRight+".snaffleOverlay";
                Leftkey_shankoverlay = DataValueLeft+".snaffleOverlay";
              }
              shankoverlay = DataValueShankoverlay;
              const OverlaysSHANKSfinish = document.querySelector('.pplr-bit-overlays:not(.pplr_no_preview)').querySelector('.pplr_select').value.split("__");
              let Overlaysfinish = OverlaysSHANKSfinish[1];
              if(shankoverlay){
                if(Overlaysfinish == "brassDots"){
                  const FinishShankOver = document.querySelector('.pplr-fancy-shanks:not(.pplr_no_preview)').querySelector('.pplr_select').value.split("__")[0];
                  if( FinishShankOver == "Riviera" || FinishShankOver == "Teton" || FinishShankOver == "Ballhinge Ring" || FinishShankOver == "Ballhinge D-Ring" || FinishShankOver == 'D-Ring' ){
                    var Rightkey_Conchos = DataValueRight+".addConchos";
                    var Leftkey_Conchos = DataValueLeft+".addConchos";
                    await setValue(Leftkey_Conchos, false);
                    await setValue(Rightkey_Conchos, false);
                    await setValue(Leftkey_shankoverlay, Overlaysfinish);
                    await setValue(Rightkey_shankoverlay, Overlaysfinish);
                  }else{
                    await setValue(Leftkey_shankoverlay, Overlaysfinish);
                    await setValue(Rightkey_shankoverlay, Overlaysfinish);
                  }
                }else{
                  await setValue(Leftkey_shankoverlay, Overlaysfinish);
                  await setValue(Rightkey_shankoverlay, Overlaysfinish);
                }
              }
                document.querySelector('body').classList.remove('loading_widget_show');
            }
            //console.log("checked Click is workd for End");
            setTimeout(async () => {
              //console.log("checked Click is workd for Endend");
              document.querySelector('.product-personalizer').classList.remove('disabled_btn');
              await SetProperty();
              await product.setValue('rotateProduct', false);
              await product.setValue('restoreInitialCameraView', true)
              setTimeout(async () => {
                captureScreenShot()  
                await product.setValue('rotateProduct', true);
              },1500);
              setTimeout(async () => {
                setupRotationControl(modalElement,product)
                if(!document.querySelector('.loading_widget_show')){
                  document.getElementById('dopple-loading-screen').style.display = "none";
                }
              },1600);
            }, 2500);
          }
        }
      });
    });
  });
});


window.addEventListener("load", async (event) => {
  let DATALABLE, LABLEHANDLE, IMAGNAME, DATAVALOPT, DATAALT, DATAVALSTAR, IMGVAL, IMGURL , baseUrl, imgTest;
  if(document.querySelector('.product-personalizer')){
    if(document.querySelector('.pplr-bit-mouthpiece')){

      document.querySelectorAll('.pplr-wrapper').forEach((optwrapp) => {
        // Process each option wrapper
        DATALABLE = optwrapp.querySelector('.pplrlabel').innerHTML.trim();
        LABLEHANDLE = DATALABLE.toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/-$/, '').replace(/^-/, '');
        if(DATALABLE == "Bit Mouthpiece" || DATALABLE == "Fancy Shanks" || DATALABLE == "Plain Shanks"){
          //DATALABLE == "Fancy Shanks" || DATALABLE == "Plain Shanks"
          // Loop through each drop item in the wrapper
          optwrapp.querySelectorAll('.pplr-drop-item').forEach((img) => {
            var imageExists = false;
            DATAVALOPT = img.getAttribute('data-value');
            DATAALT = DATAVALOPT.split('__')[0];
            IMGVAL;
        
            if(DATAVALOPT.includes('***')){
              DATAVALSTAR = DATAVALOPT.split('__')[1];
              IMGVAL = DATAVALSTAR.split('***')[0];
            } else {
              IMGVAL = DATAVALOPT.split('__')[1];
            }
            baseUrl = "//tombalding.com/cdn/shop/files/";
            IMAGNAME = LABLEHANDLE + '-' + IMGVAL + '.png';
            IMGURL = baseUrl + IMAGNAME;         
            img.innerHTML = `
                <div class="label_text">${DATAALT}</div>
                <div class="label_image">
                  <img src="${IMGURL}" alt="${DATAALT}"/>
                </div>
              `;
          });
        }
        if(DATALABLE == "Mouthpiece"){  
          if(optwrapp.classList.contains('pplr-mouthpiece__correction')){
            optwrapp.querySelectorAll('.pplr-drop-item').forEach((img) => {
              var imageExists = false;
              DATAVALOPT = img.getAttribute('data-value');
              DATAALT = DATAVALOPT.split('__')[0];
              IMGVAL;
          
              if(DATAVALOPT.includes('***')){
                DATAVALSTAR = DATAVALOPT.split('__')[1];
                IMGVAL = DATAVALSTAR.split('***')[0];
              } else {
                IMGVAL = DATAVALOPT.split('__')[1];
              }
              baseUrl = "//tombalding.com/cdn/shop/files/";
              IMAGNAME = LABLEHANDLE + '-' + IMGVAL + '.png';
              IMGURL = baseUrl + IMAGNAME;         
              img.innerHTML = `
                  <div class="label_text">${DATAALT}</div>
                  <div class="label_image">
                    <img src="${IMGURL}" alt="${DATAALT}"/>
                  </div>
                `;
            });
          }
        }
      }); 
      
      const loadingScreenHTML = `
          <div id="custom-loading-screen" style="background: white; display: none; inset: 0; place-content: center; position: absolute; z-index: 2;">
              <div class="cube">
                <svg class="cube__face--top" viewBox="0 0 24 24">
                  <rect x="2" y="2" width="20" height="20" rx="2"></rect>
                </svg>
                <svg class="cube__face--front" viewBox="0 0 24 24">
                  <rect x="2" y="2" width="20" height="20" rx="2"></rect>
                </svg>
                <svg class="cube__face--left" viewBox="0 0 24 24">
                  <rect x="2" y="2" width="20" height="20" rx="2"></rect>
                </svg>
                <svg class="cube__face--right" viewBox="0 0 24 24">
                  <rect x="2" y="2" width="20" height="20" rx="2"></rect>
                </svg>
                <svg class="cube__face--back" viewBox="0 0 24 24">
                  <rect x="2" y="2" width="20" height="20" rx="2"></rect>
                </svg>
              </div>
              <span class="loading-text">Loading 3D...</span>
          </div>
      `;

      // Get the canvas element
      const canvas = document.getElementById('dopple-render-canvas');

      // Insert the loading screen after the canvas element
      canvas.insertAdjacentHTML('afterend', loadingScreenHTML);
      
      document.querySelector('body').classList.add('overlay_canvas_show');

        var LoadWindowURL = window.location.href; 
        document.querySelector('.product-personalizer').classList.add('disabled_btn');
        if(LoadWindowURL.includes('?loadproduct=')){
          if(document.querySelector('.loading_widget_load')){
            document.querySelector('body').classList.add('overlay_wrapp_show');
          }
        }
        //document.querySelector('body').classList.add('loading_widget_show');
        // renderCanvas = document.getElementById('dopple-render-canvas');
        // visual = window.Atlatl.Visual.getInstances()[0];

        // const prodTemplate = new Atlatl.Product(visual, namespace, name);
        // await productTemplate.load();

        
        // await prodTemplate.destroy();
        // namespace = 'tombalding-assets'
  
        if(LoadWindowURL.includes('?loadproduct=')){ 

          var parsedUrl = new URL(LoadWindowURL);
          var searchParams = parsedUrl.searchParams;
          var loadProduct = searchParams.get('loadproduct');

          await loadNewProduct(loadProduct, true, searchParams);
          
        }else{
          console.log('loadNewProduct(', name, ');')
          await loadNewProduct(name);
          
        }

      
        if(document.querySelector('.pplr-custom-inscription--5000')){
          document.querySelector('.pplr-custom-inscription--5000').querySelector('.pplr_text').addEventListener("keyup", (event) => {
            SetProperty();
          });
        }
        if(document.querySelector('.pplr-custom-mouth-width-5000')){
          document.querySelector('.pplr-custom-mouth-width-5000').querySelector('.pplr_text').addEventListener("keyup", (event) => {
            SetProperty();
          });
        }
        if(document.querySelector('.pplr-316-silver-letters-14-per-letter')){
        document.querySelector('.pplr-316-silver-letters-14-per-letter').querySelector('.pplr_text').addEventListener("keyup", (event) => {
          SetProperty();
        });
      }

    }
  }
})

if(document.querySelectorAll('#SaveBitBtn').length > 0){
  function closeSavePopup() {
    document.querySelector('body').classList.remove('overflowhidden');
    document.getElementById('saveBitPopup').classList.add('hidden');
  }
  document.getElementById('SaveBitBtn').onclick = function(){
    document.querySelector('body').classList.add('overflowhidden');
    document.getElementById('saveBitPopup').classList.remove('hidden');
    document.getElementById('bitHeading').value = "";
    document.getElementById('bitHeading').classList.remove('required-error');
    document.getElementById('bitSuccessMessage').classList.add('hidden');
    document.getElementById('saveBitPopup_content_inner').classList.remove('hidden');
    let bitShareURL = document.getElementById('shank-property').value;
    var decodedShareURL = decodeURIComponent(bitShareURL);
    var shareLinks = document.querySelectorAll('.bit_share_url_class');
    // if(bitShareURL.indexOf('%20') > -1){
    //   bitShareURL = bitShareURL.replace('%20','~');
    // }
    if(shareLinks.length > 0){
      shareLinks.forEach((shareLink) => {
        var prefixURL = shareLink.getAttribute("href");
        var finalShareURL = prefixURL + bitShareURL;
        shareLink.setAttribute("href", finalShareURL);
      });
    }
    document.getElementById('copyURLID').setAttribute("href", decodedShareURL);
  };
  document.querySelector('.saveBitPopup_overlay').onclick = function(){
    closeSavePopup()
  };
  document.getElementById('close_saveBitPopup').onclick = function(){
    closeSavePopup()
  };
  document.getElementById('saveBitTrigger').onclick = function(){
    let bitTitle = document.getElementById('bitHeading').value;
    let successMsgEle = document.getElementById('bitSuccessMessage');
    let bitModelContent = document.getElementById('saveBitPopup_content_inner');
    successMsgEle.classList.add('hidden');
    if(bitTitle.length > 0){

      var loaderEle = document.getElementById('savingBitLoader');
      loaderEle.classList.remove('hidden');
      let bitData = {};
      let customerID = Number(document.getElementById('saveBitTrigger').getAttribute("data-customerid"));
      let bitURL = document.getElementById('shank-property').value;
      let bitImageURL = document.getElementById('shank-prope-img').value;
      // let extraFields = {};
      var bitmouthpiece = '';
      if(document.querySelectorAll('.pplr-bit-mouthpiece .pplr_select').length > 0){
        bitmouthpiece = document.querySelector('.pplr-bit-mouthpiece .pplr_select').value;
        bitmouthpiece = bitmouthpiece.split('__')[0];
      }
      var MouthpieceValue = '';
      if(document.querySelectorAll('.pplr-mouthpiece:not(.pplr_no_preview) .pplr_select').length > 0){
        MouthpieceValue = document.querySelector('.pplr-mouthpiece:not(.pplr_no_preview) .pplr_select').value;
        MouthpieceValue = MouthpieceValue.split('__')[0];
      }
      var fancyShanks = '';
      if(document.querySelectorAll('.pplr-fancy-shanks:not(.pplr_no_preview) .pplr_select').length > 0){
        fancyShanks = document.querySelector('.pplr-fancy-shanks:not(.pplr_no_preview) .pplr_select').value;
        fancyShanks = fancyShanks.split('__')[0];
      }
      var plainShanks = '';
      if(document.querySelectorAll('.pplr-plain-shanks:not(.pplr_no_preview) .pplr_select').length > 0){
        plainShanks = document.querySelector('.pplr-plain-shanks:not(.pplr_no_preview) .pplr_select').value;
        plainShanks = plainShanks.split('__')[0];
      }
      var bitShankColor = '';
      if(document.querySelectorAll('.pplr-bit-shank-color:not(.pplr_no_preview) .pplr_select').length > 0){
        bitShankColor = document.querySelector('.pplr-bit-shank-color:not(.pplr_no_preview) .pplr_select').value;
        bitShankColor = bitShankColor.split('__')[0];
      }
      var bitOverlays = '';
      if(document.querySelectorAll('.pplr-bit-overlays:not(.pplr_no_preview) .pplr_select').length > 0){
        bitOverlays = document.querySelector('.pplr-bit-overlays:not(.pplr_no_preview) .pplr_select').value;
        bitOverlays = bitOverlays.split('__')[0];
      }
      var customInscription = '';
      if(document.querySelectorAll('.pplr-custom-inscription-50-00:not(.pplr_no_preview) .pplr_text').length > 0){
        customInscription = document.querySelector('.pplr-custom-inscription-50-00:not(.pplr_no_preview) .pplr_text').value;
      }
      var customMouthWidth = '';
      if(document.querySelectorAll('.pplr-custom-mouth-width-50-00:not(.pplr_no_preview) .pplr_text').length > 0){
        customMouthWidth = document.querySelector('.pplr-custom-mouth-width-50-00:not(.pplr_no_preview) .pplr_text').value;
      }
      var SilverLetters = '';
      if(document.querySelectorAll('.pplr-3-16-silver-letters-14-per-letter:not(.pplr_no_preview) .pplr_text').length > 0){
        SilverLetters = document.querySelector('.pplr-3-16-silver-letters-14-per-letter:not(.pplr_no_preview) .pplr_text').value;
      }
      var BrandUpload = '';
      if(document.querySelectorAll('.cp-sel-Photos:not(.pplr_no_preview) .fileupload').length > 0){
        BrandUploadImage = document.querySelector('.cp-sel-Photos:not(.pplr_no_preview) .pplrfileuploadbutton .img_url').getAttribute("data-psrc");
        if(BrandUploadImage.indexOf('blank.png') <= -1){
          BrandUpload = BrandUploadImage;
        }
      }
      // extraFields = Object.assign({}, extraFields, { bit_mouthpiece: bitmouthpiece,mouthpiece: MouthpieceValue,fancy_shanks: fancyShanks,plain_shanks: plainShanks,bit_shank_color: bitShankColor,bit_overlays: bitOverlays,custom_inscription: customInscription,custom_mouth_width: customMouthWidth,"3_1694_silver_letters": SilverLetters,brand_upload: BrandUpload });
      bitData = Object.assign({}, bitData, { customer_id: customerID,title: bitTitle,url: bitURL,bit_mouthpiece: bitmouthpiece,mouthpiece: MouthpieceValue,fancy_shanks: fancyShanks,plain_shanks: plainShanks,bit_shank_color: bitShankColor,bit_overlays: bitOverlays,custom_inscription: customInscription,custom_mouth_width: customMouthWidth,"silver_letters": SilverLetters,brand_upload: BrandUpload,image_url: bitImageURL });
      //console.log('bitData--',bitData);
      
      fetch('https://savesharebits.tombalding.com/tom-balding/create.php', {
        method: 'POST',
        body: JSON.stringify(bitData),
        cache: 'no-cache'
      }).then(response => response.json()).then(response => {
        if(response.error != true){
          //console.log('success');
          loaderEle.classList.add('hidden');
          bitModelContent.classList.add('hidden');
          successMsgEle.classList.remove('hidden');
        } else{
          //console.log('else success');
        }
      }).catch((error) => {
        console.error(error);
      });
    }else{
      document.getElementById('bitHeading').classList.add('required-error');
    }
  };
  document.getElementById('copyURLID').onclick = function(evt){
    evt.preventDefault();
    var copyLinkBtn = document.getElementById('copyURLID');
    var BtnoriginalText = copyLinkBtn.getAttribute('data-originalText');
    var BtncopyText = copyLinkBtn.getAttribute('data-copyText');
    navigator.clipboard.writeText(copyLinkBtn.getAttribute('href')).then(() => {
        copyLinkBtn.querySelector('.social-sharing__title').innerHTML = BtncopyText;
        setTimeout(function(){
            copyLinkBtn.querySelector('.social-sharing__title').innerHTML = BtnoriginalText;
        },5000);
    }, () => {
        //console.log('clipboard write failed');
    });
  };
}


/*
document.querySelectorAll('.pplr-drop-item').forEach((img) => {
  var IMGLABEL = img.getAttribute('data-value');
  if(IMGLABEL == "3 in 1__3-in-1"){
    img.innerHTML = '<div class="label_text">3 in 1</div><div class="label_image"><img src="https://configurators.tombalding.com/pub/media/catalog/product/3/i/3in1_mouthpiece.png" /></div>'
  }
})
*/